(() => {
const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
function enterHomepageReadingMode(reason) {
    window.__kmEnterHomepageReadingMode?.(reason);
    document.documentElement.dataset.kmMotion = 'reading';
    document.documentElement.classList.remove('km-home-intro-active');
    window.__kmSetHomepageIntroScrollLock?.(false);
    document.querySelectorAll('.km-homepage-section video').forEach(video => video.pause());
    document.querySelectorAll('.inside-cards-card').forEach(card => {
        card.removeAttribute('role');
        card.removeAttribute('tabindex');
    });
}
if (motionPreference.matches || document.documentElement.dataset.kmMotion === 'reading') {
    enterHomepageReadingMode(document.documentElement.dataset.kmMotionReason || 'reduced-motion');
    return;
}
if (!window.gsap || !window.ScrollTrigger || !window.DrawSVGPlugin || !window.SplitText || !window.ScrollToPlugin) {
    enterHomepageReadingMode('animation-dependency');
    return;
}
try {
// =================================================================
// 1. 变量定义与初始化
// =================================================================
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin, SplitText, ScrollToPlugin);

const homepageRoot = document.querySelector('.km-homepage-section');
const homepageDocumentRoot = document.documentElement;
const animationScope = homepageRoot || document.querySelector('#MainContent') || document.body;
const domScope = homepageRoot || document;
const circle1 = domScope.querySelector('#circle1');
const circle2 = domScope.querySelector('#circle2');
const circle3 = domScope.querySelector('#circle3');
const circle4 = domScope.querySelector('#circle4');
const maskCircle = domScope.querySelector('#mask-circle');
const featureCircle = domScope.querySelector('#feature-circle');
const aboutCircle = domScope.querySelector('#about-circle');
const insCircle = domScope.querySelector('#ins-circle');
const cards = animationScope.querySelectorAll(".inside-cards-card");
const cardList = Array.from(cards);
const cardWrappers = Array.from(cards, (card) => card.parentNode);
const featureSection = animationScope.querySelector('.feature-section');
const heroSection = animationScope.querySelector('.hero-section');
const heroVideo = animationScope.querySelector('.hero-section video');
const attProductImages = Array.from(animationScope.querySelectorAll('.att-products-wrapper img'));
const knobVideo = animationScope.querySelector('.knob-section video');
const attachmentVideos = Array.from(animationScope.querySelectorAll('.att-center-panel video'));
const leftItems = animationScope.querySelectorAll('.att-left-item');
const leftItemList = Array.from(leftItems);
const footerColumns = animationScope.querySelectorAll('.footer-column');
const footerColumnTitles = animationScope.querySelectorAll('.footer-column-title');
const footerSection = animationScope.querySelector('.footer-section-homepage');
const footerSubscribeForm = animationScope.querySelector('.footer-subscribe-form');
const footerBackground = animationScope.querySelector('.footer-background');
const footerBottom = animationScope.querySelector('.footer-bottom');
const heroCtas = Array.from(animationScope.querySelectorAll('.hero-button, .scroll-downs'));
const featureContent = animationScope.querySelector('.feature-content');
const featureTitleWrapper = animationScope.querySelector('.feature-title-wrapper');
const featureSpacer = animationScope.querySelector('.feature-spacer');
const featureAnimationWrapper = animationScope.querySelector('.feature-animation-wrapper');
const circleSection = animationScope.querySelector('.circle-section');
const outContent = animationScope.querySelector('.out-content');
const outButton = animationScope.querySelector('.out-button');
const insideCardsTrack = animationScope.querySelector('.inside-cards');
const insideCardsViewport = animationScope.querySelector('.inside-cards-viewport');
const insideContent = animationScope.querySelector('.inside-content');
const insideCopyStage = animationScope.querySelector('.inside-copy-stage');
const insideCardsStage = animationScope.querySelector('.inside-cards-stage');
const insideTitle = animationScope.querySelector('.inside-title');
const insideTextWrapper = insideCopyStage?.querySelector('.text-warpper');
const insideButton = animationScope.querySelector('.inside-button');
const insideOutImageWrap = animationScope.querySelector('.insideOut-img');
const insideOutImage1 = animationScope.querySelector('.insideOut-img1');
const insideOutImage2 = animationScope.querySelector('.insideOut-img2');
const insideOutImage3 = animationScope.querySelector('.insideOut-img3');
const insideOutImage4 = animationScope.querySelector('.insideOut-img4');
const knobImg = animationScope.querySelector('img.knob-img');
const knobSection = animationScope.querySelector('.knob-section');
const knobContent = animationScope.querySelector('.knob-content');
const knobButton = animationScope.querySelector('.knob-button');
const knobVideoWrapper = animationScope.querySelector('.knob-video-wrapper');
const quietSection = animationScope.querySelector('.quiet-section');
const quietContent = animationScope.querySelector('.quiet-content');
const quietAudioPanel = animationScope.querySelector('.quiet-audio-wrapper');
const quietButton = animationScope.querySelector('.quiet-button');
const attSection = animationScope.querySelector('.att-section');
const attContentTop = animationScope.querySelector('.att-content-top');
const attButton = animationScope.querySelector('.att-button');
const attProductsWrapper = animationScope.querySelector('.att-products-wrapper');
const attLeftPanel = animationScope.querySelector('.att-left-panel');
const attCenterPanel = animationScope.querySelector('.att-center-panel');
const attContentBottom = animationScope.querySelector('.att-content-bottom');
const attRightPanel = animationScope.querySelector('.att-right-panel');
const attachmentRightImages = Array.from(animationScope.querySelectorAll('.att-right-panel img'));
const aboutSection = animationScope.querySelector('.about-section');
const aboutBackground = animationScope.querySelector('.about-background');
const aboutDesignWrapper = animationScope.querySelector('.about-design-wrapper');
const aboutSustainabilityWrapper = animationScope.querySelector('.about-sustainability-wrapper');
const aboutDesignButton = animationScope.querySelector('.about-design-button');
const aboutSustainabilityButton = animationScope.querySelector('.about-sustainability-button');
const aboutSustainabilityTitle = animationScope.querySelector('.about-sustainability-title');
const aboutSustainabilityText = animationScope.querySelector('.about-sustainability-text');
const aboutImgSlider = animationScope.querySelector('.about-img-slider');
const aboutImg1 = animationScope.querySelector('.about-img1');
const aboutImg2 = animationScope.querySelector('.about-img2');
const aboutImg3 = animationScope.querySelector('.about-img3');
const aboutImg4 = animationScope.querySelector('.about-img4');
const aboutIntroImages = [aboutImg1, aboutImg2, aboutImg3];
const insSection = animationScope.querySelector('.ins-section');
const insBackground = animationScope.querySelector('.ins-background');
const insTitleWrapper = animationScope.querySelector('.ins-title-wrapper');
const insGallery = animationScope.querySelector('.ins-gallery');
const instagramGalleryImages = Array.from(animationScope.querySelectorAll('.ins-gallery img'));
const insAniTops = Array.from(animationScope.querySelectorAll('.ins-ani-top'));
const insAniBottoms = Array.from(animationScope.querySelectorAll('.ins-ani-bottom'));
const insOverlays = Array.from(animationScope.querySelectorAll('.ins-overlay'));

const mobileViewportQuery = window.matchMedia("(max-aspect-ratio: 1)");
const tallViewportQuery = window.matchMedia("(min-aspect-ratio: 2/3) and (max-aspect-ratio: 1)");
let isMobile = false;
let isTall = false;
let audioInitialized = false;
let accessoriesImagesInitialized = false;
const svgMarkupCache = new Map();
let svg1Shapes = [];
let svg2Shapes = [];
let audioCleanup = () => {};
let accessoriesCleanup = () => {};
let domReadyCleanup = () => {};
let featureExperienceObserverCleanup = () => {};
let heroIntroTimeline = null;
let featureIntroTimeline = null;
let featureSpacerTimeline = null;
let viewportModeChangeCleanup = () => {};
let mainTimelineExperienceCleanup = () => {};
let mainTimelineMediaContext = null;
let mainTimelineRestoreState = null;
let mainTimelineStableState = null;
let mainTimelineRestoring = false;
function captureMainTimelinePosition() {
    if (homepageDocumentRoot.dataset.kmMotion === 'reading') return;
    if (mainTimelineStableState?.inside) mainTimelineRestoreState = mainTimelineStableState;
}
// GSAP emits this before reverting responsive contexts.
gsap.addEventListener('matchMediaInit', captureMainTimelinePosition);

let instagramAssetsWarmed = false;
const mediaPlaybackStates = new Map();
let homepageRuntimeDestroyed = false;
const HOMEPAGE_HEADER_INTRO_CLASS = 'km-home-intro-active';
const HOMEPAGE_HEADER_AT_TOP_CLASS = 'km-home-header-at-top';
const HOMEPAGE_HEADER_TOP_THRESHOLD = 8;
const HOMEPAGE_INTRO_COMPLETE_EVENT = 'km:home-intro-complete';
const homepageHeaderSection = document.querySelector('.section-header');
let homepageHeaderTopStateCleanup = () => {};

function setHomepageIntroScrollLock(isLocked) {
    if (typeof window.__kmSetHomepageIntroScrollLock === 'function') {
        window.__kmSetHomepageIntroScrollLock(isLocked);
        return;
    }

    const overscrollBehaviorValue = isLocked ? 'none' : '';

    homepageDocumentRoot.style.overscrollBehavior = overscrollBehaviorValue;
    document.body.style.overscrollBehavior = overscrollBehaviorValue;
}

function markHomepageIntroAsManaged() {
    homepageDocumentRoot.dataset.kmHeroIntroManaged = 'true';
}

function revealHomepageHeader() {
    homepageDocumentRoot.classList.remove(HOMEPAGE_HEADER_INTRO_CLASS);
    homepageDocumentRoot.removeAttribute('data-km-hero-intro-managed');
    setHomepageIntroScrollLock(false);
    window.dispatchEvent(new CustomEvent(HOMEPAGE_INTRO_COMPLETE_EVENT));
}

function syncHomepageHeaderIntroState() {
    try {
        if (sessionStorage.getItem('heroAnimationRun')) {
            revealHomepageHeader();
            return;
        }
    } catch (error) {
        // Fall through and keep the intro-managed state.
    }

    markHomepageIntroAsManaged();
    setHomepageIntroScrollLock(true);
}

syncHomepageHeaderIntroState();

function applyPreTimelineGuardStates() {
    const instagramDeferredLayers = [insTitleWrapper, insGallery].filter(Boolean);
    if (instagramDeferredLayers.length) {
        gsap.set(instagramDeferredLayers, { autoAlpha: 0 });
    }
    if (insOverlays.length) {
        gsap.set(insOverlays, { display: "none" });
    }
}

applyPreTimelineGuardStates();

function loadHomepageImages(container) {
    if (!container) return;
    if (window.__kmLoadHomepageImages) {
        window.__kmLoadHomepageImages(container);
        return;
    }
    container.querySelectorAll('source[data-km-srcset]').forEach(source => {
        if (source.srcset !== source.dataset.kmSrcset) source.srcset = source.dataset.kmSrcset;
    });
    container.querySelectorAll('img[data-km-src]').forEach(img => {
        if (img.getAttribute('src') !== img.dataset.kmSrc) img.src = img.dataset.kmSrc;
    });
}

function warmInstagramGalleryAssets() {
    if (instagramAssetsWarmed || !instagramGalleryImages.length) return;
    instagramAssetsWarmed = true;
    loadHomepageImages(insSection);
}

const HOMEPAGE_INTERACTION_PROTOCOL = Object.freeze({
    restore: Object.freeze({
        scrollThreshold: 8,
        settleMaxFrames: 10,
        settleStableFrames: 2,
        settleDelta: 1,
    }),
    observe: Object.freeze({
        defaultRootMargin: '200px 0px',
        deferredSectionRootMargin: '25% 0px',
        featureExperienceRootMargin: '20% 0px',
        footerRootMargin: '40% 0px',
    }),
    scroll: Object.freeze({
        normalizeOnNotDesktop: true,
        scrub: Object.freeze({
            featureIntro: 1,
            featureSpacer: 0,
            footer: 1,
            mainDesktop: 1,
            mainNotDesktop: 0.5,
        }),
        navigation: Object.freeze({
            ease: "power2.inOut",
            durationDesktop: 0.5,
            durationNotDesktop: 0.5,
            autoKill: false,
        }),
    }),
    chapter: Object.freeze({
        holdRatio: 0.3,
        blendWindow: 0.05,
    }),
    instagram: Object.freeze({
        hoverReadyOffset: 2.7,
        hoverEnterThreshold: 0.9,
        hoverExitThreshold: 0.84,
        hiddenDisplay: "none",
        readyDisplay: "flex",
    }),
});

function syncHomepageHeaderTopState() {
    if (!homepageHeaderSection) return;

    const scrollTop = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
    const isAtTop = scrollTop <= HOMEPAGE_HEADER_TOP_THRESHOLD;

    homepageDocumentRoot.classList.toggle(HOMEPAGE_HEADER_AT_TOP_CLASS, isAtTop);

    if (isAtTop) {
        homepageHeaderSection.classList.remove('scrolled-past-header');
    }
}

function initHomepageHeaderTopStateGuard() {
    if (!homepageRoot || !homepageHeaderSection) return () => {};

    const sync = () => syncHomepageHeaderTopState();

    sync();
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    window.addEventListener('pageshow', sync);

    return () => {
        window.removeEventListener('scroll', sync);
        window.removeEventListener('resize', sync);
        window.removeEventListener('pageshow', sync);
        homepageDocumentRoot.classList.remove(HOMEPAGE_HEADER_AT_TOP_CLASS);
    };
}

homepageHeaderTopStateCleanup = initHomepageHeaderTopStateGuard();

window.addEventListener('pageshow', ensureHeroVideoPlayback);
function getDefaultHomepageInputMode() {
    if (window.matchMedia('(pointer: coarse)').matches) return 'touch';
    try {
        const savedMode = sessionStorage.getItem('kmHomepageInputMode');
        if (savedMode === 'trackpad' || savedMode === 'wheel') return savedMode;
    } catch (error) { /* Use device defaults when storage is unavailable. */ }
    const platform = navigator.userAgentData?.platform || navigator.platform || '';
    return /Mac/i.test(platform) ? 'trackpad' : 'wheel';
}

let homepageInputMode = window.__kmHomepageInputMode || getDefaultHomepageInputMode();
let homepagePendingInputMode = null;
let homepagePendingInputModeCount = 0;
let homepageInputModeLocked = window.__kmHomepageInputModeLocked || false;
let homepageInputModeLastChangedAt = 0;
let homepageLastWheelInputAt = 0;

function setHomepageInputMode(nextMode) {
    if (!nextMode || nextMode === homepageInputMode) return;
    const previousInputMode = homepageInputMode;
    homepageInputMode = nextMode;
    try { sessionStorage.setItem('kmHomepageInputMode', nextMode); } catch (error) { /* Optional persistence. */ }
    window.__kmHomepageInputMode = homepageInputMode;
    window.__kmHomepageInputModeLocked = homepageInputModeLocked;
    homepageInputModeLastChangedAt = Date.now();
    window.dispatchEvent(new CustomEvent('km:input-mode-change', {
        detail: {
            previousInputMode,
            nextInputMode: homepageInputMode,
        }
    }));
}

function classifyHomepageWheelInput(event) {
    if (window.matchMedia('(pointer: coarse)').matches) return 'touch';
    if (event.deltaMode === 1) return 'wheel';

    const absX = Math.abs(event.deltaX);
    const absY = Math.abs(event.deltaY);
    const dominantDelta = Math.max(absX, absY);
    const hasFractionalDelta = Math.abs(dominantDelta - Math.round(dominantDelta)) > 0.01;
    const hasMultiAxisMotion = absX > 0 && absY > 0;
    const isTrackpadLike = event.deltaMode === 0 && (hasFractionalDelta || dominantDelta < 18 || hasMultiAxisMotion);

    return isTrackpadLike ? 'trackpad' : 'wheel';
}

function commitHomepageInputMode(nextMode) {
    if (homepageInputModeLocked && nextMode !== homepageInputMode) return;
    if (nextMode === 'trackpad') {
        homepageInputModeLocked = true;
        window.__kmHomepageInputModeLocked = true;
    }
    setHomepageInputMode(nextMode);
}

function handleHomepageWheelInput(event) {
    homepageLastWheelInputAt = Date.now();
    const detectedMode = classifyHomepageWheelInput(event);
    if (!detectedMode || detectedMode === homepageInputMode) {
        homepagePendingInputMode = null;
        homepagePendingInputModeCount = 0;
        return;
    }

    if (homepageInputModeLocked && homepageInputMode === 'trackpad' && detectedMode === 'wheel') {
        return;
    }

    if (detectedMode !== homepagePendingInputMode) {
        homepagePendingInputMode = detectedMode;
        homepagePendingInputModeCount = 1;
        return;
    }

    homepagePendingInputModeCount += 1;

    const now = Date.now();
    const requiredConsistentEvents = detectedMode === 'trackpad' ? 2 : 8;
    const requiredCooldown = detectedMode === 'trackpad' ? 120 : 1200;
    if (homepagePendingInputModeCount < requiredConsistentEvents) return;
    if (now - homepageInputModeLastChangedAt < requiredCooldown) return;

    homepagePendingInputMode = null;
    homepagePendingInputModeCount = 0;
    commitHomepageInputMode(detectedMode);
}

if (window.__kmHomepageWheelInputHandler) {
    window.removeEventListener('wheel', window.__kmHomepageWheelInputHandler);
}
window.__kmHomepageWheelInputHandler = handleHomepageWheelInput;
window.addEventListener('wheel', handleHomepageWheelInput, { passive: true });

ScrollTrigger.defaults({ pinSpacing: false });

function refreshViewportFlags() {
    isMobile = mobileViewportQuery.matches;
    isTall = tallViewportQuery.matches;
    return { isMobile, isTall };
}

function getViewportModeKey() {
    return `${Number(isMobile)}:${Number(isTall)}`;
}

function updateViewportDimensions() {
    const w = document.documentElement.clientWidth;
    const h = document.documentElement.clientHeight;
    const dw = isTall ? document.documentElement.clientHeight * (2 / 3) : document.documentElement.clientWidth;
    const clipPathRadius = (3 / 5) * Math.sqrt((w ** 2 + h ** 2) / 2);
    const radius = h / w;
    const circleY = (8 * radius - 1.2501) / (16 * radius);
    const circleYPos = circleY * 100 + "%";
    return { w, h, dw, clipPathRadius, radius, circleY, circleYPos };
}

function updateCardHeights() {
    const getCardHeight = (card) => {
        if (!card) return 150;
        const rectHeight = card.getBoundingClientRect().height || 0;
        const scrollHeight = card.scrollHeight || 0;
        return Math.ceil(Math.max(rectHeight, scrollHeight, 150));
    };

    const heights = {
        cardHeight1: getCardHeight(cards[0]),
        cardHeight2: getCardHeight(cards[1]),
        cardHeight3: getCardHeight(cards[2]),
    };

    if (insideCardsViewport) {
        insideCardsViewport.style.setProperty(
            '--km-inside-cards-viewport-height',
            `${Math.max(heights.cardHeight1, heights.cardHeight2, heights.cardHeight3)}px`
        );
    }

    return heights;
}

refreshViewportFlags();
let { w, h, dw, clipPathRadius, radius, circleY, circleYPos } = updateViewportDimensions();
let { cardHeight1, cardHeight2, cardHeight3 } = updateCardHeights();
let scrollRefreshFrame;
let resizeFrame;
let lastViewportModeKey = getViewportModeKey();

function refreshLayoutMetrics() {
    refreshViewportFlags();
    ({ w, h, dw, clipPathRadius, radius, circleY, circleYPos } = updateViewportDimensions());
    ({ cardHeight1, cardHeight2, cardHeight3 } = updateCardHeights());
}

function requestScrollRefresh() {
    if (scrollRefreshFrame) return;

    scrollRefreshFrame = requestAnimationFrame(() => {
        scrollRefreshFrame = null;
        ScrollTrigger.refresh();
    });
}

function setHeroSectionInteractivity(isInteractive) {
    if (!heroSection) return;
    heroSection.style.pointerEvents = isInteractive ? 'auto' : 'none';
}

function safePlayMedia(media) {
    if (!media) return;
    let state = mediaPlaybackStates.get(media);
    if (!state) {
        state = { desired: false, pending: null, blocked: false };
        mediaPlaybackStates.set(media, state);
        media.addEventListener('canplay', () => {
            state.blocked = false;
            if (state.desired) safePlayMedia(media);
        });
        media.addEventListener('error', () => {
            state.blocked = true;
            media.dataset.mediaState = 'failed';
        });
        media.addEventListener('waiting', () => {
            media.dataset.mediaState = 'waiting';
        });
        media.addEventListener('playing', () => {
            media.dataset.mediaState = 'playing';
        });
    }
    state.desired = true;
    if (document.hidden || state.pending || state.blocked || !media.paused) return;
    loadDeferredMediaElement(media);
    media.dataset.mediaState = media.readyState < 2 ? 'waiting' : 'ready';
    const attempt = media.play?.();
    if (!attempt?.then) return;
    state.pending = attempt;
    attempt.then(() => {
        if (!state.desired || document.hidden) media.pause();
    }).catch((error) => {
        if (error.name !== 'AbortError') {
            state.blocked = true;
            media.dataset.mediaState = 'failed';
        }
    }).finally(() => {
        state.pending = null;
        if (state.desired && !state.blocked && !document.hidden && media.paused) safePlayMedia(media);
    });
}

function ensureHeroVideoPlayback() {
    if (!heroVideo) return;

    heroVideo.muted = true;
    heroVideo.defaultMuted = true;
    heroVideo.setAttribute('muted', '');
    heroVideo.setAttribute('playsinline', '');
    heroVideo.setAttribute('webkit-playsinline', '');
    heroVideo.preload = 'auto';
    heroVideo.setAttribute('preload', 'auto');
    loadDeferredMediaElement(heroVideo);


    const playHeroVideo = () => {
        if (homepageRuntimeDestroyed || !heroVideo || document.hidden) return;
        if ((window.scrollY || window.pageYOffset || 0) > window.innerHeight * 0.85) return;
        safePlayMedia(heroVideo);
    };

    playHeroVideo();
    requestAnimationFrame(playHeroVideo);
    window.setTimeout(playHeroVideo, 300);
}

ensureHeroVideoPlayback();

function pauseMedia(media) {
    if (!media) return;
    const state = mediaPlaybackStates.get(media);
    if (state) state.desired = false;
    if (!media.paused || state?.pending) media.pause?.();
}

function handleHomepageMediaVisibility() {
    mediaPlaybackStates.forEach((state, media) => {
        if (document.hidden) {
            if (!media.paused) media.pause();
        } else if (state.desired) {
            safePlayMedia(media);
        }
    });
}
document.addEventListener('visibilitychange', handleHomepageMediaVisibility);

function loadDeferredMediaElement(media) {
    if (!media || media.dataset.mediaLoaded === 'true') return media;
    if (media.dataset.poster) media.poster = media.dataset.poster;

    if (media.dataset.src && !media.getAttribute('src')) {
        media.setAttribute('src', media.dataset.src);
    }

    const deferredSources = Array.from(media.querySelectorAll('source[data-src]'));
    deferredSources.forEach((source) => {
        if (!source.getAttribute('src')) {
            source.setAttribute('src', source.dataset.src);
        }
    });

    if (media.dataset.src || deferredSources.length) {
        media.load?.();
    }

    media.dataset.mediaLoaded = 'true';
    return media;
}

function loadDeferredMediaList(mediaList) {
    mediaList.forEach((media) => loadDeferredMediaElement(media));
}

function pauseAllAttachmentVideos() {
    attachmentVideos.forEach((video) => {
        pauseMedia(video);
    });
}

function setAttachmentVideosPlayback(activeIndices = []) {
    const activeSet = new Set(
        activeIndices.filter((index) =>
            Number.isInteger(index) && index >= 1 && index <= attachmentVideos.length
        )
    );

    attachmentVideos.forEach((video, videoIndex) => {
        if (activeSet.has(videoIndex + 1)) {
            safePlayMedia(video);
        } else {
            pauseMedia(video);
        }
    });
}

function playAttachmentVideo(index) {
    setAttachmentVideosPlayback([index]);
}

function handleHomepageResize() {
    cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(() => {
        const previousViewportModeKey = lastViewportModeKey;
        refreshLayoutMetrics();
        lastViewportModeKey = getViewportModeKey();

        if (lastViewportModeKey !== previousViewportModeKey) {
            window.dispatchEvent(new CustomEvent('km:viewport-mode-change', {
                detail: {
                    previousViewportModeKey,
                    nextViewportModeKey: lastViewportModeKey,
                }
            }));
        }
    });
}
window.addEventListener('resize', handleHomepageResize);

function observeSectionOnce(targetOrSelector, initFn, rootMargin = HOMEPAGE_INTERACTION_PROTOCOL.observe.defaultRootMargin) {
    const target = typeof targetOrSelector === 'string'
        ? (animationScope.querySelector(targetOrSelector) || document.querySelector(targetOrSelector))
        : targetOrSelector;
    if (!target) return () => {};

    if (typeof IntersectionObserver === 'undefined') {
        initFn();
        return () => {};
    }

    const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        initFn();
    }, { rootMargin });

    observer.observe(target);
    return () => observer.disconnect();
}

function loadSvgMarkup(url) {
    if (!url) return Promise.resolve('');
    if (!svgMarkupCache.has(url)) {
        const vectorName = url === window.assets?.svg1 ? 'svg1' : url === window.assets?.svg2 ? 'svg2' : null;
        const inlineVector = vectorName && domScope.querySelector(`template[data-km-vector="${vectorName}"]`);
        if (inlineVector?.content.querySelector('svg')) {
            svgMarkupCache.set(url, Promise.resolve(inlineVector.innerHTML));
            return svgMarkupCache.get(url);
        }
        svgMarkupCache.set(
            url,
            fetch(url, { signal: AbortSignal.timeout(6000) })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`Failed to load SVG: ${response.status} ${response.statusText}`);
                    }
                    return response.text();
                })
                .catch((error) => {
                    console.error(`SVG load failed for ${url}`, error);
                    svgMarkupCache.delete(url);
                    return '';
                })
        );
    }
    return svgMarkupCache.get(url);
}

function scheduleIdleTask(callback, timeout = 1200) {
    const runIfMounted = () => { if (!homepageRuntimeDestroyed) callback(); };
    if (typeof window.requestIdleCallback === 'function') {
        return window.requestIdleCallback(runIfMounted, { timeout });
    }

    return window.setTimeout(runIfMounted, 1);
}

function getHomepageInteractionProfile({ isNotDesktop = isMobile, isMobileViewport = isMobile } = {}) {
    const { restore, observe, scroll, chapter, instagram } = HOMEPAGE_INTERACTION_PROTOCOL;
    const inputMode = homepageInputMode;
    const isTrackpadMode = inputMode === 'trackpad';
    const isTouchMode = inputMode === 'touch';

    const mainScrub = isTrackpadMode
        ? (isNotDesktop ? 0.42 : 0.72)
        : isTouchMode
            ? (isNotDesktop ? 0.36 : 0.6)
            : (isNotDesktop ? scroll.scrub.mainNotDesktop : scroll.scrub.mainDesktop);

    const featureIntroScrub = isTrackpadMode
        ? scroll.scrub.featureIntro * 0.85
        : scroll.scrub.featureIntro;
    const footerScrub = isTrackpadMode
        ? scroll.scrub.footer * 0.85
        : scroll.scrub.footer;

    const holdRatio = isTrackpadMode
        ? 0.18
        : isTouchMode
            ? 0.22
            : chapter.holdRatio;
    const blendWindow = isTrackpadMode
        ? 0.12
        : isTouchMode
            ? 0.09
            : chapter.blendWindow;

    return {
        restore,
        observe,
        inputMode,
        scroll: {
            normalizeOnNotDesktop: scroll.normalizeOnNotDesktop,
            scrub: {
                featureIntro: featureIntroScrub,
                featureSpacer: scroll.scrub.featureSpacer,
                footer: footerScrub,
                main: mainScrub,
            },
            navigation: {
                ease: scroll.navigation.ease,
                duration: isTrackpadMode
                    ? 0.42
                    : (isNotDesktop ? scroll.navigation.durationNotDesktop : scroll.navigation.durationDesktop),
                autoKill: scroll.navigation.autoKill,
            },
        },
        chapter: {
            holdRatio,
            blendWindow,
        },
        instagram: {
            hoverReadyOffset: instagram.hoverReadyOffset,
            hoverEnterThreshold: instagram.hoverEnterThreshold,
            hoverExitThreshold: instagram.hoverExitThreshold,
            hiddenDisplay: instagram.hiddenDisplay,
            readyDisplay: instagram.readyDisplay,
        },
        insideFlow: {
            labelGap: isTrackpadMode
                ? (isNotDesktop ? 1.38 : 1.42)
                : isTouchMode
                    ? (isNotDesktop ? 1.3 : 1.35)
                    : 1.72,
            cardsStep: isTrackpadMode ? 1.32 : 1.18,
            cardFade: isTrackpadMode ? 1.18 : 1.08,
            imageSwap: isTrackpadMode ? 1.24 : 1.14,
            clickSettleRatio: isTrackpadMode ? 0.34 : 0.3,
            finalClickSettleRatio: isTrackpadMode ? 0.24 : 0.2,
            driftScale: isTrackpadMode ? 1.045 : 1.03,
            driftDistance: isTrackpadMode
                ? (isNotDesktop ? 18 : 24)
                : (isNotDesktop ? 12 : 16),
            transitionLead: isTrackpadMode
                ? (isNotDesktop ? 0.28 : 0.42)
                : (isNotDesktop ? 0.22 : 0.34),
            introOverlap: isTrackpadMode
                ? (isNotDesktop ? 0.35 : 0.6)
                : (isNotDesktop ? 0.28 : 0.48),
            finalHold: isTrackpadMode
                ? (isNotDesktop ? 0.34 : 0.56)
                : (isNotDesktop ? 0.4 : 0.7),
            finalHoldGap: isTrackpadMode
                ? (isNotDesktop ? 0.3 : 0.52)
                : (isNotDesktop ? 0.36 : 0.64),
            softLiftScale: isTrackpadMode ? 1.4 : 1.2,
        },
        aboutGallery: {
            travelDuration: isTrackpadMode ? 6.6 : 8,
            scaleStartProgress: isNotDesktop
                ? (isTrackpadMode ? 0.76 : 0.78)
                : (isTrackpadMode ? 0.68 : 0.75),
            introImagesStartProgress: isNotDesktop
                ? (isTrackpadMode ? 0.76 : 0.78)
                : (isTrackpadMode ? 0.62 : 0.72),
        },
        attachmentsFlow: (() => {
            const entryDuration = isTrackpadMode ? 1.15 : 1.35;
            const holdDuration = isTrackpadMode ? 0.04 : 0.06;
            const exitDuration = isTrackpadMode ? 1.05 : 1.18;
            const animationWindow = entryDuration + holdDuration + exitDuration;
            const gapBuffer = isTrackpadMode ? 0.12 : 0.16;

            return {
                labelGap: animationWindow + gapBuffer,
                entryLead: isTrackpadMode ? 0.7 : 0.9,
                finalHoldGap: animationWindow + (isTrackpadMode ? 0.45 : 0.6),
                entryDuration,
                holdDuration,
                exitDuration,
                clickFocusOffset: entryDuration + holdDuration,
            };
        })(),
        viewport: {
            isNotDesktop,
            isMobileViewport,
        },
    };
}

function addTimelineLabels(timeline, labels) {
    Object.entries(labels).forEach(([label, position]) => {
        timeline.addLabel(label, position);
    });
    return labels;
}

// =================================================================
// 2. 辅助功能函数
// =================================================================

// 音频初始化
function initAudio() {
    if (audioInitialized) return;
    audioInitialized = true;

    const playPauseButton = document.getElementById('playPauseButton');
    const playPauseIcon = document.getElementById('playPauseIcon');
    const waveformBase1 = document.getElementById('waveformBase1');
    const waveformPlayed1 = document.getElementById('waveformPlayed1');
    const waveformBase2 = document.getElementById('waveformBase2');
    const waveformPlayed2 = document.getElementById('waveformPlayed2');
    const mask1 = document.getElementById('mask1');
    const mask2 = document.getElementById('mask2');
    const audioPlayer1 = document.getElementById('audioPlayer1');
    const audioPlayer2 = document.getElementById('audioPlayer2');
    const audioToggle = document.getElementById('audioToggle');
    const othersLabel = document.getElementById('othersLabel');
    const km50Label = document.getElementById('km50Label');
    const quietAudioWrapper = quietAudioPanel;
    const waveformContainer = document.getElementById('waveformContainer');

    let isPlaying = false;
    let audioRequest = 0;
    let animationFrameId;
    let quietVisibilityCheckFrame = null;

    if (typeof window.assets === 'undefined') {
        console.error('Audio assets not loaded. Check Liquid injection.');
        audioInitialized = false;
        return;
    }

    if (!waveformContainer) {
        audioInitialized = false;
        return;
    }

    if (!playPauseButton || !playPauseIcon || !audioPlayer1 || !audioPlayer2 || !audioToggle) {
        audioInitialized = false;
        return;
    }

    const waveMaxWidth = waveformContainer.offsetWidth;

    loadDeferredMediaElement(audioPlayer1);
    loadDeferredMediaElement(audioPlayer2);
    audioPlayer2.volume = 0.5;

    function getCurrentAudioSourceLabel() {
        return audioToggle.checked
            ? (km50Label?.textContent?.trim() || 'KM50')
            : (othersLabel?.textContent?.trim() || 'Others');
    }

    function syncPlayPauseButtonState() {
        if (!playPauseButton) return;
        playPauseButton.setAttribute('aria-pressed', String(isPlaying));
        playPauseButton.setAttribute(
            'aria-label',
            `${isPlaying ? 'Pause' : 'Play'} ${getCurrentAudioSourceLabel()} audio sample`
        );
    }

    function pauseAudio() {
        audioRequest += 1;
        audioPlayer1.pause();
        audioPlayer2.pause();
        isPlaying = false;
        playPauseIcon.src = window.assets.playIcon;
        cancelAnimationFrame(animationFrameId);
        gsap.set([mask1, mask2], { width: 0 });
        syncPlayPauseButtonState();
    }

    function updateWaveform() {
        if (!isPlaying) {
            cancelAnimationFrame(animationFrameId);
            return;
        }

        const currentAudio = audioToggle.checked ? audioPlayer2 : audioPlayer1;
        const currentMask = audioToggle.checked ? mask2 : mask1;
        const secondaryMask = audioToggle.checked ? mask1 : mask2;

        const duration = isNaN(currentAudio.duration) || currentAudio.duration === 0 ? 1 : currentAudio.duration;
        const progress = currentAudio.currentTime / duration;
        const maskWidth = progress * waveMaxWidth;

        gsap.set(currentMask, { width: maskWidth });

        if (audioToggle.checked) {
            gsap.set(mask1, { width: maskWidth });
            gsap.set(waveformBase1, { opacity: 0.35 });
            gsap.set(waveformPlayed1, { opacity: 0.35 });
        } else {
            gsap.set(waveformBase1, { opacity: 1 });
            gsap.set(waveformPlayed1, { opacity: 1 });
            gsap.set(mask2, { opacity: 1 });
        }

        animationFrameId = requestAnimationFrame(updateWaveform);
    }

    const handlePlayPauseClick = () => {
        const targetAudio = audioToggle.checked ? audioPlayer2 : audioPlayer1;

        if (isPlaying) {
            targetAudio.pause();
            playPauseIcon.src = window.assets.playIcon;
            isPlaying = false;
            cancelAnimationFrame(animationFrameId);
            syncPlayPauseButtonState();
        } else {
            const request = ++audioRequest;
            targetAudio.play().then(() => {
                if (!isPlaying || document.hidden || targetAudio !== (audioToggle.checked ? audioPlayer2 : audioPlayer1)) targetAudio.pause();
            }).catch(error => {
                if (request !== audioRequest) return;
                pauseAudio();
                playPauseButton.setAttribute('aria-label', 'Audio unavailable. Try again');
            });
            playPauseIcon.src = window.assets.pauseIcon;
            isPlaying = true;
            syncPlayPauseButtonState();
            updateWaveform();
        }
    };

    const handleAudioToggleChange = () => {
        pauseAudio(); 

        if (audioToggle.checked) {
            gsap.set(waveformBase1, { display: 'block', opacity: 0.35 });
            gsap.set(mask1, { display: 'block', opacity: 0.35 });
            gsap.set(waveformBase2, { display: 'block', opacity: 1 });
            gsap.set(mask2, { display: 'block', opacity: 1 });
            othersLabel.classList.remove('active');
            km50Label.classList.add('active');
        } else {
            gsap.set(waveformBase1, { display: 'block', opacity: 1 });
            gsap.set(mask1, { display: 'block', opacity: 1 });
            gsap.set(waveformBase2, { display: 'none', opacity: 1 });
            gsap.set(mask2, { display: 'none', opacity: 1 });
            km50Label.classList.remove('active');
            othersLabel.classList.add('active');
        }

        syncPlayPauseButtonState();
    };

    syncPlayPauseButtonState();
    playPauseButton.addEventListener('click', handlePlayPauseClick);
    audioToggle.addEventListener('change', handleAudioToggleChange);

    let observer = null;
    if (quietAudioWrapper) {
        observer = new MutationObserver((mutations) => {
            if (!isPlaying || quietVisibilityCheckFrame) return;
            if (!mutations.some((mutation) => mutation.type === 'attributes' && mutation.attributeName === 'style')) return;

            quietVisibilityCheckFrame = requestAnimationFrame(() => {
                quietVisibilityCheckFrame = null;
                const computedStyle = window.getComputedStyle(quietAudioWrapper);
                if (computedStyle.opacity === '0') {
                    pauseAudio();
                }
            });
        });

        observer.observe(quietAudioWrapper, {
            attributes: true,
            attributeFilter: ['style']
        });
    }

    const handleAudioVisibility = () => { if (document.hidden) pauseAudio(); };
    document.addEventListener('visibilitychange', handleAudioVisibility);
    audioCleanup = () => {
        document.removeEventListener('visibilitychange', handleAudioVisibility);
        pauseAudio();
        if (quietVisibilityCheckFrame) {
            cancelAnimationFrame(quietVisibilityCheckFrame);
            quietVisibilityCheckFrame = null;
        }
        observer?.disconnect();
        playPauseButton.removeEventListener('click', handlePlayPauseClick);
        audioToggle.removeEventListener('change', handleAudioToggleChange);
        audioInitialized = false;
    };
}

// 配件图片轮播初始化
function initAccessoriesImages() {
    if (accessoriesImagesInitialized) return;
    accessoriesImagesInitialized = true;

    const images = attProductImages;
    if (!images.length) {
        accessoriesImagesInitialized = false;
        return;
    }

    gsap.set(images, { opacity: 0, position: "absolute" });
    gsap.set(images[0], { opacity: 1 });

    const tl = gsap.timeline({ repeat: -1, paused: true });

    images.forEach((img, index) => {
        const nextImage = images[(index + 1) % images.length];
        const switchTime = index + 1;
        tl.set(nextImage, { opacity: 1 }, switchTime)
          .set(img, { opacity: 0 }, switchTime);
    });

    const accessoriesTrigger = ScrollTrigger.create({
        trigger: attSection,
        start: "top bottom",
        end: "bottom top",
        onEnter: () => tl.play(),
        onEnterBack: () => tl.play(),
        onLeave: () => tl.pause(),
        onLeaveBack: () => tl.pause(),
    });

    accessoriesCleanup = () => {
        tl.pause();
        tl.kill();
        accessoriesTrigger.kill();
        accessoriesImagesInitialized = false;
    };
}

// DOMContentLoaded 监听
function initHomepageDomRuntime() {
    const cleanupFns = [
        observeSectionOnce(quietSection, initAudio, HOMEPAGE_INTERACTION_PROTOCOL.observe.deferredSectionRootMargin),
        observeSectionOnce(attSection, initAccessoriesImages, HOMEPAGE_INTERACTION_PROTOCOL.observe.deferredSectionRootMargin),
    ];
    pauseMedia(knobVideo);
    pauseAllAttachmentVideos();

    setTimeout(() => {
        animationScope.classList.add('gsap-ready');
    }, 50); 

    domReadyCleanup = () => {
        cleanupFns.forEach((cleanup) => cleanup());
        audioCleanup();
        accessoriesCleanup();
    };
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHomepageDomRuntime, { once: true });
} else {
    initHomepageDomRuntime();
}

function cleanupHomepageRuntime() {
    homepageRuntimeDestroyed = true;
    document.removeEventListener('visibilitychange', handleHomepageMediaVisibility);
    window.removeEventListener('resize', handleHomepageResize);
    window.removeEventListener('wheel', handleHomepageWheelInput);
    document.removeEventListener('DOMContentLoaded', initHomepageDomRuntime);
    cancelAnimationFrame(resizeFrame);
    revealHomepageHeader();
    homepageHeaderTopStateCleanup();
    domReadyCleanup();
    featureExperienceObserverCleanup();
    viewportModeChangeCleanup();
    mainTimelineExperienceCleanup();
    gsap.removeEventListener('matchMediaInit', captureMainTimelinePosition);
    pauseAllAttachmentVideos();
    pauseMedia(heroVideo);
    pauseMedia(knobVideo);
    audioCleanup();
    accessoriesCleanup();
    heroIntroTimeline?.kill();
    featureIntroTimeline?.scrollTrigger?.kill();
    featureSpacerTimeline?.scrollTrigger?.kill();
    featureIntroTimeline?.kill();
    featureSpacerTimeline?.kill();
}

// BFCache restore needs a fresh set of triggers and observers.
window.addEventListener('pagehide', cleanupHomepageRuntime);
window.addEventListener('pageshow', event => { if (event.persisted) window.location.reload(); });
window.addEventListener('km:reading-mode', cleanupHomepageRuntime);
motionPreference.addEventListener('change', event => {
    if (event.matches) enterHomepageReadingMode('reduced-motion');
});
document.addEventListener('shopify:section:unload', (event) => {
    const target = event.target;
    if (!homepageRoot || !target) return;
    if (target === homepageRoot || target.contains?.(homepageRoot) || homepageRoot.contains?.(target)) {
        cleanupHomepageRuntime();
    }
});

// =================================================================
// 3. GSAP 核心动画逻辑
// =================================================================
// A font request cannot hold the opening indefinitely.
Promise.race([document.fonts.ready, new Promise(resolve => setTimeout(resolve, 1000))]).then(async () => {
    if (homepageRuntimeDestroyed || homepageDocumentRoot.dataset.kmMotion === 'reading') return;
    const initialInteractionProfile = getHomepageInteractionProfile();
    const waitForInitialScrollRestore = async () => {
        let previousScrollY = window.scrollY || window.pageYOffset || 0;
        let stableFrameCount = 0;

        for (let frame = 0; frame < initialInteractionProfile.restore.settleMaxFrames; frame += 1) {
            await new Promise((resolve) => requestAnimationFrame(resolve));
            const currentScrollY = window.scrollY || window.pageYOffset || 0;

            if (Math.abs(currentScrollY - previousScrollY) < initialInteractionProfile.restore.settleDelta) {
                stableFrameCount += 1;
            } else {
                stableFrameCount = 0;
            }

            previousScrollY = currentScrollY;
            if (stableFrameCount >= initialInteractionProfile.restore.settleStableFrames) break;
        }

        return previousScrollY;
    };

    const initialScrollY = await waitForInitialScrollRestore();
    refreshLayoutMetrics();
    
    // 文本分割处理
    const titleContainers = Array.from(animationScope.querySelectorAll(".animated-title"));
    const titleSplits = [];
    function ensureTitleSplit(index) {
        if (!titleSplits[index] && titleContainers[index]) {
            const split = new SplitText(titleContainers[index], {
                type: "lines,words",
                linesClass: "title-line",
                wordsClass: "km-title-word",
                ignore: ".km-outlined-word",
                reduceWhiteSpace: false,
                aria: "none"
            });
            const words = Array.from(titleContainers[index].querySelectorAll(".km-title-word, .km-outlined-word"))
                .filter((word) => !word.matches(".km-outlined-word") || !word.closest(".km-title-word"));
            if (words.length > 0) gsap.set(words, { y: "110%" });
            titleSplits[index] = words;
        }
        return titleSplits[index] || [];
    }

    function ensureTitleRange(startIndex, endIndex) {
        for (let index = startIndex; index <= endIndex; index += 1) {
            ensureTitleSplit(index);
        }
    }

    const textContainers = Array.from(animationScope.querySelectorAll(".animated-text"));
    const textSplits = [];
    function ensureTextSplit(index) {
        if (!textSplits[index] && textContainers[index]) {
            const split = new SplitText(textContainers[index], { type: "lines", aria: "none" });
            gsap.set(split.lines, { opacity: 0, y: 30 });
            textSplits[index] = split.lines;
        }
        return textSplits[index] || [];
    }

    function ensureTextRange(startIndex, endIndex) {
        for (let index = startIndex; index <= endIndex; index += 1) {
            ensureTextSplit(index);
        }
    }

    ensureTitleSplit(0);
    
    gsap.set(".logo-domain", { xPercent: -50 });
    const svg1Container = document.getElementById("svg1-container");
    const svg2Container = document.getElementById("svg2-container");
    let featureAnimationsInitialized = false;
    let featureAnimationsInitializing = false;
    let featureTimelineCreated = false;
    let featureExperienceScheduled = false;

    function primeFeatureAssets() {
        loadSvgMarkup(window.assets?.svg1);
        loadSvgMarkup(window.assets?.svg2);
    }

    function initFeatureExperience() {
        if (featureTimelineCreated) return;
        featureTimelineCreated = true;
        loadHomepageImages(featureSection);
        observeSectionOnce(insSection, warmInstagramGalleryAssets, '1200px 0px');
        createFeatureTl();
        initFeatureAnimations();
        requestScrollRefresh();
    }

    function scheduleFeatureExperience() {
        if (featureExperienceScheduled) return;
        featureExperienceScheduled = true;

        featureExperienceObserverCleanup = observeSectionOnce(
            featureSection,
            initFeatureExperience,
            initialInteractionProfile.observe.featureExperienceRootMargin
        );
    }

    function cleanupFeatureIntroTimelines() {
        featureIntroTimeline?.scrollTrigger?.kill();
        featureSpacerTimeline?.scrollTrigger?.kill();
        featureIntroTimeline?.kill();
        featureSpacerTimeline?.kill();
        featureIntroTimeline = null;
        featureSpacerTimeline = null;
        setHeroSectionInteractivity(true);
    }

    function rebuildFeatureExperience() {
        if (!featureTimelineCreated) return;
        cleanupFeatureIntroTimelines();
        createFeatureTl();
        requestScrollRefresh();
    }

    scheduleIdleTask(() => {
        primeFeatureAssets();
    });

    const handleViewportModeChange = () => {
        rebuildFeatureExperience();
    };
    window.addEventListener('km:viewport-mode-change', handleViewportModeChange);
    viewportModeChangeCleanup = () => {
        window.removeEventListener('km:viewport-mode-change', handleViewportModeChange);
    };

    function getHeroCircleTargets(isMobileViewport) {
        return {
            circle1: {
                rx: isMobileViewport ? () => h * 0.5 : () => w * 0.5,
                ry: isMobileViewport ? () => h * 0.5 : () => w * 0.5,
                cx: isMobileViewport ? () => h * 0.75 : () => w * 0.75,
                cy: isMobileViewport ? () => w * 0.2 : () => h * 0.3,
            },
            circle2: {
                rx: isMobileViewport ? () => h * 0.625 : () => w * 0.625,
                ry: isMobileViewport ? () => h * 0.625 : () => w * 0.625,
                cx: isMobileViewport ? () => h * 0.6 : () => w * 0.6,
                cy: () => 0,
            },
        };
    }

    function getHeroTimelineProfile(isMobileViewport, hasPlayedBefore) {
        if (hasPlayedBefore) {
            return {
                circles: {
                    start: 0,
                    circle1Duration: 1.5,
                    circle2Duration: 1,
                },
                title: {
                    start: 0.5,
                    duration: 1.5,
                    stagger: 0.1,
                },
                ctas: {
                    start: 1,
                    duration: 1,
                    y: isMobileViewport ? "100%" : "200%",
                },
            };
        }

        const logoTransitionStart = isMobileViewport ? 0.5 : 1.5;
        return {
            logoIntro: {
                preLogoDuration: 0.5,
                logoDuration: 1,
                domainDuration: 1,
                logoStart: 0.5,
                domainStart: 0.5,
            },
            logoTransition: {
                start: logoTransitionStart,
                duration: 2,
                top: isMobileViewport ? "12px" : "24px",
                width: isMobileViewport ? "" : "228px",
                height: isMobileViewport ? "" : "31.5px",
                scale: isMobileViewport ? "0.525" : "1",
            },
            maskReveal: {
                start: logoTransitionStart,
                duration: 2,
            },
            circles: {
                start: isMobileViewport ? 0.5 : 1,
                duration: 3,
            },
            title: {
                start: isMobileViewport ? 1.5 : 2.5,
                duration: 1,
                stagger: 0.1,
            },
            ctas: {
                start: isMobileViewport ? 1.75 : 3,
                duration: 1,
                y: isMobileViewport ? "100%" : "200%",
            },
        };
    }

    function stabilizeHomepageFontFallback() {
        if (document.fonts.status !== 'loading') return;
        // Keep the existing fallback for this visit when reading starts before
        // a font finishes. Late metrics must not reflow the pinned copy.
        const updates = [];
        homepageRoot.querySelectorAll('.animated-title, .text-container, .custom-button, .quiet-audio-wrapper, .special-font').forEach(element => {
            const style = getComputedStyle(element);
            const families = style.fontFamily.split(',');
            const primary = families[0];
            const specification = `${style.fontStyle} ${style.fontWeight} 16px ${primary}`;
            if (document.fonts.check(specification, element.textContent || ' ')) return;
            const fallback = families.slice(1).join(',').trim() || 'serif';
            updates.push({ element, fallback });
        });
        updates.forEach(({ element, fallback }) => {
            element.style.fontFamily = fallback;
            element.dataset.kmFontFallback = 'locked';
        });
    }

    function applyHeroEnteredState() {
        stabilizeHomepageFontFallback();
        const enteredHeroCircleTargets = getHeroCircleTargets(isMobile);
        revealHomepageHeader();
        ensureHeroVideoPlayback();
        featureSection.style.opacity = "1";
        gsap.set('.logo-domain', { display: "none" });
        gsap.set('.header', { opacity: 1 });
        gsap.set('.header__heading', { display: "block" });
        gsap.set(['.logo img', '.pre-logo img'], { autoAlpha: 1 });
        gsap.set(titleSplits[0], { y: "0%", opacity: 1 });
        gsap.set(heroCtas, { opacity: 1, y: 0 });
        gsap.set(circle1, { attr: enteredHeroCircleTargets.circle1 });
        gsap.set(circle2, { attr: enteredHeroCircleTargets.circle2 });
        gsap.set(maskCircle, {
            attr: {
                cy: "50%",
                r: "100%"
            },
        });
    }

    function syncRestoredScrollState(scrollY) {
        const featureStartThreshold = Math.max(0, (featureTitleWrapper?.offsetTop || 0) - window.innerHeight * 0.25);
        applyHeroEnteredState();
        sessionStorage.setItem('heroAnimationRun', 'true');
        initFeatureExperience();

        if (scrollY >= featureStartThreshold) {
            gsap.set(heroCtas, { opacity: 0 });
            gsap.set(heroSection, { zIndex: "auto" });
            pauseMedia(heroVideo);
        }

        requestAnimationFrame(() => {
            requestScrollRefresh();
            ScrollTrigger.update();
        });
    }
    
    /* ==================== 版块 1: Hero 视频 ==================== */
    const hasHeroAnimationRun = Boolean(sessionStorage.getItem('heroAnimationRun'));
    // Browser scroll restoration may land after the initial two stable frames.
    // Re-visits must not depend on the feature section becoming visible again.
    if (hasHeroAnimationRun) initFeatureExperience();
    const shouldRestoreFromScroll = initialScrollY > initialInteractionProfile.restore.scrollThreshold;
    if (shouldRestoreFromScroll) {
        syncRestoredScrollState(initialScrollY);
        return;
    }


    const heroCircleTargets = getHeroCircleTargets(isMobile);
    if (!hasHeroAnimationRun) {
        const heroProfile = getHeroTimelineProfile(isMobile, false);

        const heroTl = heroIntroTimeline = gsap.timeline({
            defaults: { ease: "power2.inOut" },
            onComplete: () => {
                stabilizeHomepageFontFallback();
                revealHomepageHeader();
                ensureHeroVideoPlayback();
                featureSection.style.opacity = "1";
                requestScrollRefresh();
                sessionStorage.setItem('heroAnimationRun', 'true');
                const restoredScrollY = window.scrollY || window.pageYOffset || 0;
                if (restoredScrollY > initialInteractionProfile.restore.scrollThreshold) {
                    syncRestoredScrollState(restoredScrollY);
                } else {
                    scheduleFeatureExperience();
                }
            }
        });

        heroTl
            .from('.pre-logo img', {  autoAlpha: 0, clipPath: isMobile ? "" : "inset(0 0 100% 0)", duration: heroProfile.logoIntro.preLogoDuration })
            .from('.logo img', {  autoAlpha: 0, clipPath: isMobile ? "" : "inset(0 100% 0 0)", duration: heroProfile.logoIntro.logoDuration }, heroProfile.logoIntro.logoStart)
            .from('.logo-domain', {  autoAlpha: 0, xPercent: isMobile ? -50 : 0, duration: heroProfile.logoIntro.domainDuration }, heroProfile.logoIntro.domainStart)
            .to('.logo-domain', {
                top: heroProfile.logoTransition.top,
                width: heroProfile.logoTransition.width,
                height: heroProfile.logoTransition.height,
                scale: heroProfile.logoTransition.scale,
                duration: heroProfile.logoTransition.duration
            }, heroProfile.logoTransition.start)
            .to(maskCircle, {
                attr: {     
                    cy: "50%",
                    r: "100%"
                },
                duration: heroProfile.maskReveal.duration
            }, heroProfile.maskReveal.start)
            .add(() => {
                revealHomepageHeader();
                ensureHeroVideoPlayback();
            }, ">")
            .to('.header', { opacity: 1 }, ">")
            .to('.logo-domain', { display: "none" }, "<")
            .to('.header__heading', { display: "block" }, "<")
            .to(circle1, {
                attr: heroCircleTargets.circle1,
                duration: heroProfile.circles.duration,
            }, heroProfile.circles.start)
            .to(circle2, {
                attr: heroCircleTargets.circle2,
                duration: heroProfile.circles.duration,
            }, heroProfile.circles.start)
            .to(titleSplits[0], {
                y: "0%",
                stagger: heroProfile.title.stagger,
                duration: heroProfile.title.duration,
                onStart: () => {
                    setHomepageIntroScrollLock(false);
                    ensureHeroVideoPlayback();
                    refreshLayoutMetrics();
                    requestScrollRefresh();
                }
            }, heroProfile.title.start)
            .from(heroCtas, { opacity: 0, y: heroProfile.ctas.y, duration: heroProfile.ctas.duration }, heroProfile.ctas.start);
    } else {
        const heroProfile = getHeroTimelineProfile(isMobile, true);
        gsap.set('.logo-domain', {
            display: "none"
        });
        gsap.set('.header', { opacity: 1 });
        gsap.set('.header__heading', { display: "block" });
        gsap.set(['.logo img', '.pre-logo img'], {autoAlpha: 1});
        gsap.set(maskCircle, {
            attr: {     
                cy: "50%",
                r: "100%"
            },
        });

        const heroTl = heroIntroTimeline = gsap.timeline({
            defaults: { ease: "power2.inOut" },
            onComplete: () => {
                stabilizeHomepageFontFallback();
                revealHomepageHeader();
                ensureHeroVideoPlayback();
                featureSection.style.opacity = "1";
                requestScrollRefresh();
                sessionStorage.setItem('heroAnimationRun', 'true');
                const restoredScrollY = window.scrollY || window.pageYOffset || 0;
                if (restoredScrollY > initialInteractionProfile.restore.scrollThreshold) {
                    syncRestoredScrollState(restoredScrollY);
                } else {
                    scheduleFeatureExperience();
                }
            }
        });

        heroTl
            .to(circle1, {
                attr: heroCircleTargets.circle1,
                duration: heroProfile.circles.circle1Duration,
            }, heroProfile.circles.start)
            .to(circle2, {
                attr: heroCircleTargets.circle2,
                duration: heroProfile.circles.circle2Duration,
            }, heroProfile.circles.start)
            .to(titleSplits[0], {
                y: "0%",
                stagger: heroProfile.title.stagger,
                duration: heroProfile.title.duration,
                onStart: () => {
                    setHomepageIntroScrollLock(false);
                    ensureHeroVideoPlayback();
                    refreshLayoutMetrics();
                    requestScrollRefresh();
                }
            }, heroProfile.title.start)
            .from(heroCtas, { opacity: 0, y: heroProfile.ctas.y, duration: heroProfile.ctas.duration }, heroProfile.ctas.start);
    }      

    /* ==================== 版块 2: 产品特点 (Feature) ==================== */
    function getFeatureIntroTimelineProfile(isMobileViewport) {
        return {
            labels: {
                featureRevealStart: 0.5,
                featureCircleDrop: 1.2,
                featureCircleGlideA: 2.05,
                featureCircleGlideB: 3.3,
                featureCircleGlideC: 4.45,
                featureTitleEnter: 2,
                featureTitleExit: 5,
            },
            timings: {
                titleFade: 1,
                titleFadeStagger: 0.2,
                ctasFade: 1,
                ctasFadePosition: ">-=1",
                featureCircleExpand: isMobileViewport ? 2.05 : 2.45,
                heroSectionReset: 1,
                featureBg: isMobileViewport ? 1.55 : 1.8,
                circleSectionEnter: 2,
                circleReveal: 1,
                featureTitleReveal: 1,
                featureTitleRevealStagger: 0.2,
                circleDrop: 2.35,
                circleGlideA: 2.15,
                circleGlideB: 2.05,
                circleGlideC: 1.65,
                featureTitleHide: 1,
                featureTitleHideStagger: 0.1,
            },
            circles: {
                reveal: {
                    rx: isMobileViewport ? () => h * 73 / 480 : () => w * 73 / 480,
                    ry: isMobileViewport ? () => h * 73 / 480 : () => w * 73 / 480,
                    cx: () => w * 0.5,
                    cy: () => h * 0.5,
                },
                drop: {
                    circle1: {
                        rx: isMobileViewport ? () => h * 0.275 : () => w * 73 / 480,
                        ry: isMobileViewport ? () => h * 0.275 : () => w * 73 / 480,
                        cy: () => h,
                    },
                    circle2: {
                        rx: isMobileViewport ? () => h * 0.75 : () => w * 0.4,
                        ry: isMobileViewport ? () => h * 0.75 : () => w * 0.4,
                        cy: () => h,
                    },
                },
                glideA: {
                    circle1: {
                        rx: isMobileViewport ? () => h * 0.245 : () => w * 0.125,
                        ry: isMobileViewport ? () => h * 0.245 : () => w * 0.125,
                        cx: () => w * 0.5,
                        cy: () => h * 0.94,
                    },
                    circle2: {
                        rx: isMobileViewport ? () => h * 0.685 : () => w * 0.35,
                        ry: isMobileViewport ? () => h * 0.685 : () => w * 0.35,
                        cx: () => w * 0.5,
                        cy: () => h * 0.94,
                    },
                },
                glideB: {
                    circle1: {
                        rx: isMobileViewport ? () => h * 0.225 : () => w * 0.145,
                        ry: isMobileViewport ? () => h * 0.225 : () => w * 0.145,
                        cx: () => w * 0.5,
                        cy: () => h * 0.82,
                    },
                    circle2: {
                        rx: isMobileViewport ? () => h * 0.625 : () => w * 0.305,
                        ry: isMobileViewport ? () => h * 0.625 : () => w * 0.305,
                        cx: () => w * 0.5,
                        cy: () => h * 0.82,
                    },
                },
                glideC: {
                    circle1: {
                        rx: isMobileViewport ? () => h * 0.215 : () => w * 0.16,
                        ry: isMobileViewport ? () => h * 0.215 : () => w * 0.16,
                        cx: () => w * 0.5,
                        cy: () => h * 0.68,
                    },
                    circle2: {
                        rx: isMobileViewport ? () => h * 0.575 : () => w * 0.28,
                        ry: isMobileViewport ? () => h * 0.575 : () => w * 0.28,
                        cx: () => w * 0.5,
                        cy: () => h * 0.68,
                    },
                },
                spacer: {
                    rx: isMobileViewport ? () => dw * 0.44 : () => w * 90 / 480,
                    ry: isMobileViewport ? () => dw * 0.44 : () => w * 90 / 480,
                    cy: () => h * 0.5,
                },
            },
        };
    }

        function createFeatureTl() {
            const featureProfile = getFeatureIntroTimelineProfile(isMobile);
            const interactionProfile = getHomepageInteractionProfile({ isMobileViewport: isMobile });
            const featureTitleWords = [...ensureTitleSplit(1), ...ensureTitleSplit(2)];
            cleanupFeatureIntroTimelines();

        featureIntroTimeline = gsap.timeline({
            defaults: { ease: "none" },
            scrollTrigger: {
                trigger: featureTitleWrapper,
                start: "top top",
                end: "bottom top",
                scrub: interactionProfile.scroll.scrub.featureIntro,
                pin: true,
                onUpdate: (self) => {
                    setHeroSectionInteractivity(self.progress < 0.02);
                },
                onLeave: () => {
                    setHeroSectionInteractivity(false);
                },
                onEnterBack: (self) => {
                    setHeroSectionInteractivity(self.progress < 0.02);
                },
                onRefresh: (self) => {
                    setHeroSectionInteractivity(self.progress < 0.02);
                },
            }
        });
        addTimelineLabels(featureIntroTimeline, featureProfile.labels);

        featureIntroTimeline
            .set(heroCtas, { opacity: 1 }, 0)
            .set(heroSection, { zIndex: 9 }, 0)
            .to(titleSplits[0], {
                opacity: 0,
                stagger: featureProfile.timings.titleFadeStagger,
                duration: featureProfile.timings.titleFade
            })
            .fromTo(heroCtas, { opacity: 1 }, {
                opacity: 0,
                duration: featureProfile.timings.ctasFade,
                immediateRender: false,
            }, featureProfile.timings.ctasFadePosition)
            .to(featureCircle, { cy: "50%", r: "100%", duration: featureProfile.timings.featureCircleExpand }, "featureRevealStart")
            .fromTo(heroSection, { zIndex: 9 }, {
                zIndex: "auto",
                duration: featureProfile.timings.heroSectionReset,
                immediateRender: false,
            }, "<")
            .to(featureSection, { 
                backgroundColor: "#000",   
                onStart: () => { 
                    pauseMedia(heroVideo);
                },                              
                onReverseComplete: () => { 
                    ensureHeroVideoPlayback();
                },
                duration: featureProfile.timings.featureBg
            }, ">")
            .to(circleSection, { zIndex: 1, duration: featureProfile.timings.circleSectionEnter }, "<")
            .to([circle1, circle2], {
                attr: featureProfile.circles.reveal,
                duration: featureProfile.timings.circleReveal
            }, "featureRevealStart")
            .to(featureTitleWords, {
                y: "0%",
                stagger: featureProfile.timings.featureTitleRevealStagger,
                duration: featureProfile.timings.featureTitleReveal
            }, "featureTitleEnter")
            .to(circle1, {
                attr: featureProfile.circles.drop.circle1,
                duration: featureProfile.timings.circleDrop,
                ease: "expo.out",
            }, "featureCircleDrop")
            .to(circle2, {
                attr: featureProfile.circles.drop.circle2,
                duration: featureProfile.timings.circleDrop,
                ease: "expo.out",
            }, "featureCircleDrop")
            .to(circle1, {
                attr: featureProfile.circles.glideA.circle1,
                duration: featureProfile.timings.circleGlideA,
                ease: "none",
            }, "featureCircleGlideA")
            .to(circle2, {
                attr: featureProfile.circles.glideA.circle2,
                duration: featureProfile.timings.circleGlideA,
                ease: "none",
            }, "featureCircleGlideA")
            .to(circle1, {
                attr: featureProfile.circles.glideB.circle1,
                duration: featureProfile.timings.circleGlideB,
                ease: "none",
            }, "featureCircleGlideB")
            .to(circle2, {
                attr: featureProfile.circles.glideB.circle2,
                duration: featureProfile.timings.circleGlideB,
                ease: "none",
            }, "featureCircleGlideB")
            .to(circle1, {
                attr: featureProfile.circles.glideC.circle1,
                duration: featureProfile.timings.circleGlideC,
                ease: "none",
            }, "featureCircleGlideC")
            .to(circle2, {
                attr: featureProfile.circles.glideC.circle2,
                duration: featureProfile.timings.circleGlideC,
                ease: "none",
            }, "featureCircleGlideC")
            .to(featureTitleWords, {
                opacity: 0,
                stagger: featureProfile.timings.featureTitleHideStagger,
                duration: featureProfile.timings.featureTitleHide
            }, "featureTitleExit");

        featureSpacerTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: featureSpacer,
                start: "top top",
                end: "bottom 50%",
                scrub: interactionProfile.scroll.scrub.featureSpacer
            }
        });

        featureSpacerTimeline.to([circle1, circle2], {
            attr: featureProfile.circles.spacer,
        });
    }

    function initFeatureAnimations() {
        if (featureAnimationsInitialized || featureAnimationsInitializing || !svg1Container || !svg2Container) {
            return;
        }

        featureAnimationsInitializing = true;
        Promise.all([
            loadSvgMarkup(window.assets?.svg1),
            loadSvgMarkup(window.assets?.svg2)
        ]).then(([svg1Text, svg2Text]) => {
        if (homepageRuntimeDestroyed || homepageDocumentRoot.dataset.kmMotion === 'reading') return;
        if (!svg1Text || !svg2Text) { enterHomepageReadingMode('feature-asset'); return; }
        ensureTitleRange(3, 10);
        ensureTextRange(0, 7);
        svg1Container.innerHTML = svg1Text || '';
        svg2Container.innerHTML = svg2Text || '';
        svg1Shapes = Array.from(svg1Container.querySelectorAll("path, circle"));
        svg2Shapes = Array.from(svg2Container.querySelectorAll("circle, path"));
        featureAnimationsInitialized = true;
        featureAnimationsInitializing = false;
        requestScrollRefresh();

        const MAIN_TIMELINE_LABELS = {
            mobile: {
                featureInside: {
                    featureDrawStart: 0.5,
                    featureSvg2DrawStart: 2.5,
                    featureCopyReveal: 6,
                    featurePrimaryFadeStart: 9,
                    featureSecondaryRevealStart: 10,
                    insideCardsIntro: 13,
                    insideCardFocus1: 15,
                    insideCardFocus2: 17,
                    insideCardFocus3: 19,
                },
                sectionAnchors: {
                    knobStart: 21,
                    quietStart: 30,
                    attachmentsStart: 37,
                    aboutStart: 56,
                    instagramStart: 81,
                    instagramEnd: 87.8,
                },
            },
            desktop: {
                featureInside: {
                    featureDrawStart: 0.5,
                    featureSvg2DrawStart: 2.5,
                    featureShiftStart: 5.5,
                    featureCopyReveal: 6,
                    featurePrimaryFadeStart: 9,
                    featureWrapShiftStart: 10,
                    featureSecondaryRevealStart: 11,
                    featureSecondaryBodyRevealStart: 11.5,
                    featureSecondaryCopyHideStart: 14.5,
                    insideCardsIntro: 16,
                    insideCardFocus1: 18,
                    insideCardFocus2: 20,
                    insideCardFocus3: 22,
                },
                sectionAnchors: {
                    knobStart: 23,
                    quietStart: 31,
                    attachmentsStart: 37,
                    aboutStart: 56,
                    instagramStart: 81,
                    instagramEnd: 87.8,
                },
            },
        };
        const SECTION_LABEL_RATIOS = {
            mobile: {
                knob: {
                    mediaPlay: 1 / 18,
                    copyReveal: 5 / 18,
                    copyHide: 7 / 9,
                    bodyRevealStart: 1 / 3,
                },
                quiet: {
                    copyHide: 4 / 7,
                },
                attachments: {
                    copyHide: 4 / 19,
                    detailsIntro: 6 / 19,
                    item4Start: 15 / 19,
                },
                about: {
                    copyReveal: 3 / 25,
                    primaryCopyHide: 8 / 25,
                    galleryStart: 9 / 25,
                    storyReveal: 19 / 25,
                    storyCopyHide: 24 / 25,
                },
                instagram: {
                    copyHide: 7 / 11,
                    cardsIntro: 9 / 11,
                },
            },
            desktop: {
                knob: {
                    mediaPlay: 1 / 16,
                    copyReveal: 5 / 16,
                    copyHide: 3 / 4,
                    bodyRevealStart: 3 / 8,
                },
                quiet: {
                    copyHide: 2 / 3,
                },
                attachments: {
                    copyHide: 4 / 19,
                    detailsIntro: 6 / 19,
                    item4Start: 15 / 19,
                },
                about: {
                    copyReveal: 3 / 25,
                    primaryCopyHide: 8 / 25,
                    galleryStart: 9 / 25,
                    storyReveal: 19 / 25,
                    storyCopyHide: 24 / 25,
                },
                instagram: {
                    copyHide: 7 / 11,
                    cardsIntro: 9 / 11,
                },
            },
        };
        const CARD_SCROLL_LABELS = ["insideCardFocus1", "insideCardFocus2", "insideCardFocus3"];
        const ATTACHMENT_POINT_LABELS = [
            "attachmentItem1Start",
            "attachmentItem2Start",
            "attachmentItem3Start",
            "attachmentItem4Start",
        ];
        function getAttachmentTimelineConfig(runtimeProfile) {
            return {
                entryDuration: runtimeProfile.attachmentsFlow.entryDuration,
                holdDuration: runtimeProfile.attachmentsFlow.holdDuration,
                exitDuration: runtimeProfile.attachmentsFlow.exitDuration,
                exitStart: runtimeProfile.attachmentsFlow.exitStart,
                animationWindow: runtimeProfile.attachmentsFlow.animationWindow,
                clickFocusOffset: runtimeProfile.attachmentsFlow.clickFocusOffset,
                baseScale: 0.9,
                cruiseScale: runtimeProfile.inputMode === "trackpad" ? 0.97 : 0.95,
                focusScale: 1,
                activeColor: "white",
                inactiveColor: "var(--km-white-20)",
            };
        }

        function getAttachmentMotionVector(isNotDesktop) {
            if (isNotDesktop) {
                return {
                    attX: (-h * 0.5 + dw * 0.125) * 0.72,
                    attY: 0.22 * dw,
                };
            }

            const attY = h * 0.5 + w * 0.125;
            const attX = attY > w * 0.5
                ? 0.25 * w
                : 0.5 * (w * 0.5 - Math.sqrt(0.25 * w * w - attY * attY));
            return {
                attX: attX * 0.78,
                attY: attY * 0.76,
            };
        }

        function getAttachmentOrbitProfile(isNotDesktop) {
            if (isNotDesktop) {
                const panelRect = attCenterPanel?.getBoundingClientRect();
                const panelWidth = panelRect?.width || dw * 0.5;
                const panelHeight = panelRect?.height || dw * 0.5;
                const panelCenterX = panelRect ? panelRect.left + panelWidth / 2 : w * 0.5;
                const rightTravel = Math.max((w - panelCenterX) + panelWidth * 0.7, panelWidth * 1.25);
                const leftTravel = Math.max(panelCenterX + panelWidth * 0.7, panelWidth * 1.25);
                const sideDrop = Math.max(panelHeight * 0.18, h * 0.06);
                const peakLift = Math.max(panelHeight * 0.34, h * 0.11);
                const arcOffset = Math.max(panelHeight * 0.28, h * 0.085);
                const sideY = sideDrop + arcOffset;
                const peakY = -peakLift + arcOffset;

                return {
                    entryStart: { x: -leftTravel, y: sideY },
                    entryPath: [
                        { x: -leftTravel * 0.78, y: sideY * 0.86 },
                        { x: -leftTravel * 0.44, y: peakY * 0.36 },
                        { x: -leftTravel * 0.16, y: peakY * 0.82 },
                    ],
                    holdEnd: { x: 0, y: peakY },
                    exitPath: [
                        { x: rightTravel * 0.16, y: peakY * 0.82 },
                        { x: rightTravel * 0.44, y: peakY * 0.36 },
                        { x: rightTravel * 0.78, y: sideY * 0.86 },
                    ],
                    exitEnd: { x: rightTravel, y: sideY },
                };
            }

            const motionVector = getAttachmentMotionVector(isNotDesktop);
            const entryX = isNotDesktop ? -motionVector.attX : motionVector.attX;
            const entryY = motionVector.attY;
            const circleCenterX = (entryX * entryX + entryY * entryY) / (2 * entryX);
            const radius = Math.abs(circleCenterX);
            const focusAngle = circleCenterX > 0 ? Math.PI : 0;
            const startAngle = Math.atan2(entryY, entryX - circleCenterX);
            const pointOnArc = (angle) => ({
                x: circleCenterX + Math.cos(angle) * radius,
                y: Math.sin(angle) * radius,
            });
            return {
                entryStart: pointOnArc(startAngle),
                // Follow the full arc to the approved center. Stopping partway
                // leaves a visible distance for the very short center hold.
                entryPath: Array.from({ length: 15 }, (_, index) => (
                    pointOnArc(startAngle + (focusAngle - startAngle) * (index + 1) / 16)
                )),
                holdEnd: { x: 0, y: 0 },
                exitEnd: pointOnArc(-startAngle),
            };
        }

        function getKnobClipPath(percent, isDesktop) {
            if (isDesktop) {
                return `circle(${percent}% at 77.1875% ${circleYPos})`;
            }
            return `circle(${percent}% at 50% 50%)`;
        }

        function getKnobEntryClipPath(isDesktop) {
            const radius = getFeatureInsideCircleTransitions(isDesktop).knobPrep.circle1.rx();
            const referenceRadius = Math.hypot(knobImg.offsetWidth, knobImg.offsetHeight) / Math.SQRT2;
            // Continue from the retained outline instead of revealing a new
            // zero-radius mask inside it. Keep the approved image center.
            return getKnobClipPath(radius / referenceRadius * 100, isDesktop);
        }

        function getPlatformCircleTransitions(isDesktop) {
            if (isDesktop) {
                return {
                    quietIntro: {
                        circle1: { rx: () => w * 0.315, ry: () => w * 0.315, cx: () => w * 0.5, cy: () => h * 0.5 },
                        circle2: { rx: () => w * 0.165, ry: () => w * 0.165, cx: () => w * 0.5, cy: () => h * 0.5 },
                    },
                    quietToAttachments: {
                        circle1: { rx: () => w * 0.225, ry: () => w * 0.225, cx: () => w * 1.05, cy: () => h * 0.25 },
                        circle2: { rx: () => w * 0.5, ry: () => w * 0.5, cx: () => w * 1.05, cy: () => h * 1.35 },
                    },
                    aboutIntro: {
                        circle1: { rx: () => w * 0.2836, ry: () => w * 0.2836, cx: () => w * 0.4997, cy: () => h * 0.5005 },
                        circle2: { rx: () => w * 0.1401, ry: () => w * 0.1401, cx: () => w * 0.4109, cy: () => h * 0.675 },
                    },
                    aboutCopyFlow: {
                        circle1: { rx: () => w * 0.305, ry: () => w * 0.305, cx: () => w * 0.525, cy: () => h * 0.48 },
                        circle2: { rx: () => w * 0.132, ry: () => w * 0.132, cx: () => w * 0.448, cy: () => h * 0.628 },
                    },
                    aboutStory: {
                        circle1: { rx: () => w * 0.45, ry: () => w * 0.45, cx: () => w * 0.75, cy: () => h * 0.3 },
                        circle2: { rx: () => w * 0.625, ry: () => w * 0.625, cx: () => w * 0.8, cy: () => h * 1.2 },
                    },
                    instagram: {
                        group13: { rx: () => w * 0.5, ry: () => w * 0.5, cx: () => w * 0.3, cy: () => h * 0.5 },
                        group24: { rx: () => w * 0.6, ry: () => w * 0.6, cx: () => w * 0.9, cy: () => h * 1.5 },
                    },
                };
            }

            return {
                quietIntro: {
                    circle1: { rx: () => dw * 0.78, ry: () => dw * 0.78, cx: () => w * 0.5, cy: () => h * 0.5 },
                    circle2: { rx: () => dw * 0.43, ry: () => dw * 0.43, cx: () => w * 0.5, cy: () => h * 0.5 },
                },
                quietToAttachments: {
                    circle1: { rx: () => h * 0.55 - dw * 0.482, ry: () => h * 0.55 - dw * 0.482, cx: () => w * 0.5, cy: () => h * 1.1 },
                    circle2: { rx: () => h * 0.6 - dw * 0.05, ry: () => h * 0.6 - dw * 0.05, cx: () => w * 0, cy: () => h * 1.1 },
                },
                aboutIntro: {
                    circle1: { rx: () => dw * 0.75, ry: () => dw * 0.75, cx: () => w * 0.5, cy: () => h * 0.5 },
                    circle2: { rx: () => dw * 0.29, ry: () => dw * 0.29, cx: () => w * 0.57, cy: () => h * 0.46 },
                },
                aboutCopyFlow: {
                    circle1: { rx: () => dw * 0.82, ry: () => dw * 0.82, cx: () => w * 0.54, cy: () => h * 0.49 },
                    circle2: { rx: () => dw * 0.24, ry: () => dw * 0.24, cx: () => w * 0.61, cy: () => h * 0.43 },
                },
                aboutStory: {
                    circle1: { rx: () => dw * 0.75, ry: () => dw * 0.75, cx: () => dw * 1, cy: () => h * 0.3 },
                    circle2: { rx: () => dw * 1.25, ry: () => dw * 1.25, cx: () => dw * 0.8, cy: () => h * 1.2 },
                },
                instagram: {
                    group13: { rx: () => w * 0.9, ry: () => w * 0.9, cx: () => -w * 0.1, cy: () => h * 1 },
                    group24: { rx: () => w * 0.9, ry: () => w * 0.9, cx: () => w * 1, cy: () => h * 0.75 },
                },
            };
        }

        function getQuietCircleBreathTargets(isDesktop) {
            if (isDesktop) {
                return {
                    circle1: { rx: () => w * 0.285, ry: () => w * 0.285, cx: () => w * 0.5, cy: () => h * 0.5 },
                    circle2: { rx: () => w * 0.19, ry: () => w * 0.19, cx: () => w * 0.5, cy: () => h * 0.5 },
                };
            }

            return {
                circle1: { rx: () => dw * 0.72, ry: () => dw * 0.72, cx: () => w * 0.5, cy: () => h * 0.5 },
                circle2: { rx: () => dw * 0.49, ry: () => dw * 0.49, cx: () => w * 0.5, cy: () => h * 0.5 },
            };
        }

        function getFeatureInsideCircleTransitions(isDesktop) {
            if (isDesktop) {
                return {
                    featureStroke: {
                        circle1: { rx: () => w * 90 / 480, ry: () => w * 90 / 2400, cy: () => h * 0.5 + w * 0.1 },
                        circle2: { rx: () => w * 120 / 480, ry: () => w * 130 / 2400, cy: () => h * 0.5 + w * 0.11 },
                    },
                    featureExpand: {
                        circle1: { rx: () => w * 0.16, ry: () => w * 0.16, cx: () => w * 0.275, cy: () => h * 0.5 },
                        circle2: { rx: () => w * 0.325, ry: () => w * 0.325, cx: () => w * 0.425, cy: () => h * 0.5 },
                    },
                    featureShiftCx: {
                        circle1: { cx: () => w * 0.725 },
                        circle2: { cx: () => w * 0.575 },
                    },
                    featureSecondaryMorph: {
                        circle1: { rx: () => w * 0.215, ry: () => w * 0.215, cx: () => w * 0.675, cy: () => h * 0.485 },
                        circle2: { rx: () => w * 0.29, ry: () => w * 0.29, cx: () => w * 0.6, cy: () => h * 0.515 },
                    },
                    insideStageA: {
                        circle1: { rx: () => dw * 0.325, ry: () => dw * 0.325, cx: () => w * 0.575, cy: () => h * 0.5 },
                        circle2: { rx: () => w * 0.11, ry: () => w * 0.11, cx: () => w * 0.73, cy: () => h * 0.5 - w * 0.075 },
                    },
                    insideStageB: {
                        circle1: { rx: () => w * 0.325, ry: () => w * 0.325, cx: () => w * 0.585, cy: () => h * 0.505 },
                        circle2: { rx: () => w * 0.11, ry: () => w * 0.11, cx: () => w * 0.76, cy: () => h * 0.5 + w * 0.055 },
                    },
                    insideStageC: {
                        circle1: { rx: () => w * 0.325, ry: () => w * 0.325, cx: () => w * 0.575, cy: () => h * 0.5 },
                        circle2: { rx: () => w * 0.11, ry: () => w * 0.11, cx: () => w * 0.67, cy: () => h * 0.5 + w * 0.03 },
                    },
                    knobPrep: {
                        circle1: {
                            rx: () => w * 0.015,
                            ry: () => w * 0.015,
                            cx: () => w * 0.771875,
                            cy: () => h * circleY,
                        },
                        circle2: {
                            rx: () => w * 0.015,
                            ry: () => w * 0.015,
                            cx: () => w * 0.771875,
                            cy: () => h * circleY,
                        },
                    },
                };
            }

            return {
                featureStroke: {
                    circle1: { rx: () => dw * 0.375, ry: () => dw * 0.08, cy: () => h * 0.5 + dw * 0.225 },
                    circle2: { rx: () => dw * 0.48, ry: () => dw * 0.12, cy: () => h * 0.5 + dw * 0.245 },
                },
                featureExpand: {
                    circle1: { rx: () => dw * 0.45, ry: () => dw * 0.45, cx: () => w * 0.5, cy: () => h * 0.5 },
                    circle2: { rx: () => dw * 0.8, ry: () => dw * 0.8, cx: () => w * 0.5, cy: () => h * 0.5 },
                },
                featureSecondary: {
                    circle1: { rx: () => dw * 0.35, ry: () => dw * 0.35, cx: () => w * 0.5, cy: () => h * 0.28 },
                    circle2: { rx: () => dw * 0.625, ry: () => dw * 0.625, cx: () => w * 0.5, cy: () => h * 0.35 },
                },
                insideStageA: {
                    circle1: { rx: () => dw * 0.625, ry: () => dw * 0.625, cx: () => w * 0.5, cy: () => h * 0.375 },
                    circle2: { rx: () => dw * 0.225, ry: () => dw * 0.225, cx: () => w * 0.6, cy: () => h * 0.225 },
                },
                insideStageB: {
                    circle1: { rx: () => dw * 0.225, ry: () => dw * 0.225, cx: () => w * 0.675, cy: () => h * 0.4 },
                    circle2: { rx: () => dw * 0.625, ry: () => dw * 0.625, cx: () => w * 0.5, cy: () => h * 0.375 },
                },
                insideStageC: {
                    circle1: { rx: () => dw * 0.625, ry: () => dw * 0.625, cx: () => w * 0.5, cy: () => h * 0.375 },
                    circle2: { rx: () => dw * 0.225, ry: () => dw * 0.225, cx: () => w * 0.4, cy: () => h * 0.35 },
                },
                knobPrep: {
                    circle1: {
                        rx: () => dw * 0.043,
                        ry: () => dw * 0.043,
                        cx: () => w * 0.5 + dw * 0.102,
                        cy: () => h * 0.5 - dw * 0.502,
                    },
                    circle2: {
                        rx: () => dw * 0.043,
                        ry: () => dw * 0.043,
                        cx: () => w * 0.5 + dw * 0.102,
                        cy: () => h * 0.5 - dw * 0.502,
                    },
                },
            };
        }

        function getInsideCardTrackTargets(isDesktop) {
            if (isDesktop) {
                return {
                    intro: () => -(h / 2 + cardHeight1 / 2),
                    focus1: () => -(h / 2 + 24 + cardHeight1 + cardHeight2 / 2),
                    focus2: () => -(h / 2 + 48 + cardHeight1 + cardHeight2 + cardHeight3 / 2),
                    focus3: () => -(h / 2 + 72 + cardHeight1 + cardHeight2 + cardHeight3 + cardHeight1 / 2),
                    outro: () => {
                        const focus3Base = h / 2 + 72 + cardHeight1 + cardHeight2 + cardHeight3 + cardHeight1 / 2;
                        const exitTravel = Math.max(cardHeight3 * 0.72, h * 0.18);
                        return -(focus3Base + exitTravel);
                    },
                };
            }

            return {
                focus1: () => -cardHeight1 - w * 0.04,
                focus2: -cardHeight1 - cardHeight2 - w * 0.08,
            };
        }

        function getInsideCardOpacityProfile(isDesktop) {
            if (isDesktop) {
                return {
                    intro: [1, 0.35, 0.15],
                    focus1: [0.35, 1, 0.35],
                    focus2: [0.15, 0.35, 1],
                    focus3: [0, 0.15, 0.35],
                };
            }

            return {
                intro: [1, 0, 0],
                focus1: [0, 1, 0],
                focus2: [0, 0, 1],
            };
        }

        function getDesktopInsideCardsExitProfile(focus3TrackStartTime, knobIntroTime, cardsStep, finalHold, trackFadeOut = 1) {
            const cardsExitStart = focus3TrackStartTime + cardsStep;
            const focus3ExitStart = Math.min(
                cardsExitStart,
                (knobIntroTime ?? cardsExitStart) - 0.08
            );

            return {
                focus3ExitStart,
                cardsExitStart: focus3ExitStart,
                cardsExitDuration: Math.max(trackFadeOut - 0.4, 0.54),
            };
        }

        function getFeatureInsideTimingProfile(isDesktop, runtimeProfile = null) {
            const insideFlow = runtimeProfile?.insideFlow || {
                cardsStep: 1,
                cardFade: 1,
                imageSwap: 1,
            };
            return {
                draw: runtimeProfile?.insideReadingPace?.drawDuration ?? 1.5,
                svg2Draw: runtimeProfile?.insideReadingPace?.drawDuration ?? 1.5,
                strokeDelay: 1,
                feature: {
                    svgFade: 1,
                    imageFade: 1,
                    wrapFade: 1,
                    circleExpand: 2,
                    titleReveal: 1,
                    bodyReveal: 1,
                    buttonReveal: 2,
                    titleHide: 0.5,
                    bodyHidePrimary: 2,
                    buttonHide: 2,
                    secondaryBodyDelay: 2,
                    secondaryWrapReveal: 1,
                    secondaryBodyHide: 1.5,
                },
                inside: {
                    cardsIntro: 1,
                    cardsStep: insideFlow.cardsStep,
                    cardFade: insideFlow.cardFade,
                    imageSwap: insideFlow.imageSwap,
                    circleStage: isDesktop ? 1 : 2,
                    buttonReveal: isDesktop ? 1 : null,
                    trackFadeOut: 1,
                    clipShrink: 1.5,
                    exitAlign: 0.65,
                    exitEase: "sine.inOut",
                },
                desktop: isDesktop
                    ? {
                        contentShift: 2,
                        featureExpandLead: 1.2,
                        featureExpandStagger: 0,
                        featureExpandDuration: 4.1,
                        featureExpandEase: "sine.inOut",
                        wrapShift: 2,
                        secondaryCircleShift: 1.5,
                        secondaryCircleShiftLead: 0,
                        secondaryCircleShiftStagger: 0,
                        secondaryCircleShiftDuration: 2.55,
                        secondaryCircleShiftEase: "sine.inOut",
                        featureSecondaryMorphLead: 0.35,
                        featureSecondaryMorphStagger: 0,
                        featureSecondaryMorphDuration: 3.95,
                        featureSecondaryMorphEase: "sine.inOut",
                    }
                    : null,
            };
        }

        function getInsideExitProfile(labelMap, timings, runtimeProfile, isDesktop) {
            const insideFlow = runtimeProfile?.insideFlow || {};
            const start = isDesktop
                ? getDesktopInsideCardsExitProfile(
                    (labelMap.insideCardFocus3 ?? 0) - (insideFlow.transitionLead || 0),
                    labelMap.knobIntro,
                    timings.inside.cardsStep,
                    insideFlow.finalHold || 0,
                    timings.inside.trackFadeOut
                ).focus3ExitStart
                : labelMap.insideCardFocus3 ?? 0;

            return {
                start,
                alignStart: start - timings.inside.exitAlign,
                alignDuration: timings.inside.exitAlign,
                duration: timings.inside.clipShrink,
                ease: timings.inside.exitEase,
            };
        }

        function alignInsideExitCircles(mainTl, featureCircles, exit) {
            // Align centers before contraction. The mask and both radii then
            // share one start, duration and ease, including reverse scrubbing.
            [circle1, circle2].forEach((circle, index) => {
                const target = featureCircles.knobPrep[`circle${index + 1}`];
                mainTl.to(circle, {
                    attr: { cx: target.cx, cy: target.cy },
                    x: 0,
                    y: 0,
                    duration: exit.alignDuration,
                    ease: "sine.inOut",
                }, exit.alignStart);
            });
        }

        function getSecondaryChapterTimingProfile() {
            return {
                knob: {
                    introFade: 0.5,
                    preExpand: 1.1,
                    expandLead: 0.45,
                    expandDuration: 2.85,
                    clipSustain: 3,
                    expandEase: "sine.inOut",
                    circleSustain: 3,
                    clipReset: 2.2,
                    circleResetInner: 2.45,
                    circleResetOuter: 2.9,
                    resetHold: 0.35,
                    titleReveal: 1,
                    bodyReveal: 1,
                    bodyRevealDelayMobile: 0.5,
                    ctaReveal: 2,
                    mediaReveal: 2,
                    titleHide: 0.5,
                    mediaFade: 0.5,
                    bodyHide: 2,
                    ctaHide: 2,
                    circleReset: 2,
                },
                quiet: {
                    sectionEnter: 2,
                    titleReveal: 1,
                    bodyReveal: 1,
                    bodyRevealDelay: 2,
                    panelReveal: 2,
                    titleHide: 0.5,
                    bodyHide: 2,
                    ctaHide: 2,
                    panelHide: 2,
                    panelHideDelay: 0.5,
                    circleShift: 2,
                },
                attachments: {
                    sectionEnter: 2,
                    titleReveal: 1,
                    bodyReveal: 1,
                    bodyRevealDelay: 2,
                    ctaReveal: 2,
                    productsReveal: 2,
                    titleHide: 0.5,
                    bodyHide: 2,
                    ctaHide: 2,
                    productsHide: 2,
                    productsHideDelay: 0,
                    leftPanelReveal: 2,
                    circleShift: 1.5,
                },
                about: {
                    attachmentVideoPreFade: 0.45,
                    coverDelay: 0.18,
                    copyHoldDelay: 0.55,
                    storyCopyHoldDelay: 2.4,
                    contentFade: 2,
                    sectionEnterDelay: 0.5,
                    introCircleExpand: 2.7,
                    circleShift: 2,
                    bgFade: 2,
                    titleReveal: 1,
                    bodyReveal: 1,
                    bodyRevealDelay: 2,
                    buttonReveal: 2,
                    titleHide: 0.5,
                    bodyHide: 2,
                    buttonHide: 2,
                    galleryStep: 2,
                    imageScale: 2,
                    imageScaleDelay: 0.5,
                    imageTrackShift: 2,
                    storyCircleShift: 2,
                    storyTitleReveal: 1,
                    storyBodyReveal: 1,
                    storyBodyDelay: 2,
                    storyButtonReveal: 2,
                    storyTitleHide: 0.9,
                    storyBodyHide: 2.8,
                    storyButtonHide: 2.4,
                },
                instagram: {
                    introCircleExpand: 2.7,
                    circleShift: 2,
                    group13Delay: 1,
                    bgFade: 2,
                    titleReveal: 1,
                    bodyReveal: 1,
                    bodyRevealDelay: 2,
                    titleHide: 0.5,
                    bodyHide: 2,
                    cardsMove: 2.6,
                },
            };
        }

        function getSecondaryChapterLayoutProfile(isDesktop) {
            if (isDesktop) {
                const knobClipExpandPercent = 60;
                const knobSustainClipPercent = 64;
                return {
                    knob: {
                        clipExpandPercent: knobClipExpandPercent,
                        sustainClipPercent: knobSustainClipPercent,
                        entryCircle1: {
                            rx: () => clipPathRadius,
                            ry: () => clipPathRadius,
                            cx: () => w * 0.771875,
                            cy: () => h * circleY,
                        },
                        entryCircle2: {
                            rx: () => w * 0.621,
                            ry: () => w * 0.621,
                            cx: () => w * 0.771875,
                            cy: () => h * circleY,
                        },
                        sustainCircle1: {
                            rx: () => clipPathRadius * knobSustainClipPercent / knobClipExpandPercent,
                            ry: () => clipPathRadius * knobSustainClipPercent / knobClipExpandPercent,
                            cx: () => w * 0.771875,
                            cy: () => h * circleY,
                        },
                        sustainCircle2: {
                            rx: () => w * 0.621,
                            ry: () => w * 0.621,
                            cx: () => w * 0.614,
                            cy: () => h * 0.048,
                        },
                        resetCircles: {
                            rx: () => w * 0.015,
                            ry: () => w * 0.015,
                            cx: () => w * 0.771875,
                            cy: () => h * circleY,
                        },
                    },
                    attachments: {
                        handoffCircles: {
                            cy: () => h * 0.5,
                        },
                    },
                    about: {
                        gallerySteps: ["-68.75vw", "-137.5vw", "-206.25vw", "-272.91666667vw"],
                        imageScale: 1.5,
                        introImagesShift: "-33.33333333vw",
                    },
                    instagram: {
                        cardIntroTop: { y: "-100%" },
                        cardIntroBottom: { y: "100%" },
                    },
                };
            }

            return {
                knob: {
                    clipExpandPercent: 50,
                    entryCircle1: {
                        rx: () => h * 0.5 + 1,
                        ry: () => h * 0.5 + 1,
                    },
                    entryCircle2: {
                        rx: () => h * 0.625,
                        ry: () => h * 0.625,
                        cx: () => h * 0.25,
                        cy: () => h * 0.25,
                    },
                    sustainCircle2: {
                        rx: () => h * 0.64,
                        ry: () => h * 0.64,
                        cx: () => h * 0.25 + dw * 0.03,
                        cy: () => h * 0.25 - dw * 0.02,
                    },
                    resetCircles: {
                        rx: () => w * 0.1,
                        ry: () => w * 0.1,
                        cx: () => w * 0.5,
                        cy: () => h * 0.5,
                    },
                },
                attachments: {
                    handoffCircles: {
                        cx: () => w * 0.5,
                        cy: () => h * 1.1,
                    },
                },
                about: {
                    gallerySteps: ["-94dw", "-186vw", "-278vw", "-364vw"],
                    imageScale: 2,
                    introImagesShift: "-88vw",
                },
                instagram: {
                    cardIntroTop: { x: "-100%" },
                    cardIntroBottom: { x: "100%" },
                },
            };
        }

        function getFooterAnimationProfile(isMobileViewport) {
            return {
                float: {
                    circle3Duration: 10,
                    circle4Duration: 12,
                    radiusRange: isMobileViewport ? [h * 0.3, h * 0.6] : [750, 1000],
                    cxRange: isMobileViewport ? [-w * 0.2, w * 1.2] : [-200, 2000],
                    cyRange: isMobileViewport ? [-h * 0.1, h * 1.1] : [-200, 1000],
                },
                timeline: {
                    title: { duration: 1, stagger: 0.2 },
                    text: { duration: 1, stagger: 0.2, delay: 0.25 },
                    subscribe: { y: 60, duration: 2 },
                    background: { duration: 1.5 },
                    bottom: { y: 120, duration: 2, delay: 0.5 },
                    columns: {
                        y: isMobileViewport ? 10 : 30,
                        duration: 0.6,
                        stagger: 0.1,
                        offset: "-=1.5",
                    },
                    columnItems: {
                        y: 30,
                        duration: 0.6,
                        stepDelay: 0.1,
                    },
                },
            };
        }

        function getMainTimelineRuntimeProfile(isNotDesktop, interactionProfile = getHomepageInteractionProfile({ isNotDesktop, isMobileViewport: isMobile })) {
            return {
                inputMode: interactionProfile.inputMode,
                scrollTrigger: {
                    start: "top 50%",
                    end: "+=2000%",
                    scrub: interactionProfile.scroll.scrub.main,
                    pin: true,
                },
                interactions: {
                    scrollEase: interactionProfile.scroll.navigation.ease,
                    scrollDuration: interactionProfile.scroll.navigation.duration,
                    scrollAutoKill: interactionProfile.scroll.navigation.autoKill,
                },
                overlay: {
                    hiddenDisplay: interactionProfile.instagram.hiddenDisplay,
                    readyDisplay: interactionProfile.instagram.readyDisplay,
                },
                instagram: {
                    hoverReadyOffset: interactionProfile.instagram.hoverReadyOffset,
                    hoverEnterThreshold: interactionProfile.instagram.hoverEnterThreshold,
                    hoverExitThreshold: interactionProfile.instagram.hoverExitThreshold,
                },
                chapter: interactionProfile.chapter,
                insideFlow: interactionProfile.insideFlow,
                aboutGallery: interactionProfile.aboutGallery,
                attachmentsFlow: {
                    ...interactionProfile.attachmentsFlow,
                    exitStart: interactionProfile.attachmentsFlow.entryDuration + interactionProfile.attachmentsFlow.holdDuration,
                    animationWindow: interactionProfile.attachmentsFlow.entryDuration + interactionProfile.attachmentsFlow.holdDuration + interactionProfile.attachmentsFlow.exitDuration,
                },
                scroll: {
                    normalizeOnNotDesktop: interactionProfile.scroll.normalizeOnNotDesktop,
                },
            };
        }

        function interpolateSectionLabel(start, end, ratio) {
            if (typeof start !== "number" || typeof end !== "number") return start;
            return start + (end - start) * ratio;
        }

        function buildDerivedSectionLabels(sectionAnchors, sectionRatios, runtimeProfile) {
            const labels = {};
            const knobStart = sectionAnchors.knobStart;
            const quietStart = sectionAnchors.quietStart;
            const attachmentsStart = sectionAnchors.attachmentsStart;
            const aboutStart = sectionAnchors.aboutStart;
            const instagramStart = sectionAnchors.instagramStart;
            const instagramEnd = sectionAnchors.instagramEnd;

            labels.knobIntro = knobStart;
            labels.knobMediaPlay = interpolateSectionLabel(knobStart, quietStart, sectionRatios.knob.mediaPlay);
            labels.knobCopyReveal = interpolateSectionLabel(knobStart, quietStart, sectionRatios.knob.copyReveal);
            labels.knobBodyRevealStart = interpolateSectionLabel(knobStart, quietStart, sectionRatios.knob.bodyRevealStart);
            labels.knobCopyHide = interpolateSectionLabel(knobStart, quietStart, sectionRatios.knob.copyHide);

            labels.quietIntro = quietStart;
            labels.quietCopyHide = interpolateSectionLabel(quietStart, attachmentsStart, sectionRatios.quiet.copyHide);

            labels.attachmentsIntro = attachmentsStart;
            labels.attachmentsCopyHide = interpolateSectionLabel(attachmentsStart, aboutStart, sectionRatios.attachments.copyHide);
            labels.attachmentsDetailsIntro = interpolateSectionLabel(attachmentsStart, aboutStart, sectionRatios.attachments.detailsIntro);
            labels.attachmentItem1Start = labels.attachmentsDetailsIntro + runtimeProfile.attachmentsFlow.entryLead;
            labels.attachmentItem2Start = labels.attachmentItem1Start + runtimeProfile.attachmentsFlow.labelGap;
            labels.attachmentItem3Start = labels.attachmentItem2Start + runtimeProfile.attachmentsFlow.labelGap;
            labels.attachmentItem4Start = labels.attachmentItem3Start + runtimeProfile.attachmentsFlow.labelGap;

            labels.aboutIntro = aboutStart;
            labels.aboutCopyReveal = interpolateSectionLabel(aboutStart, instagramStart, sectionRatios.about.copyReveal);
            labels.aboutPrimaryCopyHide = interpolateSectionLabel(aboutStart, instagramStart, sectionRatios.about.primaryCopyHide);
            labels.aboutGalleryStart = interpolateSectionLabel(aboutStart, instagramStart, sectionRatios.about.galleryStart);
            labels.aboutStoryReveal = interpolateSectionLabel(aboutStart, instagramStart, sectionRatios.about.storyReveal);
            labels.aboutStoryCopyHide = interpolateSectionLabel(aboutStart, instagramStart, sectionRatios.about.storyCopyHide);

            labels.instagramIntro = instagramStart;
            labels.instagramCopyHide = interpolateSectionLabel(instagramStart, instagramEnd, sectionRatios.instagram.copyHide);
            labels.instagramCardsIntro = interpolateSectionLabel(instagramStart, instagramEnd, sectionRatios.instagram.cardsIntro);

            return labels;
        }

        function getMainTimelineLabelsByPlatform(isNotDesktop, runtimeProfile) {
            const labelsBySection = isNotDesktop ? MAIN_TIMELINE_LABELS.mobile : MAIN_TIMELINE_LABELS.desktop;
            const featureTimings = getFeatureInsideTimingProfile(!isNotDesktop, runtimeProfile);
            const secondaryTimings = getSecondaryChapterTimingProfile();
            const sectionRatios = isNotDesktop ? SECTION_LABEL_RATIOS.mobile : SECTION_LABEL_RATIOS.desktop;
            const originalInsideLabels = labelsBySection.featureInside;
            const labels = {
                ...labelsBySection.featureInside,
            };
            const sectionAnchors = {
                ...labelsBySection.sectionAnchors,
            };
            labels.insideCardFocus1 = labels.insideCardsIntro + runtimeProfile.insideFlow.labelGap;
            labels.insideCardFocus2 = labels.insideCardFocus1 + runtimeProfile.insideFlow.labelGap;
            labels.insideCardFocus3 = labels.insideCardFocus2 + runtimeProfile.insideFlow.labelGap;
            const downstreamShift = originalInsideLabels.insideCardFocus3 - labels.insideCardFocus3;
            if (downstreamShift > 0) {
                const appliedDownstreamShift = Math.max(
                    0,
                    downstreamShift - (runtimeProfile.insideFlow.finalHoldGap || 0)
                );
                Object.keys(sectionAnchors).forEach((labelKey) => {
                    sectionAnchors[labelKey] -= appliedDownstreamShift;
                });
            }

            const focus3TrackStart = labels.insideCardFocus3 - (runtimeProfile.insideFlow.transitionLead || 0);
            const featureInsideOutroStart = focus3TrackStart + featureTimings.inside.cardsStep + (runtimeProfile.insideFlow.finalHold || 0);
            const featureInsideOutroDuration = Math.max(
                featureTimings.inside.trackFadeOut,
                featureTimings.inside.clipShrink
            );
            const knobStartMinimum = featureInsideOutroStart + featureInsideOutroDuration - 0.58;
            if (sectionAnchors.knobStart < knobStartMinimum) {
                const knobShift = knobStartMinimum - sectionAnchors.knobStart;
                sectionAnchors.knobStart += knobShift;
                sectionAnchors.quietStart += knobShift;
                sectionAnchors.attachmentsStart += knobShift;
                sectionAnchors.aboutStart += knobShift;
                sectionAnchors.instagramStart += knobShift;
                sectionAnchors.instagramEnd += knobShift;
            }

            const knobCopyHideBase = interpolateSectionLabel(
                sectionAnchors.knobStart,
                sectionAnchors.quietStart,
                sectionRatios.knob.copyHide
            );
            const knobResetEnd = knobCopyHideBase + Math.max(
                secondaryTimings.knob.clipReset,
                secondaryTimings.knob.circleResetInner,
                secondaryTimings.knob.circleResetOuter
            );
            const quietIntroMinimum = knobResetEnd + (secondaryTimings.knob.resetHold || 0);
            if (sectionAnchors.quietStart < quietIntroMinimum) {
                const quietShift = quietIntroMinimum - sectionAnchors.quietStart;
                sectionAnchors.quietStart += quietShift;
                sectionAnchors.attachmentsStart += quietShift;
                sectionAnchors.aboutStart += quietShift;
                sectionAnchors.instagramStart += quietShift;
                sectionAnchors.instagramEnd += quietShift;
            }

            const attachmentsStart = sectionAnchors.attachmentsStart;
            const initialAboutStart = sectionAnchors.aboutStart;
            const initialDetailsIntro = interpolateSectionLabel(
                attachmentsStart,
                initialAboutStart,
                sectionRatios.attachments.detailsIntro
            );
            const projectedAttachmentItem4Start = initialDetailsIntro
                + runtimeProfile.attachmentsFlow.entryLead
                + runtimeProfile.attachmentsFlow.labelGap * (ATTACHMENT_POINT_LABELS.length - 1);
            const attachmentVideoMotionScale = runtimeProfile.viewport?.isNotDesktop ? 1.18 : 1.24;
            const projectedAttachmentVideoEntryDuration = runtimeProfile.attachmentsFlow.entryDuration * attachmentVideoMotionScale;
            const projectedAttachmentVideoCenterBlendDuration = Math.max(
                runtimeProfile.viewport?.isNotDesktop ? 0.04 : 0.06,
                runtimeProfile.attachmentsFlow.holdDuration * 0.18
            );
            const projectedAttachmentVideoExitDuration = runtimeProfile.attachmentsFlow.exitDuration * attachmentVideoMotionScale;
            const projectedAttachmentVideoOverlapLead = Math.max(
                1.08,
                projectedAttachmentVideoExitDuration * (runtimeProfile.viewport?.isNotDesktop ? 1.08 : 1.2)
            );
            const projectedAttachmentItem4VideoStart = Math.max(
                initialDetailsIntro,
                projectedAttachmentItem4Start - projectedAttachmentVideoOverlapLead
            );
            const projectedFinalItemHighlightHold = runtimeProfile.viewport?.isNotDesktop ? 0.08 : 0.1;
            const projectedFinalItemSideExitStart =
                projectedAttachmentItem4VideoStart
                + projectedAttachmentVideoEntryDuration
                + projectedAttachmentVideoCenterBlendDuration
                + projectedFinalItemHighlightHold;
            const targetAboutCoverStartAtFade75 =
                projectedFinalItemSideExitStart
                + projectedAttachmentVideoExitDuration * 0.75;
            const targetAboutIntroStart = targetAboutCoverStartAtFade75 - secondaryTimings.about.coverDelay;
            const minimumAboutIntroStart =
                projectedAttachmentItem4VideoStart
                + Math.max(0.22, projectedAttachmentVideoEntryDuration * 0.22);
            const adjustedAboutStart = Math.max(
                minimumAboutIntroStart,
                Math.min(initialAboutStart, targetAboutIntroStart)
            );
            if (adjustedAboutStart !== initialAboutStart) {
                const aboutShift = adjustedAboutStart - initialAboutStart;
                sectionAnchors.aboutStart += aboutShift;
                sectionAnchors.instagramStart += aboutShift;
                sectionAnchors.instagramEnd += aboutShift;
            }

            Object.assign(labels, buildDerivedSectionLabels(sectionAnchors, sectionRatios, runtimeProfile));
            labels.instagramHoverReady = labels.instagramCardsIntro + runtimeProfile.instagram.hoverReadyOffset;
            return labels;
        }

        function applyInsideReadingPace(labels, runtimeProfile, isNotDesktop) {
            const paced = { ...labels };
            const revealShift = 2;
            const originalGap = labels.insideCardFocus1 - labels.insideCardsIntro;
            const readingGap = isNotDesktop ? 3 : 4.2;
            const originalStep = runtimeProfile.insideFlow.cardsStep;
            const cardsStep = isNotDesktop ? originalStep : 1.65;
            const downstreamShift = revealShift + 3 * (readingGap - originalGap)
                + (cardsStep - originalStep);

            runtimeProfile.insideReadingPace = { drawDuration: 2.4 };
            if (!isNotDesktop) {
                runtimeProfile.insideFlow = {
                    ...runtimeProfile.insideFlow,
                    cardsStep,
                    cardFade: 1.45,
                    imageSwap: 1.55,
                };
            }

            // Extend this chapter's reveal and reading intervals. Shift later
            // chapters together so their internal timings remain unchanged.
            Object.keys(labels).forEach((key) => {
                if (labels[key] >= labels.knobIntro) {
                    paced[key] += downstreamShift;
                } else if (labels[key] >= (labels.featureShiftStart ?? labels.featureCopyReveal)) {
                    paced[key] += revealShift;
                }
            });
            paced.featureSvg2DrawStart += 1;
            CARD_SCROLL_LABELS.forEach((key, index) => {
                paced[key] = paced.insideCardsIntro + readingGap * (index + 1);
            });
            return paced;
        }

        function applyHomepageReadingPace(labels, runtimeProfile, isNotDesktop) {
            const paced = applyInsideReadingPace(labels, runtimeProfile, isNotDesktop);
            const timings = getSecondaryChapterTimingProfile();
            const readingHold = 2.4;
            runtimeProfile.readingHold = readingHold;
            const extendFrom = (label, distance) => {
                if (distance <= 0) return;
                const boundary = paced[label];
                Object.keys(paced).forEach(key => {
                    if (paced[key] >= boundary) paced[key] += distance;
                });
            };
            // Give fully revealed copy and controls a comparable reading window.
            // Insert time at the hold, leaving entry/exit and orbit speeds intact.
            const quietSettle = Math.max(
                timings.quiet.panelReveal,
                timings.quiet.titleReveal + 0.2 * Math.max(0, titleSplits[6].length - 1),
                timings.quiet.bodyReveal + 0.2 * Math.max(0, textSplits[3].length - 1)
            );
            extendFrom('quietCopyHide', quietSettle + readingHold - getQuietChapterMarkers(paced).copyHide);
            const attachmentSettle = Math.max(
                timings.attachments.productsReveal,
                timings.attachments.ctaReveal,
                timings.attachments.titleReveal + 0.2 * Math.max(0, titleSplits[7].length - 1),
                timings.attachments.bodyReveal + 0.2 * Math.max(0, textSplits[4].length - 1)
            );
            extendFrom('attachmentsCopyHide', attachmentSettle + readingHold - (paced.attachmentsCopyHide - paced.attachmentsIntro));
            const attachmentHide = Math.max(
                timings.attachments.titleHide + 0.2 * Math.max(0, titleSplits[7].length - 1),
                timings.attachments.bodyHide, timings.attachments.ctaHide, timings.attachments.productsHide
            );
            extendFrom('attachmentsDetailsIntro', attachmentHide + 0.08 - (paced.attachmentsDetailsIntro - paced.attachmentsCopyHide));
            runtimeProfile.aboutGallery = {
                ...runtimeProfile.aboutGallery,
                travelDuration: Math.max(runtimeProfile.aboutGallery.travelDuration, isNotDesktop ? 8 : 10.5),
            };
            return paced;
        }

        function getMobileInsideCardStages(labelMap) {
            const starts = [
                labelMap.insideCardsIntro + 0.28,
                labelMap.insideCardFocus1,
                labelMap.insideCardFocus2,
            ];
            const ends = [
                labelMap.insideCardFocus1,
                labelMap.insideCardFocus2,
                labelMap.insideCardFocus3,
            ];

            // Each card, machine pose and circle pair settles together, then
            // holds before the next state. Clicks use the same stable interval.
            return starts.map((start, index) => {
                const end = ends[index];
                const duration = Math.min(0.82, (end - start) * 0.55);
                const settled = start + duration;
                return { start, end, duration, settled, target: (settled + end) / 2 };
            });
        }

        function getInsideCardClickTargetTimes(labelMap, runtimeProfile, isNotDesktop) {
            const insideFlow = runtimeProfile?.insideFlow || {};
            const settleRatio = insideFlow.clickSettleRatio ?? 0.3;
            const finalSettleRatio = insideFlow.finalClickSettleRatio ?? 0.2;

            if (isNotDesktop) {
                return getMobileInsideCardStages(labelMap).map(stage => stage.target);
            }

            const cardsStep = insideFlow.cardsStep || 1;
            const introOverlap = insideFlow.introOverlap || 0;
            const transitionLead = insideFlow.transitionLead || 0;
            const introTrackStart = labelMap.insideCardsIntro - introOverlap;
            const focus1TrackStart = labelMap.insideCardFocus1 - transitionLead;
            const focus2TrackStart = labelMap.insideCardFocus2 - transitionLead;
            const focus3TrackStart = labelMap.insideCardFocus3 - transitionLead;
            const insideCircleIntroDuration = Math.max(cardsStep + introOverlap + 0.72, 1.95);
            const insideCircleStageBDuration = Math.max(cardsStep + transitionLead * 0.2 + 0.22, 1.28);
            const insideCircleStageCDuration = Math.max(cardsStep + transitionLead + 0.28, 1.55);
            const circleStageAStart = labelMap.featureSecondaryCopyHideStart - Math.max(introOverlap, 0.56);

            const stableRanges = [
                {
                    start: Math.max(introTrackStart + cardsStep, circleStageAStart + insideCircleIntroDuration),
                    end: focus1TrackStart,
                    ratio: 0.46,
                    fallbackInset: 0.18,
                },
                {
                    start: Math.max(focus1TrackStart + cardsStep, focus1TrackStart + insideCircleStageBDuration),
                    end: focus2TrackStart,
                    ratio: 0.2,
                    fallbackInset: 0.32,
                },
                {
                    start: Math.max(focus2TrackStart + cardsStep, focus2TrackStart + insideCircleStageCDuration),
                    end: focus3TrackStart,
                    ratio: finalSettleRatio,
                    fallbackInset: 0.26,
                },
            ];

            return stableRanges.map(({ start, end, ratio, fallbackInset }) => {
                if (typeof start !== "number") return null;
                if (typeof end !== "number" || end <= start) {
                    return start - fallbackInset;
                }

                return start + (end - start) * ratio;
            });
        }

        function getAmbientMotionLayerProfile(isNotDesktop, runtimeProfile, labels) {
            const baseDistance = isNotDesktop
                ? Math.max(26, Math.min(dw, h) * 0.055)
                : Math.max(30, Math.min(w, h) * 0.042);
            const featureDistance = isNotDesktop ? baseDistance * 0.42 : baseDistance * 0.58;

            return {
                flowRatio: 0.62,
                travelBlend: 0.88,
                settleBlend: 0.26,
                ease: "none",
                segments: [
                    {
                        startLabel: "featureShiftStart",
                        endLabel: "featureSecondaryRevealStart",
                        flowRatio: 0.68,
                        targets: [
                            { node: circle1, x: 0, y: 0 },
                            { node: circle2, x: 0, y: 0 },
                        ],
                    },
                    {
                        startLabel: "featureSecondaryRevealStart",
                        endLabel: "insideCardsIntro",
                        flowRatio: 0.66,
                        targets: [
                            { node: circle1, x: 0, y: 0 },
                            { node: circle2, x: 0, y: 0 },
                        ],
                    },
                    {
                        startLabel: "insideCardsIntro",
                        endLabel: "insideCardFocus1",
                        flowRatio: 0.64,
                        targets: [
                            { node: circle1, x: 0, y: 0 },
                            { node: circle2, x: 0, y: 0 },
                        ],
                    },
                    {
                        startLabel: "insideCardFocus1",
                        endLabel: "insideCardFocus2",
                        flowRatio: 0.64,
                        targets: [
                            { node: circle1, x: 0, y: 0 },
                            { node: circle2, x: 0, y: 0 },
                        ],
                    },
                    {
                        startLabel: "insideCardFocus2",
                        endLabel: "insideCardFocus3",
                        flowRatio: 0.62,
                        targets: [
                            { node: circle1, x: 0, y: 0 },
                            { node: circle2, x: 0, y: 0 },
                        ],
                    },
                    {
                        startLabel: "quietIntro",
                        endLabel: "quietCopyHide",
                        targets: [
                            { node: circle1, x: -baseDistance * 0.42, y: baseDistance * 0.28 },
                            { node: circle2, x: -baseDistance * 0.42, y: baseDistance * 0.28 },
                        ],
                    },
                    {
                        startLabel: "attachmentsIntro",
                        endLabel: "attachmentsCopyHide",
                        targets: [
                            { node: circle1, x: 0, y: 0 },
                            { node: circle2, x: 0, y: 0 },
                        ],
                    },
                    {
                        startLabel: "aboutCopyReveal",
                        endLabel: "aboutPrimaryCopyHide",
                        targets: [
                            { node: circle1, x: 0, y: 0 },
                            { node: circle2, x: 0, y: 0 },
                        ],
                    },
                    {
                        startLabel: "aboutStoryReveal",
                        endLabel: "aboutStoryCopyHide",
                        targets: [
                            { node: circle1, x: 0, y: 0 },
                            { node: circle2, x: 0, y: 0 },
                        ],
                    },
                    {
                        startLabel: "instagramIntro",
                        endLabel: "instagramCopyHide",
                        targets: [
                            { node: circle1, x: 0, y: 0 },
                            { node: circle2, x: 0, y: 0 },
                            { node: circle3, x: 0, y: 0 },
                            { node: circle4, x: 0, y: 0 },
                        ],
                    },
                ],
                reset: {
                    startLabel: "instagramCopyHide",
                    endLabel: "instagramHoverReady",
                    nodes: [circle1, circle2, circle3, circle4],
                },
            };
        }

        function getAmbientSegmentNodeTarget(segment, node) {
            if (!segment || !node) return { x: 0, y: 0 };

            const target = segment.targets.find((item) => item.node === node);
            return target ? { x: target.x, y: target.y } : { x: 0, y: 0 };
        }

        function interpolateAmbientPoint(fromPoint, toPoint, progress) {
            return {
                x: gsap.utils.interpolate(fromPoint.x, toPoint.x, progress),
                y: gsap.utils.interpolate(fromPoint.y, toPoint.y, progress),
            };
        }

        function addAmbientMotionSegment(layerTimeline, labelMap, segments, segmentIndex, profile) {
            const segment = segments[segmentIndex];
            const start = labelMap[segment.startLabel];
            const end = labelMap[segment.endLabel];
            if (typeof start !== "number" || typeof end !== "number" || end <= start) return;

            const flowRatio = segment.flowRatio ?? profile.flowRatio;
            const travelBlend = segment.travelBlend ?? profile.travelBlend;
            const settleBlend = segment.settleBlend ?? profile.settleBlend;
            const ease = segment.ease ?? profile.ease;
            const totalDuration = end - start;
            const flowDuration = Math.max(0.24, totalDuration * flowRatio);
            const settleDuration = Math.max(0.24, totalDuration - flowDuration);
            const settlePosition = start + flowDuration;
            const previousSegment = segments[segmentIndex - 1] || null;
            const nextSegment = segments[segmentIndex + 1] || null;

            segment.targets.forEach(({ node, x, y }) => {
                if (!node) return;

                const previousTarget = getAmbientSegmentNodeTarget(previousSegment, node);
                const currentTarget = { x, y };
                const nextTarget = getAmbientSegmentNodeTarget(nextSegment, node);
                const flowTarget = interpolateAmbientPoint(previousTarget, currentTarget, travelBlend);
                const settleTarget = interpolateAmbientPoint(currentTarget, nextTarget, settleBlend);

                layerTimeline.to(node, {
                    x: flowTarget.x,
                    y: flowTarget.y,
                    duration: flowDuration,
                    ease,
                }, start);

                layerTimeline.to(node, {
                    x: settleTarget.x,
                    y: settleTarget.y,
                    duration: settleDuration,
                    ease,
                }, settlePosition);
            });
        }

        function addAmbientMotionLayer(mainTl, labelMap, runtimeProfile, isNotDesktop) {
            const ambientProfile = getAmbientMotionLayerProfile(isNotDesktop, runtimeProfile, labelMap);
            const ambientTl = gsap.timeline();

            ambientTl.set([circle1, circle2, circle3, circle4], { x: 0, y: 0 }, 0);
            ambientProfile.segments.forEach((segment, segmentIndex) => {
                addAmbientMotionSegment(ambientTl, labelMap, ambientProfile.segments, segmentIndex, ambientProfile);
            });

            const resetStart = labelMap[ambientProfile.reset.startLabel];
            const resetEnd = labelMap[ambientProfile.reset.endLabel];
            if (typeof resetStart === "number" && typeof resetEnd === "number" && resetEnd > resetStart) {
                ambientTl.to(ambientProfile.reset.nodes, {
                    x: 0,
                    y: 0,
                    duration: resetEnd - resetStart,
                    ease: "none",
                }, resetStart);
            }

            mainTl.add(ambientTl, 0);
        }

        function getInsideCardSoftFlowProfile(isNotDesktop, runtimeProfile) {
            const cardTargets = isNotDesktop ? cardWrappers : cardList;
            const liftScale = runtimeProfile?.insideFlow?.softLiftScale || 1;

            return {
                segments: [
                    {
                        startLabel: "insideCardsIntro",
                        endLabel: "insideCardFocus1",
                        card: cardTargets[0],
                        cardLift: -2.4 * liftScale,
                    },
                    {
                        startLabel: "insideCardFocus1",
                        endLabel: "insideCardFocus2",
                        card: cardTargets[1],
                        cardLift: -3 * liftScale,
                    },
                    {
                        startLabel: "insideCardFocus2",
                        endLabel: "insideCardFocus3",
                        card: cardTargets[2],
                        cardLift: -3.6 * liftScale,
                    },
                ],
            };
        }

        function addInsideCardSoftFlowLayer(mainTl, labelMap, runtimeProfile, isNotDesktop) {
            // Mobile wrappers already have a full enter/exit path. A second
            // yPercent layer would override it while scrubbing or reversing.
            if (isNotDesktop) return;
            const profile = getInsideCardSoftFlowProfile(isNotDesktop, runtimeProfile);
            const layerTimeline = gsap.timeline();
            const resetStart = labelMap.insideCardFocus3;
            const resetEnd = labelMap.knobIntro;

            profile.segments.forEach((segment) => {
                const start = labelMap[segment.startLabel];
                const end = labelMap[segment.endLabel];
                if (typeof start !== "number" || typeof end !== "number" || end <= start) return;

                const totalDuration = end - start;
                const enterDuration = Math.max(0.2, totalDuration * 0.62);
                const settleDuration = Math.max(0.2, totalDuration - enterDuration);
                const settlePosition = start + enterDuration;

                if (segment.card) {
                    layerTimeline.to(segment.card, {
                        yPercent: segment.cardLift,
                        duration: enterDuration,
                        ease: "none",
                    }, start);

                    layerTimeline.to(segment.card, {
                        yPercent: 0,
                        duration: settleDuration,
                        ease: "none",
                    }, settlePosition);
                }
            });

            if (typeof resetStart === "number" && typeof resetEnd === "number" && resetEnd > resetStart) {
                if (isNotDesktop) {
                    layerTimeline.to(cardWrappers, {
                        yPercent: 0,
                        duration: resetEnd - resetStart,
                        ease: "none",
                    }, resetStart);
                } else {
                    layerTimeline.to(cardList, {
                        yPercent: 0,
                        duration: resetEnd - resetStart,
                        ease: "none",
                    }, resetStart);
                }
            }

            mainTl.add(layerTimeline, 0);
        }

        function getAboutGalleryFlowProfile(runtimeProfile, layoutProfile) {
            const gallerySteps = layoutProfile.about.gallerySteps;
            const finalGalleryPosition = gallerySteps[gallerySteps.length - 1];
            const travelDuration = runtimeProfile.aboutGallery.travelDuration;

            return {
                finalGalleryPosition,
                travelDuration,
                scaleStartOffset: travelDuration * runtimeProfile.aboutGallery.scaleStartProgress,
                introImagesStartOffset: travelDuration * runtimeProfile.aboutGallery.introImagesStartProgress,
            };
        }

        function getKnobChapterMarkers(labelMap, timings, isDesktop) {
            const knobRatios = isDesktop ? SECTION_LABEL_RATIOS.desktop.knob : SECTION_LABEL_RATIOS.mobile.knob;
            const chapterDuration = Math.max(0.1, (labelMap.quietIntro || 0) - (labelMap.knobIntro || 0));
            const introFadeEnd = timings.knob.introFade;
            const copyReveal = chapterDuration * knobRatios.copyReveal;
            const bodyRevealStart = chapterDuration * knobRatios.bodyRevealStart;
            const backgroundExitStart = chapterDuration * knobRatios.copyHide;
            const copyHoldDelay = Math.min(
                Math.max(chapterDuration * 0.12, 0.64),
                1.12
            );
            const copyHideDuration = Math.max(
                timings.knob.titleHide + 0.2 * Math.max(0, (titleSplits[5]?.length || 1) - 1),
                timings.knob.bodyHide,
                timings.knob.ctaHide
            );
            const copyHideStart = Math.min(
                backgroundExitStart + copyHoldDelay,
                Math.max(0, chapterDuration - copyHideDuration - 0.08)
            );
            const mediaPlay = chapterDuration * knobRatios.mediaPlay;
            const expandStart = Math.max(mediaPlay + 0.08, introFadeEnd + 0.04);
            const expandEnd = expandStart + timings.knob.expandDuration;
            const sustainStart = Math.max(expandEnd, copyReveal + 0.2);
            const sustainDuration = Math.max(0.6, backgroundExitStart - sustainStart);

            return {
                chapterDuration,
                mediaPlay,
                copyReveal,
                bodyRevealStart,
                backgroundExitStart,
                copyHideStart,
                copyHideDuration,
                expandStart,
                expandEnd,
                sustainStart,
                sustainDuration,
            };
        }

        function getKnobEntryMarkers(labelMap, timings, isDesktop, runtimeProfile) {
            const markers = getKnobChapterMarkers(labelMap, timings, isDesktop);
            const exit = getInsideExitProfile(
                labelMap, getFeatureInsideTimingProfile(isDesktop, runtimeProfile), runtimeProfile, isDesktop
            );
            const entryStart = exit.start + exit.duration;
            const offset = labelMap.knobIntro - entryStart;
            // Use the outgoing mask's end as the new scene's entry. Keep copy,
            // media and later chapter anchors at their approved absolute times.
            return {
                ...markers,
                entryStart,
                contentEnter: Math.max(0, offset),
                copyReveal: markers.copyReveal + offset,
                bodyRevealStart: markers.bodyRevealStart + offset,
                backgroundExitStart: markers.backgroundExitStart + offset,
                copyHideStart: markers.copyHideStart + offset,
                expandStart: 0,
                expandDuration: markers.expandEnd + offset,
                sustainStart: markers.sustainStart + offset,
            };
        }

        function createMobileKnobChapterTimeline(labelMap, runtimeProfile) {
            const timings = getSecondaryChapterTimingProfile();
            const layout = getSecondaryChapterLayoutProfile(false);
            const markers = getKnobEntryMarkers(labelMap, timings, false, runtimeProfile);
            const knobHideComplete = markers.copyHideStart + markers.copyHideDuration;

            return gsap.timeline()
                .set(knobContent, { autoAlpha: 1 }, markers.contentEnter)
                .set(knobImg, {
                    clipPath: () => getKnobEntryClipPath(false),
                }, 0)
                .to(knobImg, { opacity: 1, duration: timings.knob.introFade }, 0)
                .to(knobSection, { zIndex: 15, duration: timings.knob.introFade }, 0)
                .to(knobImg, {
                    clipPath: getKnobClipPath(layout.knob.clipExpandPercent, false),
                    duration: markers.expandDuration,
                    ease: timings.knob.expandEase,
                }, markers.expandStart)
                .to(circle1, {
                    attr: layout.knob.entryCircle1,
                    x: 0,
                    y: 0,
                    duration: markers.expandDuration,
                    ease: timings.knob.expandEase,
                }, markers.expandStart)
                .to(circle2, {
                    attr: layout.knob.entryCircle2,
                    x: 0,
                    y: 0,
                    duration: markers.expandDuration,
                    ease: timings.knob.expandEase,
                }, markers.expandStart)
                .fromTo(titleSplits[5], { y: "110%", opacity: 1 }, { y: "0%", stagger: 0.2, duration: timings.knob.titleReveal, opacity: 1, immediateRender: false }, markers.copyReveal)
                .fromTo(textSplits[2], { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: timings.knob.bodyReveal, stagger: 0.2, immediateRender: false }, markers.bodyRevealStart)
                .from(knobButton, { opacity: 0, y: "200%", duration: timings.knob.ctaReveal }, "<")
                .from(knobVideoWrapper, { scale: 0.0001, y: "50%", duration: timings.knob.mediaReveal }, "<")
                .to(knobImg, {
                    clipPath: getKnobClipPath(layout.knob.clipExpandPercent, false),
                    duration: markers.sustainDuration,
                    ease: "none",
                }, markers.sustainStart)
                // As in Quiet's reading interval, keep subtle background motion
                // while copy holds. The image and first ring stay concentric.
                .to(circle2, {
                    attr: layout.knob.sustainCircle2,
                    duration: markers.sustainDuration,
                    ease: "none",
                }, markers.sustainStart)
                .to(knobVideo, { opacity: 0, duration: timings.knob.mediaFade }, markers.backgroundExitStart)
                .to(knobImg, {
                    clipPath: getKnobClipPath(0, false),
                    duration: timings.knob.clipReset,
                    ease: "sine.in",
                }, "<")
                .to(circle1, {
                    attr: layout.knob.resetCircles,
                    duration: timings.knob.circleResetInner,
                    ease: "sine.inOut",
                }, "<")
                .to(circle2, {
                    attr: layout.knob.resetCircles,
                    duration: timings.knob.circleResetOuter,
                    ease: "sine.inOut",
                }, "<")
                .fromTo(titleSplits[5], { opacity: 1 }, { opacity: 0, stagger: 0.2, duration: timings.knob.titleHide, immediateRender: false }, markers.copyHideStart)
                .fromTo(textSplits[2], { opacity: 1 }, { opacity: 0, duration: timings.knob.bodyHide, immediateRender: false }, "<")
                .to(knobButton, { opacity: 0, duration: timings.knob.ctaHide }, "<")
                .set(knobContent, { autoAlpha: 0 }, knobHideComplete);
        }

        function createDesktopKnobChapterTimeline(labelMap, runtimeProfile) {
            const timings = getSecondaryChapterTimingProfile();
            const layout = getSecondaryChapterLayoutProfile(true);
            const markers = getKnobEntryMarkers(labelMap, timings, true, runtimeProfile);
            const knobHideComplete = markers.copyHideStart + markers.copyHideDuration;

            return gsap.timeline()
                .set(knobContent, { autoAlpha: 1 }, markers.contentEnter)
                .set(knobImg, {
                    clipPath: () => getKnobEntryClipPath(true),
                }, 0)
                .to(knobImg, { opacity: 1, duration: timings.knob.introFade }, 0)
                .to(knobSection, { zIndex: 15, duration: timings.knob.introFade }, 0)
                .to(knobImg, {
                    clipPath: getKnobClipPath(layout.knob.clipExpandPercent, true),
                    duration: markers.expandDuration,
                    ease: timings.knob.expandEase,
                }, markers.expandStart)
                .to(circle1, {
                    attr: layout.knob.entryCircle1,
                    duration: markers.expandDuration,
                    ease: timings.knob.expandEase,
                }, markers.expandStart)
                .to(circle2, {
                    attr: layout.knob.entryCircle2,
                    duration: markers.expandDuration,
                    ease: timings.knob.expandEase,
                }, markers.expandStart)
                .fromTo(titleSplits[5], { y: "110%", opacity: 1 }, { y: "0%", stagger: 0.2, duration: timings.knob.titleReveal, opacity: 1, immediateRender: false }, markers.copyReveal)
                .fromTo(textSplits[2], { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: timings.knob.bodyReveal, stagger: 0.2, immediateRender: false }, markers.bodyRevealStart)
                .from(knobButton, { opacity: 0, y: "200%", duration: timings.knob.ctaReveal }, "<")
                .from(knobVideoWrapper, { scale: 0.0001, y: "50%", duration: timings.knob.mediaReveal }, "<")
                .to(knobImg, {
                    clipPath: getKnobClipPath(layout.knob.sustainClipPercent, true),
                    duration: markers.sustainDuration,
                    ease: "none",
                }, markers.sustainStart)
                .to(circle1, {
                    attr: layout.knob.sustainCircle1,
                    duration: markers.sustainDuration,
                    ease: "none",
                }, markers.sustainStart)
                .to(circle2, {
                    attr: layout.knob.sustainCircle2,
                    duration: markers.sustainDuration,
                    ease: "none",
                }, markers.sustainStart)
                .to(knobVideo, { opacity: 0, duration: timings.knob.mediaFade }, markers.backgroundExitStart)
                .to(knobImg, {
                    clipPath: getKnobClipPath(0, true),
                    duration: timings.knob.clipReset,
                    ease: "sine.in",
                }, "<")
                .to(circle1, {
                    attr: layout.knob.resetCircles,
                    duration: timings.knob.circleResetInner,
                    ease: "sine.inOut",
                }, "<")
                .to(circle2, {
                    attr: layout.knob.resetCircles,
                    duration: timings.knob.circleResetOuter,
                    ease: "sine.inOut",
                }, "<")
                .fromTo(titleSplits[5], { opacity: 1 }, { opacity: 0, stagger: 0.2, duration: timings.knob.titleHide, immediateRender: false }, markers.copyHideStart)
                .fromTo(textSplits[2], { opacity: 1 }, { opacity: 0, duration: timings.knob.bodyHide, immediateRender: false }, "<")
                .to(knobButton, { opacity: 0, duration: timings.knob.ctaHide }, "<")
                .set(knobContent, { autoAlpha: 0 }, knobHideComplete);
        }

        function getQuietChapterMarkers(labelMap) {
            const chapterStart = labelMap.quietIntro || 0;
            const nominalCopyHide = Math.max(0, (labelMap.quietCopyHide || chapterStart) - chapterStart);
            const chapterEnd = Math.max(chapterStart, labelMap.attachmentsIntro || chapterStart);
            const chapterDuration = Math.max(0.1, chapterEnd - chapterStart);
            const timings = getSecondaryChapterTimingProfile();
            const copyHideDuration = Math.max(
                timings.quiet.titleHide + 0.2 * Math.max(0, (titleSplits[6]?.length || 1) - 1),
                timings.quiet.bodyHide,
                timings.quiet.ctaHide,
                timings.quiet.panelHideDelay + timings.quiet.panelHide
            );
            const copyHide = Math.min(nominalCopyHide, Math.max(0, chapterDuration - copyHideDuration - 0.08));
            const circleBreathStart = Math.max(timings.quiet.circleShift * 0.72, 0.36);
            const circleBreathDuration = Math.max(
                0.72,
                chapterDuration - circleBreathStart - 0.04
            );

            return {
                copyHide,
                panelHideStart: copyHide + timings.quiet.panelHideDelay,
                circleBreathStart,
                circleBreathDuration,
            };
        }

        function createMobileQuietChapterTimeline(labelMap) {
            const circleTransitions = getPlatformCircleTransitions(false);
            const quietBreathTargets = getQuietCircleBreathTargets(false);
            const timings = getSecondaryChapterTimingProfile();
            const markers = getQuietChapterMarkers(labelMap);
            const quietHideComplete = markers.panelHideStart + timings.quiet.panelHide;

            return gsap.timeline()
                .set(quietContent, { autoAlpha: 1 }, 0)
                .to(circle1, { attr: circleTransitions.quietIntro.circle1, duration: timings.quiet.circleShift }, 0)
                .to(circle2, { attr: circleTransitions.quietIntro.circle2, duration: timings.quiet.circleShift }, 0.18)
                .to(circle1, {
                    attr: quietBreathTargets.circle1,
                    duration: markers.circleBreathDuration,
                    ease: "none",
                }, markers.circleBreathStart)
                .to(circle2, {
                    attr: quietBreathTargets.circle2,
                    duration: markers.circleBreathDuration,
                    ease: "none",
                }, markers.circleBreathStart)
                .to(quietSection, { zIndex: 16, duration: timings.quiet.sectionEnter }, 0)
                .fromTo(titleSplits[6], { y: "110%", opacity: 1 }, { y: "0%", stagger: 0.2, duration: timings.quiet.titleReveal, opacity: 1, immediateRender: false }, 0)
                .fromTo(textSplits[3], { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: timings.quiet.bodyReveal, stagger: 0.2, immediateRender: false }, 0)
                .from(quietAudioPanel, { opacity: 0, y: "50%", duration: timings.quiet.panelReveal }, 0)
                .fromTo(titleSplits[6], { opacity: 1 }, { opacity: 0, stagger: 0.2, duration: timings.quiet.titleHide, immediateRender: false }, markers.copyHide)
                .fromTo(textSplits[3], { opacity: 1 }, { opacity: 0, duration: timings.quiet.bodyHide, immediateRender: false }, "<")
                .to(quietButton, { opacity: 0, duration: timings.quiet.ctaHide }, "<")
                .to(quietAudioPanel, { opacity: 0, duration: timings.quiet.panelHide }, markers.panelHideStart)
                .set(quietContent, { autoAlpha: 0 }, quietHideComplete);
        }

        function createDesktopQuietChapterTimeline(labelMap) {
            const circleTransitions = getPlatformCircleTransitions(true);
            const quietBreathTargets = getQuietCircleBreathTargets(true);
            const timings = getSecondaryChapterTimingProfile();
            const markers = getQuietChapterMarkers(labelMap);
            const quietHideComplete = markers.panelHideStart + timings.quiet.panelHide;

            return gsap.timeline()
                .set(quietContent, { autoAlpha: 1 }, 0)
                .to(circle1, { attr: circleTransitions.quietIntro.circle1, duration: timings.quiet.circleShift }, 0)
                .to(circle2, { attr: circleTransitions.quietIntro.circle2, duration: timings.quiet.circleShift }, 0.18)
                .to(circle1, {
                    attr: quietBreathTargets.circle1,
                    duration: markers.circleBreathDuration,
                    ease: "none",
                }, markers.circleBreathStart)
                .to(circle2, {
                    attr: quietBreathTargets.circle2,
                    duration: markers.circleBreathDuration,
                    ease: "none",
                }, markers.circleBreathStart)
                .to(quietSection, { zIndex: 16, duration: timings.quiet.sectionEnter }, 0)
                .fromTo(titleSplits[6], { y: "110%", opacity: 1 }, { y: "0%", stagger: 0.2, duration: timings.quiet.titleReveal, opacity: 1, immediateRender: false }, 0)
                .fromTo(textSplits[3], { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: timings.quiet.bodyReveal, stagger: 0.2, immediateRender: false }, 0)
                .from(quietAudioPanel, { opacity: 0, y: "50%", duration: timings.quiet.panelReveal }, 0)
                .fromTo(titleSplits[6], { opacity: 1 }, { opacity: 0, stagger: 0.2, duration: timings.quiet.titleHide, immediateRender: false }, markers.copyHide)
                .fromTo(textSplits[3], { opacity: 1 }, { opacity: 0, duration: timings.quiet.bodyHide, immediateRender: false }, "<")
                .to(quietButton, { opacity: 0, duration: timings.quiet.ctaHide }, "<")
                .to(quietAudioPanel, { opacity: 0, duration: timings.quiet.panelHide }, markers.panelHideStart)
                .set(quietContent, { autoAlpha: 0 }, quietHideComplete);
        }

        function buildMobileFeatureInside(mainTl, runtimeProfile) {
            const featureCircles = getFeatureInsideCircleTransitions(false);
            const timings = getFeatureInsideTimingProfile(false, runtimeProfile);
            const labelTimes = mainTl.labels || {};
            const cardStages = getMobileInsideCardStages(labelTimes);
            const mobileCopyHold = 0.22;
            const exit = getInsideExitProfile(labelTimes, timings, runtimeProfile, false);
            const secondaryCopyHideStart = `insideCardsIntro+=${mobileCopyHold}`;
            mainTl
                .set(outContent, { autoAlpha: 1 }, 0)
                .set(insideContent, { autoAlpha: 0 }, 0)
                .to(svg1Shapes, { drawSVG: "0%", duration: timings.draw }, "featureDrawStart")
                .to(circle1, { attr: featureCircles.featureStroke.circle1, duration: timings.draw }, `<+=${timings.strokeDelay}`)
                .to(circle2, { attr: featureCircles.featureStroke.circle2, duration: timings.draw }, "<")
                .fromTo(svg2Shapes, { drawSVG: "0%" }, { drawSVG: "100%", duration: timings.svg2Draw }, "featureSvg2DrawStart")
                .to(svg2Container, { opacity: 0, duration: timings.feature.svgFade }, ">")
                .to(insideOutImage1, { opacity: 1, duration: timings.feature.imageFade }, "<")
                .to(insideOutImageWrap, { opacity: 0, duration: timings.feature.wrapFade }, ">")
                .to(circle1, { attr: featureCircles.featureExpand.circle1, duration: timings.feature.circleExpand }, "<")
                .to(circle2, { attr: featureCircles.featureExpand.circle2, duration: timings.feature.circleExpand }, "<")
                .fromTo(titleSplits[3], { y: "110%", opacity: 1 }, { y: "0%", stagger: 0.2, duration: timings.feature.titleReveal, opacity: 1, immediateRender: false }, "<")
                .fromTo(textSplits[0], { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: timings.feature.bodyReveal, stagger: 0.2, immediateRender: false }, "featureCopyReveal")
                .from(outButton, { opacity: 0, y: "200%", duration: timings.feature.buttonReveal }, "<")
                .fromTo(titleSplits[3], { opacity: 1 }, { opacity: 0, stagger: 0.2, duration: timings.feature.titleHide, immediateRender: false }, "featurePrimaryFadeStart")
                .fromTo(textSplits[0], { opacity: 1 }, { opacity: 0, duration: timings.feature.bodyHidePrimary, immediateRender: false }, "<")
                .to(outButton, { opacity: 0, duration: timings.feature.buttonHide }, "<")
                .set(outContent, { autoAlpha: 0 }, "featureSecondaryRevealStart")
                .set(insideContent, { autoAlpha: 1 }, "featureSecondaryRevealStart")
                .set(insideCopyStage, { autoAlpha: 1 }, "featureSecondaryRevealStart")
                .set(insideCardsStage, { autoAlpha: 1 }, "featureSecondaryRevealStart")
                .fromTo(titleSplits[4], { y: "110%", opacity: 1 }, { y: "0%", stagger: 0.2, duration: timings.feature.titleReveal, opacity: 1, immediateRender: false }, "featureSecondaryRevealStart")
                .fromTo(textSplits[1], { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: timings.feature.bodyReveal, stagger: 0.2, immediateRender: false }, "featureSecondaryRevealStart")
                .to(insideOutImageWrap, { y: "-50%", opacity: 1, duration: timings.feature.secondaryWrapReveal }, "<")
                .to(circle1, { attr: featureCircles.featureSecondary.circle1, duration: timings.feature.circleExpand }, "<")
                .to(circle2, { attr: featureCircles.featureSecondary.circle2, duration: timings.feature.circleExpand }, "<")
                .to(insideCopyStage, { autoAlpha: 0, duration: 0.28 }, secondaryCopyHideStart)

                .set(insideCardsTrack, { opacity: 1 }, cardStages[0].start)
                .set(cards, { opacity: 1 }, 0)
                .set(cardWrappers, { autoAlpha: 0, yPercent: 32 }, 0);

            const machinePoses = [insideOutImage1, insideOutImage2, insideOutImage3, insideOutImage4];
            const circleStages = [featureCircles.insideStageA, featureCircles.insideStageB, featureCircles.insideStageC];
            cardStages.forEach((stage, index) => {
                const enterDelay = stage.duration * 0.28;
                if (index > 0) {
                    mainTl.to(cardWrappers[index - 1], {
                        autoAlpha: 0, yPercent: -28,
                        duration: stage.duration * 0.62, ease: "power1.out",
                    }, stage.start);
                }
                mainTl.fromTo(cardWrappers[index],
                    { autoAlpha: 0, yPercent: 32 },
                    { autoAlpha: 1, yPercent: 0, duration: stage.duration - enterDelay, ease: "power2.out", immediateRender: false },
                    stage.start + enterDelay)
                    .to(machinePoses[index], { opacity: 0, duration: stage.duration, ease: "sine.inOut" }, stage.start)
                    .to(machinePoses[index + 1], { opacity: 1, duration: stage.duration, ease: "sine.inOut" }, stage.start)
                    .to(circle1, { attr: circleStages[index].circle1, duration: stage.duration, ease: "sine.inOut" }, stage.start)
                    .to(circle2, { attr: circleStages[index].circle2, duration: stage.duration, ease: "sine.inOut" }, stage.start);
            });

            alignInsideExitCircles(mainTl, featureCircles, exit);
            return mainTl
                .to(cardWrappers[2], { yPercent: -28, duration: timings.inside.trackFadeOut, ease: "power1.in" }, "insideCardFocus3")
                .to(insideCardsTrack, { opacity: 0, duration: timings.inside.trackFadeOut }, "insideCardFocus3")
                .fromTo(
                    insideOutImage4,
                    {
                        clipPath: "circle(80% at 65.3% 24.85%)"
                    },
                    {
                        clipPath: "circle(6% at 65.3% 24.85%)",
                        duration: exit.duration,
                        ease: exit.ease,
                    }, exit.start)
                .to(insideOutImage4, {
                    opacity: 0,
                    duration: 0.2,
                }, exit.start + exit.duration)
                .to(circle1, {
                    attr: featureCircles.knobPrep.circle1,
                    x: 0,
                    y: 0,
                    duration: exit.duration,
                    ease: exit.ease,
                }, exit.start)
                .to(circle2, {
                    attr: featureCircles.knobPrep.circle2,
                    x: 0,
                    y: 0,
                    duration: exit.duration,
                    ease: exit.ease,
                }, exit.start)
                .set(insideContent, { autoAlpha: 0 }, "knobIntro");
        }

        function buildMobileKnobChapter(mainTl, labelMap, runtimeProfile) {
            const markers = getKnobEntryMarkers(labelMap, getSecondaryChapterTimingProfile(), false, runtimeProfile);
            mainTl.add(createMobileKnobChapterTimeline(labelMap, runtimeProfile), markers.entryStart);
            return mainTl;
        }

        function buildMobileQuietChapter(mainTl, labelMap) {
            mainTl.add(createMobileQuietChapterTimeline(labelMap), labelMap.quietIntro);
            return mainTl;
        }

        function buildMobileAttachmentsChapter(mainTl, labelMap) {
            const timings = getSecondaryChapterTimingProfile();
            const layout = getSecondaryChapterLayoutProfile(false);
            const attachmentsBottomSlideReveal = Math.min(
                0.48,
                Math.max(0.24, timings.attachments.leftPanelReveal * 0.2)
            );
            const attachmentsIntro = labelMap.attachmentsIntro || 0;
            const attachmentsDetailsIntro = labelMap.attachmentsDetailsIntro || attachmentsIntro;
            const attachmentsCircleTravelWindow = Math.max(
                0.6,
                attachmentsDetailsIntro - attachmentsIntro
            );
            const attachmentsCircleEntryDuration = Math.min(
                timings.quiet.circleShift,
                Math.max(0.48, attachmentsCircleTravelWindow * 0.62)
            );
            const attachmentsCircleHandoffStart = attachmentsIntro + attachmentsCircleEntryDuration;
            const attachmentsCircleHandoffDuration = Math.max(
                0.24,
                attachmentsCircleTravelWindow - attachmentsCircleEntryDuration
            );
            return mainTl
                .set(attSection, { autoAlpha: 1, pointerEvents: "auto" }, "attachmentsIntro")
                .set(attContentTop, { autoAlpha: 1 }, "attachmentsIntro")
                .set(attContentBottom, { autoAlpha: 0 }, "attachmentsIntro")
                .to(circle1, { attr: getPlatformCircleTransitions(false).quietToAttachments.circle1, duration: attachmentsCircleEntryDuration }, "attachmentsIntro")
                .to(circle2, { attr: getPlatformCircleTransitions(false).quietToAttachments.circle2, duration: attachmentsCircleEntryDuration }, "attachmentsIntro")
                .to([circle1, circle2], {
                    attr: layout.attachments.handoffCircles,
                    duration: attachmentsCircleHandoffDuration,
                    ease: "power1.in",
                }, attachmentsCircleHandoffStart)
                .to(attSection, { zIndex: 17, duration: timings.attachments.sectionEnter }, "attachmentsIntro")
                .fromTo(titleSplits[7], { y: "110%", opacity: 1 }, { y: "0%", stagger: 0.2, duration: timings.attachments.titleReveal, opacity: 1, immediateRender: false }, "<")
                .from(attProductsWrapper, { opacity: 0, y: "50%", duration: timings.attachments.productsReveal }, "attachmentsIntro")
                .fromTo(textSplits[4], { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: timings.attachments.bodyReveal, stagger: 0.2, immediateRender: false }, "attachmentsIntro")
                .from(attButton, { opacity: 0, y: "200%", duration: timings.attachments.ctaReveal }, "<")
                .fromTo(titleSplits[7], { opacity: 1 }, { opacity: 0, stagger: 0.2, duration: timings.attachments.titleHide, immediateRender: false }, "attachmentsCopyHide")
                .fromTo(textSplits[4], { opacity: 1 }, { opacity: 0, duration: timings.attachments.bodyHide, immediateRender: false }, "<")
                .to(attButton, { opacity: 0, duration: timings.attachments.ctaHide }, "<")
                .to(attProductsWrapper, { opacity: 0, duration: timings.attachments.productsHide }, `<+=${timings.attachments.productsHideDelay}`)
                .set(attSection, { autoAlpha: 1, pointerEvents: "auto", zIndex: 17 }, "attachmentsDetailsIntro")
                .set(attContentTop, { autoAlpha: 0 }, "attachmentsDetailsIntro")
                .set(attContentBottom, { autoAlpha: 1 }, "attachmentsDetailsIntro")
                .set([attLeftPanel, attCenterPanel, attRightPanel], { opacity: 1 }, "attachmentsDetailsIntro")
                .set(attLeftPanel, { y: "14%" }, "attachmentsDetailsIntro")
                .to(attLeftPanel, { y: "0%", duration: attachmentsBottomSlideReveal, ease: "power1.out" }, "attachmentsDetailsIntro");
        }

        function buildMobileAboutInstagram(mainTl, runtimeProfile) {
            const circleTransitions = getPlatformCircleTransitions(false);
            const timings = getSecondaryChapterTimingProfile();
            const layout = getSecondaryChapterLayoutProfile(false);
            const galleryFlow = getAboutGalleryFlowProfile(runtimeProfile, layout);
            const labelMap = mainTl.labels || {};
            const aboutIntroTime = labelMap.aboutIntro || 0;
            const aboutCoverLead = Math.min(0.16, Math.max(0.1, timings.about.attachmentVideoPreFade * 0.35));
            const aboutCoverStartDelay = Math.max(0, timings.about.coverDelay - aboutCoverLead);
            const aboutCopyRevealTime = aboutIntroTime + timings.about.coverDelay + Math.max(0.72, timings.about.introCircleExpand * 0.3);
            const aboutCoverStart = aboutCoverStartDelay === 0 ? "aboutIntro" : `aboutIntro+=${aboutCoverStartDelay}`;
            const aboutCopyHideStart = `aboutPrimaryCopyHide+=${timings.about.copyHoldDelay}`;
            const aboutStoryCopyStart = `aboutGalleryStart+=${galleryFlow.scaleStartOffset + timings.about.imageScale * 0.75}`;
            const aboutGalleryStartTime = labelMap.aboutGalleryStart || 0;
            const aboutCopyFlowStartTime = aboutIntroTime + timings.about.coverDelay + timings.about.circleShift;
            const aboutCopyFlowDuration = Math.max(0.8, aboutGalleryStartTime - aboutCopyFlowStartTime);
            const aboutStoryCopyStartTime = aboutGalleryStartTime + galleryFlow.scaleStartOffset + timings.about.imageScale * 0.75;
            const instagramCircleStartTime = aboutStoryCopyStartTime + Math.max(
                timings.about.storyTitleReveal + timings.about.storyBodyReveal + timings.about.storyCopyHoldDelay,
                timings.about.storyButtonReveal * 0.55 + timings.about.storyCopyHoldDelay
            ) + 0.55;
            const aboutStoryCircleDuration = Math.max(
                timings.about.storyCircleShift,
                instagramCircleStartTime - aboutGalleryStartTime
            );
            const aboutStoryCopyHideTime = instagramCircleStartTime - 0.08;
            const aboutStoryContentDropTime = aboutStoryCopyHideTime + timings.about.storyTitleHide * 0.2;
            const aboutStoryTitleDropTime = aboutStoryCopyHideTime + timings.about.storyTitleHide * 0.82;
            const instagramCardsIntroBaseTime = labelMap.instagramCardsIntro || labelMap.instagramIntro || instagramCircleStartTime;
            const instagramCopyRevealTime = instagramCircleStartTime + Math.max(0.72, timings.instagram.introCircleExpand * 0.3);
            const instagramTitleSettleTime = instagramCopyRevealTime
                + timings.instagram.titleReveal
                + Math.max(0, titleSplits[10].length - 1) * 0.2;
            const instagramBodySettleTime = instagramCopyRevealTime
                + timings.instagram.bodyReveal
                + Math.max(0, textSplits[7].length - 1) * 0.2;
            const instagramCopyHideTime = Math.max(instagramTitleSettleTime, instagramBodySettleTime) + 2.4;
            const instagramCopyHideComplete = instagramCopyHideTime + Math.max(
                timings.instagram.titleHide + Math.max(0, titleSplits[10].length - 1) * 0.2,
                timings.instagram.bodyHide
            );
            const instagramCardsRevealTime = instagramCopyHideComplete + 0.08;
            const instagramCircleEndTime = instagramCardsRevealTime + timings.instagram.cardsMove;
            const instagramCircleDuration = Math.max(0.8, instagramCircleEndTime - instagramCircleStartTime);
            // Labels, hover readiness and the page budget follow the actual
            // copy/gallery sequence, including responsive line wrapping.
            mainTl.addLabel('aboutCopyReveal', aboutCopyRevealTime);
            mainTl.addLabel('aboutStoryReveal', aboutStoryCopyStartTime);
            mainTl.addLabel('aboutStoryCopyHide', aboutStoryCopyHideTime);
            mainTl.addLabel('instagramIntro', instagramCircleStartTime);
            mainTl.addLabel('instagramCopyHide', instagramCopyHideTime);
            mainTl.addLabel('instagramCardsIntro', instagramCardsRevealTime);
            mainTl.addLabel('instagramHoverReady', instagramCircleEndTime);
            const aboutDesignHideComplete = `aboutPrimaryCopyHide+=${timings.about.copyHoldDelay + Math.max(
                timings.about.titleHide,
                timings.about.bodyHide,
                timings.about.buttonHide
            )}`;
            const aboutStoryHideComplete = aboutStoryCopyHideTime + Math.max(
                timings.about.storyTitleHide,
                timings.about.storyBodyHide,
                timings.about.storyButtonHide
            );
            return mainTl
                .to("#att-video4", {
                    opacity: 0,
                    duration: timings.about.attachmentVideoPreFade,
                    ease: "none",
                }, aboutCoverStart)
                .set(attSection, { zIndex: 16, pointerEvents: "none" }, aboutCoverStart)
                .set(aboutBackground, { zIndex: 18 }, aboutCoverStart)
                .set(circleSection, { zIndex: 19 }, aboutCoverStart)
                .to(aboutCircle, { cy: "50%", r: "100%", duration: timings.about.introCircleExpand }, aboutCoverStart)
                .to(circle1, { attr: circleTransitions.aboutIntro.circle1, duration: timings.about.circleShift }, "<")
                .to(circle2, { attr: circleTransitions.aboutIntro.circle2, duration: timings.about.circleShift }, "<")
                .to(aboutSection, { backgroundColor: "var(--km-secondary)", duration: timings.about.bgFade }, "<")
                .set(aboutDesignWrapper, { autoAlpha: 1 }, aboutCopyRevealTime)
                .fromTo(titleSplits[8], { y: "110%", opacity: 1 }, { y: "0%", stagger: 0.2, duration: timings.about.titleReveal, opacity: 1, immediateRender: false }, aboutCopyRevealTime)
                .fromTo(textSplits[5], { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: timings.about.bodyReveal, stagger: 0.2, immediateRender: false }, aboutCopyRevealTime)
                .from(aboutDesignButton, { opacity: 0, y: "200%", duration: timings.about.buttonReveal }, "<")
                .to(circle1, { attr: circleTransitions.aboutCopyFlow.circle1, duration: aboutCopyFlowDuration, ease: "none" }, aboutCopyFlowStartTime)
                .to(circle2, { attr: circleTransitions.aboutCopyFlow.circle2, duration: aboutCopyFlowDuration, ease: "none" }, aboutCopyFlowStartTime)
                .fromTo(titleSplits[8], { opacity: 1 }, { opacity: 0, stagger: 0.2, duration: timings.about.titleHide, immediateRender: false }, aboutCopyHideStart)
                .fromTo(textSplits[5], { opacity: 1 }, { opacity: 0, duration: timings.about.bodyHide, immediateRender: false }, "<")
                .to(aboutDesignButton, { opacity: 0, duration: timings.about.buttonHide }, "<")
                .set(aboutDesignWrapper, { autoAlpha: 0 }, aboutDesignHideComplete)
                .to(aboutImgSlider, {
                    x: galleryFlow.finalGalleryPosition,
                    duration: galleryFlow.travelDuration
                }, "aboutGalleryStart")
                .to(aboutImg4, {
                    x: galleryFlow.finalGalleryPosition,
                    duration: galleryFlow.travelDuration
                }, "aboutGalleryStart")
                .to(aboutImg4, {
                    scale: layout.about.imageScale,
                    duration: timings.about.imageScale
                }, `aboutGalleryStart+=${galleryFlow.scaleStartOffset}`)
                .to(aboutIntroImages, {
                    x: layout.about.introImagesShift,
                    duration: timings.about.imageTrackShift
                }, `aboutGalleryStart+=${galleryFlow.introImagesStartOffset}`)
                .set(circleSection, { zIndex: 19 }, "aboutGalleryStart")
                .to(circle1, { attr: circleTransitions.aboutStory.circle1, duration: aboutStoryCircleDuration, ease: "none" }, "aboutGalleryStart")
                .to(circle2, { attr: circleTransitions.aboutStory.circle2, duration: aboutStoryCircleDuration, ease: "none" }, "aboutGalleryStart")
                .set(aboutSustainabilityWrapper, { autoAlpha: 1 }, aboutStoryCopyStart)
                .fromTo(titleSplits[9], { y: "110%", opacity: 1 }, { y: "0%", stagger: 0.2, duration: timings.about.storyTitleReveal, opacity: 1, immediateRender: false }, aboutStoryCopyStart)
                .fromTo(textSplits[6], { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: timings.about.storyBodyReveal, stagger: 0.2, immediateRender: false }, aboutStoryCopyStart)
                .from(aboutSustainabilityButton, { opacity: 0, y: "200%", duration: timings.about.storyButtonReveal }, "<")
                .fromTo(titleSplits[9], { opacity: 1 }, { opacity: 0, stagger: 0.2, duration: timings.about.storyTitleHide, immediateRender: false }, aboutStoryCopyHideTime)
                .fromTo(textSplits[6], { opacity: 1 }, { opacity: 0, duration: timings.about.storyBodyHide, immediateRender: false }, "<")
                .to(aboutSustainabilityButton, { opacity: 0, duration: timings.about.storyButtonHide }, "<")
                .set(aboutSustainabilityWrapper, { autoAlpha: 0 }, aboutStoryHideComplete)

                .to(insCircle, { cy: "50%", r: "100%", duration: timings.instagram.introCircleExpand }, instagramCircleStartTime)
                .to([circle1, circle3], { attr: circleTransitions.instagram.group13, duration: instagramCircleDuration, ease: "none" }, instagramCircleStartTime)
                .to([circle2, circle4], { attr: circleTransitions.instagram.group24, duration: instagramCircleDuration, ease: "none" }, instagramCircleStartTime)
                .set(aboutSustainabilityText, { zIndex: 17 }, aboutStoryContentDropTime)
                .set(insBackground, { zIndex: 23 }, aboutStoryContentDropTime)
                .set(circleSection, { zIndex: 24 }, aboutStoryContentDropTime)
                .set(aboutSustainabilityTitle, { zIndex: 17 }, aboutStoryTitleDropTime)
                .set(insTitleWrapper, { autoAlpha: 1 }, instagramCopyRevealTime)
                .fromTo(titleSplits[10], { y: "110%", opacity: 1 }, { y: "0%", stagger: 0.2, duration: timings.instagram.titleReveal, opacity: 1, immediateRender: false }, instagramCopyRevealTime)
                .fromTo(textSplits[7], { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: timings.instagram.bodyReveal, stagger: 0.2, immediateRender: false }, instagramCopyRevealTime)
                .fromTo(titleSplits[10], { opacity: 1 }, { opacity: 0, stagger: 0.2, duration: timings.instagram.titleHide, immediateRender: false }, instagramCopyHideTime)
                .fromTo(textSplits[7], { opacity: 1 }, { opacity: 0, duration: timings.instagram.bodyHide, immediateRender: false }, "<")
                // Keep the rings through the gallery entrance so the copy-to-media
                // handoff has a visible scene even before the first card arrives.
                .to(circleSection, { zIndex: 1 }, instagramCircleEndTime)
                .set(insTitleWrapper, { autoAlpha: 0 }, instagramCopyHideComplete)
                .set(insGallery, { autoAlpha: 1 }, instagramCardsRevealTime)
                .from(insAniTops, { ...layout.instagram.cardIntroTop, duration: timings.instagram.cardsMove }, instagramCardsRevealTime)
                .from(insAniBottoms, { ...layout.instagram.cardIntroBottom, duration: timings.instagram.cardsMove }, "<");
        }

        function buildMobileMainTimeline(mainTl, runtimeProfile) {
            buildMobileFeatureInside(mainTl, runtimeProfile);
            buildMobileKnobChapter(mainTl, mainTl.labels, runtimeProfile);
            buildMobileQuietChapter(mainTl, mainTl.labels);
            buildMobileAttachmentsChapter(mainTl, mainTl.labels);
            return buildMobileAboutInstagram(mainTl, runtimeProfile);
        }

        function buildDesktopFeatureInside(mainTl, runtimeProfile) {
            const featureCircles = getFeatureInsideCircleTransitions(true);
            mainTl.set(cardWrappers, { autoAlpha: 1, yPercent: 0 }, 0);
            const cardTrackTargets = getInsideCardTrackTargets(true);
            const cardOpacityProfile = getInsideCardOpacityProfile(true);
            const timings = getFeatureInsideTimingProfile(true, runtimeProfile);
            const insideFlow = runtimeProfile?.insideFlow || {};
            const labelTimes = mainTl.labels || {};
            const introStart = `insideCardsIntro-=${insideFlow.introOverlap || 0}`;
            const focus1Start = `insideCardFocus1-=${insideFlow.transitionLead || 0}`;
            const focus2Start = `insideCardFocus2-=${insideFlow.transitionLead || 0}`;
            const focus3Start = `insideCardFocus3-=${insideFlow.transitionLead || 0}`;
            const focus3TrackStartTime = (labelTimes.insideCardFocus3 ?? 0) - (insideFlow.transitionLead || 0);
            const { cardsExitStart: focus3CardsExitStart, cardsExitDuration: focus3CardsExitDuration } = getDesktopInsideCardsExitProfile(
                focus3TrackStartTime,
                labelTimes.knobIntro,
                timings.inside.cardsStep,
                insideFlow.finalHold || 0,
                timings.inside.trackFadeOut
            );
            const exit = getInsideExitProfile(labelTimes, timings, runtimeProfile, true);
            const finalImageHideDuration = 0.2;
            const featureShiftStartTime = labelTimes.featureShiftStart ?? 0;
            const featureSecondaryRevealStartTime = labelTimes.featureSecondaryRevealStart ?? featureShiftStartTime;
            const featureCircleExpandDuration = timings.desktop.featureExpandDuration || timings.feature.circleExpand;
            const featureCircleExpandEase = timings.desktop.featureExpandEase || "sine.inOut";
            const featureCircleExpandStart = featureShiftStartTime - (timings.desktop.featureExpandLead || 0);
            const featureCircleExpandFollow = featureCircleExpandStart + (timings.desktop.featureExpandStagger || 0);
            const featureCircleExpandEnd = featureCircleExpandStart + featureCircleExpandDuration;
            const featureSecondaryCircleShiftDuration = timings.desktop.secondaryCircleShiftDuration || timings.desktop.secondaryCircleShift;
            const featureSecondaryCircleShiftEase = timings.desktop.secondaryCircleShiftEase || "sine.inOut";
            const featureSecondaryCircleShiftStart = featureCircleExpandEnd;
            const featureSecondaryCircleShiftFollow = featureSecondaryCircleShiftStart + (timings.desktop.secondaryCircleShiftStagger || 0);
            const featureSecondaryCircleShiftEnd = featureSecondaryCircleShiftStart + featureSecondaryCircleShiftDuration;
            const featureSecondaryMorphDuration = timings.desktop.featureSecondaryMorphDuration || 3.6;
            const featureSecondaryMorphEase = timings.desktop.featureSecondaryMorphEase || "expo.out";
            const featureSecondaryMorphStart = Math.max(
                featureSecondaryCircleShiftEnd,
                featureSecondaryRevealStartTime - (timings.desktop.featureSecondaryMorphLead || 0)
            );
            const featureSecondaryMorphFollow = featureSecondaryMorphStart + (timings.desktop.featureSecondaryMorphStagger || 0);
            const insideCircleIntroDuration = Math.max(
                timings.inside.cardsStep + (insideFlow.introOverlap || 0) + 0.72,
                1.95
            );
            const insideCircleStageBDuration = Math.max(
                timings.inside.cardsStep + (insideFlow.transitionLead || 0) * 0.2 + 0.22,
                1.28
            );
            const insideCircleStageCDuration = Math.max(
                timings.inside.cardsStep + (insideFlow.transitionLead || 0) + 0.28,
                1.55
            );
            const insideCircleBridgeStart = `featureSecondaryCopyHideStart-=${Math.max(insideFlow.introOverlap || 0, 0.56)}`;
            const insideCircleFollow = "<+=0.08";
            alignInsideExitCircles(mainTl, featureCircles, exit);
            return mainTl
                .set(outContent, { autoAlpha: 1 }, 0)
                .set(insideContent, { autoAlpha: 0 }, 0)
                .to(svg1Shapes, { drawSVG: "0%", duration: timings.draw }, "featureDrawStart")
                .to(circle1, { attr: featureCircles.featureStroke.circle1, duration: timings.draw }, `<+=${timings.strokeDelay}`)
                .to(circle2, { attr: featureCircles.featureStroke.circle2, duration: timings.draw }, "<")
                .fromTo(svg2Shapes, { drawSVG: "0%" }, { drawSVG: "100%", duration: timings.svg2Draw }, "featureSvg2DrawStart")
                .set([circle1, circle2], { x: 0, y: 0 }, featureCircleExpandStart)
                .to(featureContent, { x: "-76.5%", duration: timings.desktop.contentShift }, "featureShiftStart")
                .to(svg2Container, { opacity: 0, duration: timings.feature.svgFade }, "<")
                .to(insideOutImage1, { opacity: 1, duration: timings.feature.imageFade }, "<")
                .to(circle1, { attr: featureCircles.featureExpand.circle1, duration: featureCircleExpandDuration, ease: featureCircleExpandEase }, featureCircleExpandStart)
                .to(circle2, { attr: featureCircles.featureExpand.circle2, duration: featureCircleExpandDuration, ease: featureCircleExpandEase }, featureCircleExpandFollow)
                .fromTo(titleSplits[3], { y: "110%", opacity: 1 }, { y: "0%", stagger: 0.2, duration: timings.feature.titleReveal, opacity: 1, immediateRender: false }, "featureShiftStart")
                .fromTo(textSplits[0], { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: timings.feature.bodyReveal, stagger: 0.2, immediateRender: false }, "featureCopyReveal")
                .from(outButton, { opacity: 0, y: "200%", duration: timings.feature.buttonReveal }, "<")
                .fromTo(titleSplits[3], { opacity: 1 }, { opacity: 0, stagger: 0.2, duration: timings.feature.titleHide, immediateRender: false }, "featurePrimaryFadeStart")
                .fromTo(textSplits[0], { opacity: 1 }, { opacity: 0, duration: timings.feature.bodyHidePrimary, immediateRender: false }, "<")
                .to(outButton, { opacity: 0, duration: timings.feature.buttonHide }, "<")
                .set(outContent, { autoAlpha: 0 }, "featureSecondaryRevealStart")
                .set(insideContent, { autoAlpha: 1 }, "featureSecondaryRevealStart")
                .to(insideOutImageWrap, { x: "150%", duration: timings.desktop.wrapShift }, "featureWrapShiftStart")
                .to(circle1, { attr: featureCircles.featureShiftCx.circle1, duration: featureSecondaryCircleShiftDuration, ease: featureSecondaryCircleShiftEase }, featureSecondaryCircleShiftStart)
                .to(circle2, { attr: featureCircles.featureShiftCx.circle2, duration: featureSecondaryCircleShiftDuration, ease: featureSecondaryCircleShiftEase }, featureSecondaryCircleShiftFollow)
                .to(circle1, { attr: featureCircles.featureSecondaryMorph.circle1, duration: featureSecondaryMorphDuration, ease: featureSecondaryMorphEase }, featureSecondaryMorphStart)
                .to(circle2, { attr: featureCircles.featureSecondaryMorph.circle2, duration: featureSecondaryMorphDuration, ease: featureSecondaryMorphEase }, featureSecondaryMorphFollow)
                .fromTo(titleSplits[4], { y: "110%", opacity: 1 }, { y: "0%", stagger: 0.2, duration: timings.feature.titleReveal, opacity: 1, immediateRender: false }, "featureSecondaryRevealStart")
                .fromTo(textSplits[1], { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: timings.feature.bodyReveal, stagger: 0.2, immediateRender: false }, "featureSecondaryBodyRevealStart")
                .fromTo(titleSplits[4], { opacity: 1 }, { opacity: 0, stagger: 0.2, duration: timings.feature.titleHide, immediateRender: false }, "featureSecondaryCopyHideStart")
                .fromTo(textSplits[1], { opacity: 1 }, { opacity: 0, duration: timings.feature.secondaryBodyHide, immediateRender: false }, "<")

                .to(insideCardsTrack, {
                    y: cardTrackTargets.intro,
                    duration: timings.inside.cardsStep
                }, introStart)
                .to(cards[0], { opacity: cardOpacityProfile.intro[0], duration: timings.inside.cardFade }, "<")
                .to(cards[1], { opacity: cardOpacityProfile.intro[1], duration: timings.inside.cardFade }, "<")
                .to(cards[2], { opacity: cardOpacityProfile.intro[2], duration: timings.inside.cardFade }, "<")
                .to(insideOutImage1, { opacity: 0, duration: timings.inside.imageSwap }, "<")
                .to(insideOutImage2, { opacity: 1, duration: timings.inside.imageSwap }, "<")
                .to(circle1, { attr: featureCircles.insideStageA.circle1, duration: insideCircleIntroDuration, ease: "sine.inOut" }, insideCircleBridgeStart)
                .to(circle2, { attr: featureCircles.insideStageA.circle2, duration: insideCircleIntroDuration, ease: "sine.inOut" }, insideCircleFollow)

                .to(insideCardsTrack, {
                    y: cardTrackTargets.focus1,
                    duration: timings.inside.cardsStep
                }, focus1Start)
                .to(cards[0], { opacity: cardOpacityProfile.focus1[0], duration: timings.inside.cardFade }, "<")
                .to(cards[1], { opacity: cardOpacityProfile.focus1[1], duration: timings.inside.cardFade }, "<")
                .to(cards[2], { opacity: cardOpacityProfile.focus1[2], duration: timings.inside.cardFade }, "<")
                .to(insideOutImage2, { opacity: 0, duration: timings.inside.imageSwap }, "<")
                .to(insideOutImage3, { opacity: 1, duration: timings.inside.imageSwap }, "<")
                .to(circle1, { attr: featureCircles.insideStageB.circle1, duration: insideCircleStageBDuration, ease: "sine.inOut" }, focus1Start)
                .to(circle2, { attr: featureCircles.insideStageB.circle2, duration: insideCircleStageBDuration, ease: "sine.inOut" }, insideCircleFollow)

                .to(insideCardsTrack, {
                    y: cardTrackTargets.focus2,
                    duration: timings.inside.cardsStep
                }, focus2Start)
                .to(cards[0], { opacity: cardOpacityProfile.focus2[0], duration: timings.inside.cardFade }, "<")
                .to(cards[1], { opacity: cardOpacityProfile.focus2[1], duration: timings.inside.cardFade }, "<")
                .to(cards[2], { opacity: cardOpacityProfile.focus2[2], duration: timings.inside.cardFade }, "<")
                .from(insideButton, { opacity: 0, y: "200%", duration: timings.inside.buttonReveal }, "<")
                .to(insideOutImage3, { opacity: 0, duration: timings.inside.imageSwap }, "<")
                .to(insideOutImage4, { opacity: 1, duration: timings.inside.imageSwap }, "<")
                .to(circle1, { attr: featureCircles.insideStageC.circle1, duration: insideCircleStageCDuration, ease: "sine.inOut" }, focus2Start)
                .to(circle2, { attr: featureCircles.insideStageC.circle2, duration: insideCircleStageCDuration, ease: "sine.inOut" }, insideCircleFollow)
                .to(insideCardsTrack, {
                    y: cardTrackTargets.focus3,
                    duration: timings.inside.cardsStep
                }, focus3Start)
                .to(cards[0], { opacity: cardOpacityProfile.focus3[0], duration: timings.inside.cardFade }, "<")
                .to(cards[1], { opacity: cardOpacityProfile.focus3[1], duration: timings.inside.cardFade }, "<")
                .to(cards[2], { opacity: cardOpacityProfile.focus3[2], duration: timings.inside.cardFade }, "<")
                .to(insideCardsTrack, {
                    y: cardTrackTargets.outro,
                    opacity: 0,
                    duration: focus3CardsExitDuration,
                    ease: "power1.in",
                }, focus3CardsExitStart)
                .to(cards[0], {
                    opacity: 0,
                    duration: focus3CardsExitDuration * 0.18,
                    ease: "power1.out",
                }, focus3CardsExitStart)
                .to(cards[1], {
                    opacity: 0,
                    duration: focus3CardsExitDuration * 0.28,
                    ease: "power1.out",
                }, focus3CardsExitStart)
                .to(cards[2], {
                    opacity: 0,
                    duration: focus3CardsExitDuration * 0.42,
                    ease: "power1.out",
                }, focus3CardsExitStart)
                .fromTo(
                    insideOutImage4,
                    {
                        clipPath: "circle(80% at 65.3% 24.85%)"
                    },
                    {
                        clipPath: "circle(1% at 65.3% 24.85%)",
                        duration: exit.duration,
                        ease: exit.ease,
                    },
                    exit.start
                )
                .to(insideOutImage4, {
                    opacity: 0,
                    duration: finalImageHideDuration,
                }, exit.start + exit.duration)
                .to(circle1, {
                    attr: featureCircles.knobPrep.circle1,
                    x: 0,
                    y: 0,
                    duration: exit.duration,
                    ease: exit.ease,
                }, exit.start)
                .to(circle2, {
                    attr: featureCircles.knobPrep.circle2,
                    x: 0,
                    y: 0,
                    duration: exit.duration,
                    ease: exit.ease,
                }, exit.start)
                .set(insideContent, { autoAlpha: 0 }, "knobIntro");
        }

        function buildDesktopKnobChapter(mainTl, labelMap, runtimeProfile) {
            const markers = getKnobEntryMarkers(labelMap, getSecondaryChapterTimingProfile(), true, runtimeProfile);
            mainTl.add(createDesktopKnobChapterTimeline(labelMap, runtimeProfile), markers.entryStart);
            return mainTl;
        }

        function buildDesktopQuietChapter(mainTl, labelMap) {
            mainTl.add(createDesktopQuietChapterTimeline(labelMap), labelMap.quietIntro);
            return mainTl;
        }

        function buildDesktopAttachmentsChapter(mainTl, labelMap) {
            const timings = getSecondaryChapterTimingProfile();
            const layout = getSecondaryChapterLayoutProfile(true);
            const attachmentsBottomSlideReveal = Math.min(
                0.48,
                Math.max(0.24, timings.attachments.leftPanelReveal * 0.2)
            );
            const attachmentsIntro = labelMap.attachmentsIntro || 0;
            const attachmentsDetailsIntro = labelMap.attachmentsDetailsIntro || attachmentsIntro;
            const attachmentsCircleTravelWindow = Math.max(
                0.6,
                attachmentsDetailsIntro - attachmentsIntro
            );
            const attachmentsCircleEntryDuration = Math.min(
                timings.quiet.circleShift,
                Math.max(0.48, attachmentsCircleTravelWindow * 0.62)
            );
            const attachmentsCircleHandoffStart = attachmentsIntro + attachmentsCircleEntryDuration;
            const attachmentsCircleHandoffDuration = Math.max(
                0.24,
                attachmentsCircleTravelWindow - attachmentsCircleEntryDuration
            );
            return mainTl
                .set(attSection, { autoAlpha: 1, pointerEvents: "auto" }, "attachmentsIntro")
                .set(attContentTop, { autoAlpha: 1 }, "attachmentsIntro")
                .set(attContentBottom, { autoAlpha: 0 }, "attachmentsIntro")
                .to(circle1, { attr: getPlatformCircleTransitions(true).quietToAttachments.circle1, duration: attachmentsCircleEntryDuration }, "attachmentsIntro")
                .to(circle2, { attr: getPlatformCircleTransitions(true).quietToAttachments.circle2, duration: attachmentsCircleEntryDuration }, "attachmentsIntro")
                .to([circle1, circle2], {
                    attr: layout.attachments.handoffCircles,
                    duration: attachmentsCircleHandoffDuration,
                    ease: "power1.in",
                }, attachmentsCircleHandoffStart)
                .to(attSection, { zIndex: 17, duration: timings.attachments.sectionEnter }, "attachmentsIntro")
                .fromTo(titleSplits[7], { y: "110%", opacity: 1 }, { y: "0%", stagger: 0.2, duration: timings.attachments.titleReveal, opacity: 1, immediateRender: false }, "<")
                .from(attProductsWrapper, { opacity: 0, y: "50%", duration: timings.attachments.productsReveal }, "attachmentsIntro")
                .fromTo(textSplits[4], { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: timings.attachments.bodyReveal, stagger: 0.2, immediateRender: false }, "attachmentsIntro")
                .from(attButton, { opacity: 0, y: "200%", duration: timings.attachments.ctaReveal }, "<")
                .fromTo(titleSplits[7], { opacity: 1 }, { opacity: 0, stagger: 0.2, duration: timings.attachments.titleHide, immediateRender: false }, "attachmentsCopyHide")
                .fromTo(textSplits[4], { opacity: 1 }, { opacity: 0, duration: timings.attachments.bodyHide, immediateRender: false }, "<")
                .to(attButton, { opacity: 0, duration: timings.attachments.ctaHide }, "<")
                .to(attProductsWrapper, { opacity: 0, duration: timings.attachments.productsHide }, `<+=${timings.attachments.productsHideDelay}`)
                .set(attSection, { autoAlpha: 1, pointerEvents: "auto", zIndex: 17 }, "attachmentsDetailsIntro")
                .set(attContentTop, { autoAlpha: 0 }, "attachmentsDetailsIntro")
                .set(attContentBottom, { autoAlpha: 1 }, "attachmentsDetailsIntro")
                .set([attLeftPanel, attCenterPanel, attRightPanel], { opacity: 1 }, "attachmentsDetailsIntro")
                .set(attLeftPanel, { y: "14%" }, "attachmentsDetailsIntro")
                .to(attLeftPanel, { y: "0%", duration: attachmentsBottomSlideReveal, ease: "power1.out" }, "attachmentsDetailsIntro");
        }

        function buildDesktopAboutInstagram(mainTl, runtimeProfile) {
            const circleTransitions = getPlatformCircleTransitions(true);
            const timings = getSecondaryChapterTimingProfile();
            const layout = getSecondaryChapterLayoutProfile(true);
            const galleryFlow = getAboutGalleryFlowProfile(runtimeProfile, layout);
            const labelMap = mainTl.labels || {};
            const aboutIntroTime = labelMap.aboutIntro || 0;
            const aboutCoverLead = Math.min(0.16, Math.max(0.1, timings.about.attachmentVideoPreFade * 0.35));
            const aboutCoverStartDelay = Math.max(0, timings.about.coverDelay - aboutCoverLead);
            const aboutCopyRevealTime = aboutIntroTime + timings.about.coverDelay + Math.max(0.72, timings.about.introCircleExpand * 0.3);
            const aboutCoverStart = aboutCoverStartDelay === 0 ? "aboutIntro" : `aboutIntro+=${aboutCoverStartDelay}`;
            const aboutCopyHideStart = `aboutPrimaryCopyHide+=${timings.about.copyHoldDelay}`;
            const aboutStoryCopyStart = `aboutGalleryStart+=${galleryFlow.scaleStartOffset + timings.about.imageScale * 0.75}`;
            const aboutGalleryStartTime = labelMap.aboutGalleryStart || 0;
            const aboutCopyFlowStartTime = aboutIntroTime + timings.about.coverDelay + timings.about.circleShift;
            const aboutCopyFlowDuration = Math.max(0.8, aboutGalleryStartTime - aboutCopyFlowStartTime);
            const aboutStoryCopyStartTime = aboutGalleryStartTime + galleryFlow.scaleStartOffset + timings.about.imageScale * 0.75;
            const instagramCircleStartTime = aboutStoryCopyStartTime + Math.max(
                timings.about.storyTitleReveal + timings.about.storyBodyReveal + timings.about.storyCopyHoldDelay,
                timings.about.storyButtonReveal * 0.55 + timings.about.storyCopyHoldDelay
            ) + 0.55;
            const aboutStoryCircleDuration = Math.max(
                timings.about.storyCircleShift,
                instagramCircleStartTime - aboutGalleryStartTime
            );
            const aboutStoryCopyHideTime = instagramCircleStartTime - 0.08;
            const aboutStoryContentDropTime = aboutStoryCopyHideTime + timings.about.storyTitleHide * 0.2;
            const aboutStoryTitleDropTime = aboutStoryCopyHideTime + timings.about.storyTitleHide * 0.82;
            const instagramCardsIntroBaseTime = labelMap.instagramCardsIntro || labelMap.instagramIntro || instagramCircleStartTime;
            const instagramCopyRevealTime = instagramCircleStartTime + Math.max(0.72, timings.instagram.introCircleExpand * 0.3);
            const instagramTitleSettleTime = instagramCopyRevealTime
                + timings.instagram.titleReveal
                + Math.max(0, titleSplits[10].length - 1) * 0.2;
            const instagramBodySettleTime = instagramCopyRevealTime
                + timings.instagram.bodyReveal
                + Math.max(0, textSplits[7].length - 1) * 0.2;
            const instagramCopyHideTime = Math.max(instagramTitleSettleTime, instagramBodySettleTime) + 2.4;
            const instagramCopyHideComplete = instagramCopyHideTime + Math.max(
                timings.instagram.titleHide + Math.max(0, titleSplits[10].length - 1) * 0.2,
                timings.instagram.bodyHide
            );
            const instagramCardsRevealTime = instagramCopyHideComplete + 0.08;
            const instagramCircleEndTime = instagramCardsRevealTime + timings.instagram.cardsMove;
            const instagramCircleDuration = Math.max(0.8, instagramCircleEndTime - instagramCircleStartTime);
            // Labels, hover readiness and the page budget follow the actual
            // copy/gallery sequence, including responsive line wrapping.
            mainTl.addLabel('aboutCopyReveal', aboutCopyRevealTime);
            mainTl.addLabel('aboutStoryReveal', aboutStoryCopyStartTime);
            mainTl.addLabel('aboutStoryCopyHide', aboutStoryCopyHideTime);
            mainTl.addLabel('instagramIntro', instagramCircleStartTime);
            mainTl.addLabel('instagramCopyHide', instagramCopyHideTime);
            mainTl.addLabel('instagramCardsIntro', instagramCardsRevealTime);
            mainTl.addLabel('instagramHoverReady', instagramCircleEndTime);
            const aboutDesignHideComplete = `aboutPrimaryCopyHide+=${timings.about.copyHoldDelay + Math.max(
                timings.about.titleHide,
                timings.about.bodyHide,
                timings.about.buttonHide
            )}`;
            const aboutStoryHideComplete = aboutStoryCopyHideTime + Math.max(
                timings.about.storyTitleHide,
                timings.about.storyBodyHide,
                timings.about.storyButtonHide
            );
            return mainTl
                .to("#att-video4", {
                    opacity: 0,
                    duration: timings.about.attachmentVideoPreFade,
                    ease: "none",
                }, aboutCoverStart)
                .set(attSection, { zIndex: 16, pointerEvents: "none" }, aboutCoverStart)
                .set(aboutBackground, { zIndex: 18 }, aboutCoverStart)
                .set(circleSection, { zIndex: 19 }, aboutCoverStart)
                .to(aboutCircle, { cy: "50%", r: "100%", duration: timings.about.introCircleExpand }, aboutCoverStart)
                .to(circle1, { attr: circleTransitions.aboutIntro.circle1, duration: timings.about.circleShift }, "<")
                .to(circle2, { attr: circleTransitions.aboutIntro.circle2, duration: timings.about.circleShift }, "<")
                .to(aboutSection, { backgroundColor: "var(--km-secondary)", duration: timings.about.bgFade }, "<")
                .set(aboutDesignWrapper, { autoAlpha: 1 }, aboutCopyRevealTime)
                .fromTo(titleSplits[8], { y: "110%", opacity: 1 }, { y: "0%", stagger: 0.2, duration: timings.about.titleReveal, opacity: 1, immediateRender: false }, aboutCopyRevealTime)
                .fromTo(textSplits[5], { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: timings.about.bodyReveal, stagger: 0.2, immediateRender: false }, aboutCopyRevealTime)
                .from(aboutDesignButton, { opacity: 0, y: "200%", duration: timings.about.buttonReveal }, "<")
                .to(circle1, { attr: circleTransitions.aboutCopyFlow.circle1, duration: aboutCopyFlowDuration, ease: "none" }, aboutCopyFlowStartTime)
                .to(circle2, { attr: circleTransitions.aboutCopyFlow.circle2, duration: aboutCopyFlowDuration, ease: "none" }, aboutCopyFlowStartTime)
                .fromTo(titleSplits[8], { opacity: 1 }, { opacity: 0, stagger: 0.2, duration: timings.about.titleHide, immediateRender: false }, aboutCopyHideStart)
                .fromTo(textSplits[5], { opacity: 1 }, { opacity: 0, duration: timings.about.bodyHide, immediateRender: false }, "<")
                .to(aboutDesignButton, { opacity: 0, duration: timings.about.buttonHide }, "<")
                .set(aboutDesignWrapper, { autoAlpha: 0 }, aboutDesignHideComplete)
                .to(aboutImgSlider, {
                    x: galleryFlow.finalGalleryPosition,
                    duration: galleryFlow.travelDuration
                }, "aboutGalleryStart")
                .to(aboutImg4, {
                    x: galleryFlow.finalGalleryPosition,
                    duration: galleryFlow.travelDuration
                }, "aboutGalleryStart")
                .to(aboutImg4, {
                    scale: layout.about.imageScale,
                    duration: timings.about.imageScale
                }, `aboutGalleryStart+=${galleryFlow.scaleStartOffset}`)
                .to(aboutIntroImages, {
                    x: layout.about.introImagesShift,
                    duration: timings.about.imageTrackShift
                }, `aboutGalleryStart+=${galleryFlow.introImagesStartOffset}`)
                .set(circleSection, { zIndex: 19 }, "aboutGalleryStart")
                .to(circle1, { attr: circleTransitions.aboutStory.circle1, duration: aboutStoryCircleDuration, ease: "none" }, "aboutGalleryStart")
                .to(circle2, { attr: circleTransitions.aboutStory.circle2, duration: aboutStoryCircleDuration, ease: "none" }, "aboutGalleryStart")
                .set(aboutSustainabilityWrapper, { autoAlpha: 1 }, aboutStoryCopyStart)
                .fromTo(titleSplits[9], { y: "110%", opacity: 1 }, { y: "0%", stagger: 0.2, duration: timings.about.storyTitleReveal, opacity: 1, immediateRender: false }, aboutStoryCopyStart)
                .fromTo(textSplits[6], { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: timings.about.storyBodyReveal, stagger: 0.2, immediateRender: false }, aboutStoryCopyStart)
                .from(aboutSustainabilityButton, { opacity: 0, y: "200%", duration: timings.about.storyButtonReveal }, "<")
                .fromTo(titleSplits[9], { opacity: 1 }, { opacity: 0, stagger: 0.2, duration: timings.about.storyTitleHide, immediateRender: false }, aboutStoryCopyHideTime)
                .fromTo(textSplits[6], { opacity: 1 }, { opacity: 0, duration: timings.about.storyBodyHide, immediateRender: false }, "<")
                .to(aboutSustainabilityButton, { opacity: 0, duration: timings.about.storyButtonHide }, "<")
                .set(aboutSustainabilityWrapper, { autoAlpha: 0 }, aboutStoryHideComplete)

                .to(insCircle, { cy: "50%", r: "100%", duration: timings.instagram.introCircleExpand }, instagramCircleStartTime)
                .to([circle1, circle3], { attr: circleTransitions.instagram.group13, duration: instagramCircleDuration, ease: "none" }, instagramCircleStartTime)
                .to([circle2, circle4], { attr: circleTransitions.instagram.group24, duration: instagramCircleDuration, ease: "none" }, instagramCircleStartTime)
                .set(aboutSustainabilityText, { zIndex: 17 }, aboutStoryContentDropTime)
                .set(insBackground, { zIndex: 23 }, aboutStoryContentDropTime)
                .set(circleSection, { zIndex: 24 }, aboutStoryContentDropTime)
                .set(aboutSustainabilityTitle, { zIndex: 17 }, aboutStoryTitleDropTime)
                .set(insTitleWrapper, { autoAlpha: 1 }, instagramCopyRevealTime)
                .fromTo(titleSplits[10], { y: "110%", opacity: 1 }, { y: "0%", stagger: 0.2, duration: timings.instagram.titleReveal, opacity: 1, immediateRender: false }, instagramCopyRevealTime)
                .to([".header",".logo-domain"], { display: "none" }, instagramCopyRevealTime)
                .fromTo(textSplits[7], { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: timings.instagram.bodyReveal, stagger: 0.2, immediateRender: false }, instagramCopyRevealTime)
                .fromTo(titleSplits[10], { opacity: 1 }, { opacity: 0, stagger: 0.2, duration: timings.instagram.titleHide, immediateRender: false }, instagramCopyHideTime)
                .fromTo(textSplits[7], { opacity: 1 }, { opacity: 0, duration: timings.instagram.bodyHide, immediateRender: false }, "<")
                // Keep the rings through the gallery entrance so the copy-to-media
                // handoff has a visible scene even before the first card arrives.
                .to(circleSection, { zIndex: 1 }, instagramCircleEndTime)
                .set(insTitleWrapper, { autoAlpha: 0 }, instagramCopyHideComplete)
                .set(insGallery, { autoAlpha: 1 }, instagramCardsRevealTime)
                .from(insAniTops, { ...layout.instagram.cardIntroTop, duration: timings.instagram.cardsMove }, instagramCardsRevealTime)
                .from(insAniBottoms, { ...layout.instagram.cardIntroBottom, duration: timings.instagram.cardsMove }, "<");
        }

        function buildDesktopMainTimeline(mainTl, runtimeProfile) {
            buildDesktopFeatureInside(mainTl, runtimeProfile);
            buildDesktopKnobChapter(mainTl, mainTl.labels, runtimeProfile);
            buildDesktopQuietChapter(mainTl, mainTl.labels);
            buildDesktopAttachmentsChapter(mainTl, mainTl.labels);
            return buildDesktopAboutInstagram(mainTl, runtimeProfile);
        }

        function mountMainTimelineExperience() {
            captureMainTimelinePosition();
            mainTimelineMediaContext?.revert();
            const mm = gsap.matchMedia();
            mainTimelineMediaContext = mm;

            mm.add(
            {
                isDesktop: "(min-aspect-ratio: 1/1)", 
                isNotDesktop: "(max-aspect-ratio: 1/1)"   
            },
            (context) => {
                const { isDesktop, isNotDesktop } = context.conditions;  
                const cleanupFns = [];
                const mountedViewport = [window.innerWidth, window.innerHeight];
                const interactionProfile = getHomepageInteractionProfile({ isNotDesktop, isMobileViewport: isMobile });
                const runtimeProfile = getMainTimelineRuntimeProfile(isNotDesktop, interactionProfile);
                refreshLayoutMetrics();
                if (isNotDesktop && runtimeProfile.scroll.normalizeOnNotDesktop) {
                    // Let the drawer own its native gestures and body scroll
                    // lock; the page normalizer must not drag the scene behind it.
                    ScrollTrigger.normalizeScroll({ ignore: 'header-drawer' });
                    cleanupFns.push(() => ScrollTrigger.normalizeScroll(false));
                }

                const originalLabels = getMainTimelineLabelsByPlatform(isNotDesktop, runtimeProfile);
                const mainTimelineLabels = applyHomepageReadingPace(originalLabels, runtimeProfile, isNotDesktop);
                let mainTimelineDuration = mainTimelineLabels.instagramHoverReady;
                const getMainScrollDistance = () => window.innerHeight * 20
                    * mainTimelineDuration / originalLabels.instagramHoverReady;
                const originalSocialHeight = insSection.style.height;
                const socialHandoffInset = homepageHeaderSection?.getBoundingClientRect().height || 0;
                const syncMainScrollSpace = () => {
                    // pinSpacing is disabled: the document must reserve the same
                    // added distance as the timeline, or the footer covers social.
                    const extraDistance = Math.max(0, getMainScrollDistance() - window.innerHeight * 20);
                    // The header leaves normal flow in the social chapter.
                    insSection.style.height = `calc(200vh + ${extraDistance + socialHandoffInset}px)`;
                };
                syncMainScrollSpace();
                cleanupFns.push(() => { insSection.style.height = originalSocialHeight; });
                const mainTl = gsap.timeline({
                    defaults: { ease: "none" },
                    scrollTrigger: {
                        trigger: featureAnimationWrapper,
                        ...runtimeProfile.scrollTrigger,
                        // Allocate extra scroll distance to the added reading
                        // time, preserving the speed of every later chapter.
                        end: () => `+=${getMainScrollDistance()}`,
                        onRefreshInit: syncMainScrollSpace,
                        invalidateOnRefresh: true,
                    }
                });
                addTimelineLabels(mainTl, mainTimelineLabels);
                mainTl.set(outContent, { autoAlpha: 1 }, 0);
                mainTl.set(insideContent, { autoAlpha: 0 }, 0);
                mainTl.set([knobContent, quietContent, attContentTop, attContentBottom, aboutDesignWrapper, aboutSustainabilityWrapper], { autoAlpha: 0 }, 0);
                mainTl.set(attSection, { autoAlpha: 0, pointerEvents: "none", zIndex: -1 }, 0);
                const cardScrollTargetTimes = getInsideCardClickTargetTimes(mainTimelineLabels, runtimeProfile, isNotDesktop);
                const attachmentPointLabels = ATTACHMENT_POINT_LABELS;
                const getScrollPositionForTimelineTime = (targetTime) => {
                    const scrollTrigger = mainTl.scrollTrigger;
                    if (!scrollTrigger || typeof targetTime !== "number" || Number.isNaN(targetTime)) return null;

                    const duration = mainTl.duration();
                    if (!duration) return null;

                    const progress = gsap.utils.clamp(0, 1, targetTime / duration);
                    return scrollTrigger.start + (scrollTrigger.end - scrollTrigger.start) * progress;
                };
                const scrollMainTimelineToTime = (targetTime) => {
                    const scrollPosition = getScrollPositionForTimelineTime(targetTime);
                    if (scrollPosition === null) return;

                    gsap.to(window, {
                        scrollTo: { y: scrollPosition, autoKill: true },
                        duration: runtimeProfile.interactions.scrollDuration,
                        ease: runtimeProfile.interactions.scrollEase,
                        overwrite: "auto",
                    });
                };
                cards.forEach((card) => {
                    card.style.cursor = "pointer";
                    card.setAttribute('role', 'button');
                    card.tabIndex = 0;
                });
                const handleCardClick = (event) => {
                    const clickedCard = event.target.closest(".inside-cards-card");
                    if (!clickedCard || !insideCardsTrack?.contains(clickedCard)) return;

                    const index = cardList.indexOf(clickedCard);
                    if (index === -1) return;

                    const targetTime = cardScrollTargetTimes[index];
                    if (typeof targetTime !== "number") return;

                    scrollMainTimelineToTime(targetTime);
                };

                insideCardsTrack?.addEventListener("click", handleCardClick);
                cleanupFns.push(() => insideCardsTrack?.removeEventListener("click", handleCardClick));
                const handleCardKeydown = (event) => {
                    if (event.key !== 'Enter' && event.key !== ' ') return;
                    if (!event.target.closest('.inside-cards-card')) return;
                    event.preventDefault();
                    handleCardClick(event);
                };
                insideCardsTrack?.addEventListener('keydown', handleCardKeydown);
                cleanupFns.push(() => insideCardsTrack?.removeEventListener('keydown', handleCardKeydown));

                const timelinePoints = attachmentPointLabels.map((label) => mainTl.labels[label]);
                const lastAttachmentItemIndex = attachmentPointLabels.length;
                const {
                    entryDuration,
                    holdDuration,
                    exitDuration,
                    animationWindow,
                    clickFocusOffset,
                    baseScale,
                    cruiseScale,
                    focusScale,
                    activeColor,
                    inactiveColor,
                } = getAttachmentTimelineConfig(runtimeProfile);

                const attachmentOrbit = getAttachmentOrbitProfile(isNotDesktop);
                const attachmentVideoMotionScale = isNotDesktop ? 1.18 : 1.24;
                const attachmentVideoEntryDuration = entryDuration * attachmentVideoMotionScale;
                const attachmentVideoCenterBlendDuration = Math.max(
                    isNotDesktop ? 0.01 : 0.02,
                    holdDuration * 0.08
                );
                const attachmentVideoExitDuration = exitDuration * attachmentVideoMotionScale;
                const attachmentVideoTravelDuration = attachmentVideoEntryDuration + attachmentVideoCenterBlendDuration + attachmentVideoExitDuration;
                const attachmentVideoOverlapLead = Math.max(
                    1.08,
                    attachmentVideoExitDuration * (isNotDesktop ? 1.08 : 1.2)
                );

                mainTl.set(attCenterPanel, {
                    x: 0,
                    y: 0,
                    scale: 1,
                    transformOrigin: "50% 50%",
                }, mainTimelineLabels.attachmentsDetailsIntro);
                mainTl.set(attachmentVideos, {
                    x: attachmentOrbit.entryStart.x,
                    y: attachmentOrbit.entryStart.y,
                    scale: baseScale,
                    opacity: 0,
                    transformOrigin: "50% 50%",
                }, mainTimelineLabels.attachmentsDetailsIntro);
                mainTl.set(attachmentRightImages, {
                    opacity: 0,
                    zIndex: 0,
                }, 0);
                mainTl.set(attachmentRightImages, {
                    opacity: 0,
                    zIndex: 0,
                }, mainTimelineLabels.attachmentsDetailsIntro);
                mainTl.set(attContentBottom, { opacity: 1 }, mainTimelineLabels.attachmentsDetailsIntro);
                mainTl.set(["#att-icon1", "#att-icon2", "#att-icon3", "#att-icon4"], { opacity: 0 }, mainTimelineLabels.attachmentsDetailsIntro);
                const attachmentItemSelectors = leftItemList.map((_, itemIdx) => `#att-item${itemIdx + 1}`);
                const attachmentIconSelectors = leftItemList.map((_, itemIdx) => `#att-icon${itemIdx + 1}`);

                function animateItem(itemIndex, startTime) {
                    const item = `#att-item${itemIndex}`;
                    const icon = `#att-icon${itemIndex}`;
                    const video = `#att-video${itemIndex}`;
                    const image = `#att-image${itemIndex}`;
                    const previousItem = itemIndex > 1 ? `#att-item${itemIndex - 1}` : null;
                    const previousIcon = itemIndex > 1 ? `#att-icon${itemIndex - 1}` : null;
                    const inactiveItems = attachmentItemSelectors.filter((selector) => selector !== item);
                    const inactiveIcons = attachmentIconSelectors.filter((selector) => selector !== icon);
                    const farInactiveItems = previousItem
                        ? inactiveItems.filter((selector) => selector !== previousItem)
                        : inactiveItems;
                    const farInactiveIcons = previousIcon
                        ? inactiveIcons.filter((selector) => selector !== previousIcon)
                        : inactiveIcons;
                    const videoStartTime = Math.max(
                        mainTimelineLabels.attachmentsDetailsIntro,
                        startTime - attachmentVideoOverlapLead
                    );
                    const videoCenterArrivalTime = videoStartTime
                        + attachmentVideoEntryDuration
                        + attachmentVideoCenterBlendDuration;
                    const isLastAttachmentItem = itemIndex === lastAttachmentItemIndex;
                    const activeRevealDuration = Math.max(
                        isNotDesktop ? 0.2 : 0.24,
                        Math.min(isNotDesktop ? 0.32 : 0.36, attachmentVideoEntryDuration * 0.24)
                    );
                    const activeRevealStartTime = Math.max(
                        videoStartTime,
                        videoCenterArrivalTime - activeRevealDuration
                    );
                    const imageRevealLead = Math.min(
                        activeRevealDuration * 0.45,
                        attachmentVideoEntryDuration * 0.14
                    );
                    const imageRevealTime = videoCenterArrivalTime - imageRevealLead;
                    const firstImageFadeDuration = Math.max(
                        0.2,
                        Math.min(0.42, attachmentVideoEntryDuration * 0.42)
                    );
                    const firstImageRevealTime = imageRevealTime - firstImageFadeDuration;
                    const buildSegmentedKeyframes = (points, totalDuration, opts = {}) => {
                        const segmentCount = Array.isArray(points) ? points.length : 0;
                        if (!segmentCount) return [];
                        const segmentDuration = totalDuration / segmentCount;

                        return points.map((point, index) => {
                            const progress = (index + 1) / segmentCount;
                            const opacity = opts.opacityRange
                                ? opts.opacityRange[0] + (opts.opacityRange[1] - opts.opacityRange[0]) * progress
                                : 1;
                            const scale = opts.scaleRange
                                ? opts.scaleRange[0] + (opts.scaleRange[1] - opts.scaleRange[0]) * progress
                                : focusScale;

                            return {
                                opacity,
                                x: point.x,
                                y: point.y,
                                scale,
                                duration: segmentDuration,
                                ease: index === segmentCount - 1
                                    ? (opts.finalEase || "sine.out")
                                    : (opts.ease || "power1.out"),
                            };
                        });
                    };
                    const entryKeyframes = attachmentOrbit.entryPath
                        ? buildSegmentedKeyframes([
                            ...attachmentOrbit.entryPath,
                            attachmentOrbit.holdEnd,
                        ], attachmentVideoEntryDuration, {
                            opacityRange: [isNotDesktop ? 0.72 : 0, 1],
                            scaleRange: [isNotDesktop ? baseScale + (cruiseScale - baseScale) * 0.25 : baseScale, focusScale],
                            // Desktop gets one easing curve across the whole
                            // arc, avoiding a stop/start at each sampled point.
                            ease: isNotDesktop ? "power1.out" : "none",
                            finalEase: isNotDesktop ? "sine.out" : "none",
                        })
                        : attachmentOrbit.entryMid
                            ? [
                                {
                                    opacity: 0.86,
                                    x: attachmentOrbit.entryMid.x,
                                    y: attachmentOrbit.entryMid.y,
                                    scale: baseScale + (cruiseScale - baseScale) * 0.6,
                                    duration: attachmentVideoEntryDuration * 0.56,
                                    ease: "power1.out",
                                },
                                {
                                    opacity: 1,
                                    x: attachmentOrbit.entryEnd.x,
                                    y: attachmentOrbit.entryEnd.y,
                                    scale: cruiseScale,
                                    duration: attachmentVideoEntryDuration * 0.44,
                                    ease: "sine.out",
                                },
                            ]
                            : [
                                {
                                    opacity: 1,
                                    x: attachmentOrbit.entryEnd.x,
                                    y: attachmentOrbit.entryEnd.y,
                                    scale: cruiseScale,
                                    duration: attachmentVideoEntryDuration,
                                    ease: "sine.out",
                                },
                            ];
                    const exitSegmentedKeyframes = attachmentOrbit.exitPath
                        ? [
                            {
                                opacity: 1,
                                x: attachmentOrbit.holdEnd.x,
                                y: attachmentOrbit.holdEnd.y,
                                scale: focusScale,
                                duration: attachmentVideoCenterBlendDuration,
                                ease: "none",
                            },
                            ...buildSegmentedKeyframes([
                                ...attachmentOrbit.exitPath,
                                attachmentOrbit.exitEnd,
                            ], attachmentVideoExitDuration, {
                                opacityRange: [0.88, 0],
                                scaleRange: [focusScale + (baseScale - focusScale) * 0.12, baseScale],
                                ease: "sine.inOut",
                                finalEase: "sine.in",
                            }),
                        ]
                        : null;

                    mainTl
                        .set(attContentBottom, { opacity: 1 }, startTime)
                        .set([attLeftPanel, attRightPanel], { opacity: 1 }, startTime)
                        .set(leftItemList, { opacity: 1 }, startTime)
                        .set(farInactiveItems, { color: inactiveColor }, activeRevealStartTime)
                        .set(farInactiveIcons, { opacity: 0 }, activeRevealStartTime)
                        .set(video, { zIndex: itemIndex }, videoStartTime)
                        .to(item, { color: activeColor, duration: activeRevealDuration, ease: "sine.out" }, activeRevealStartTime)
                        .to(icon, { opacity: 1, duration: activeRevealDuration, ease: "sine.out" }, "<")
                        .set(image, { zIndex: itemIndex }, imageRevealTime)
                        .fromTo(video, {
                            opacity: 0,
                            x: attachmentOrbit.entryStart.x,
                            y: attachmentOrbit.entryStart.y,
                            scale: baseScale,
                        }, {
                            keyframes: entryKeyframes,
                            ease: isNotDesktop ? "none" : "sine.out",
                            immediateRender: false,
                        }, videoStartTime)
                        .to(video, {
                            keyframes: exitSegmentedKeyframes || (attachmentOrbit.exitMid
                                ? [
                                    {
                                        opacity: 1,
                                        x: attachmentOrbit.holdEnd.x,
                                        y: attachmentOrbit.holdEnd.y,
                                        scale: focusScale,
                                        duration: attachmentVideoCenterBlendDuration,
                                        ease: "none",
                                    },
                                    {
                                        opacity: 0.72,
                                        x: attachmentOrbit.exitMid.x,
                                        y: attachmentOrbit.exitMid.y,
                                        scale: focusScale + (baseScale - focusScale) * 0.42,
                                        duration: attachmentVideoExitDuration * 0.44,
                                        ease: "sine.inOut",
                                    },
                                    {
                                        opacity: 0,
                                        x: attachmentOrbit.exitEnd.x,
                                        y: attachmentOrbit.exitEnd.y,
                                        scale: baseScale,
                                        duration: attachmentVideoExitDuration * 0.56,
                                        ease: "sine.in",
                                    },
                                ]
                                : [
                                    {
                                        opacity: 1,
                                        x: attachmentOrbit.holdEnd.x,
                                        y: attachmentOrbit.holdEnd.y,
                                        scale: focusScale,
                                        duration: attachmentVideoCenterBlendDuration,
                                        ease: "none",
                                    },
                                    {
                                        opacity: 0,
                                        x: attachmentOrbit.exitEnd.x,
                                        y: attachmentOrbit.exitEnd.y,
                                        scale: baseScale,
                                        duration: attachmentVideoExitDuration,
                                        ease: "sine.in",
                                    },
                                ]),
                            immediateRender: false,
                        }, videoStartTime + attachmentVideoEntryDuration);

                    if (previousItem && previousIcon) {
                        mainTl
                            .to(previousItem, { color: inactiveColor, duration: activeRevealDuration, ease: "sine.in" }, activeRevealStartTime)
                            .to(previousIcon, { opacity: 0, duration: activeRevealDuration, ease: "sine.in" }, "<");
                    }

                    if (itemIndex === 1) {
                        mainTl.fromTo(image, {
                            opacity: 0,
                        }, {
                            opacity: 1,
                            duration: firstImageFadeDuration,
                            ease: "sine.out",
                        }, firstImageRevealTime);
                    } else {
                        mainTl.set(image, { opacity: 1 }, imageRevealTime);
                    }

                    if (isLastAttachmentItem) {
                        mainTl.to([attLeftPanel, attRightPanel], {
                            opacity: 0,
                            duration: attachmentVideoExitDuration,
                            ease: "none",
                        }, videoCenterArrivalTime);
                    }
                }

                timelinePoints.forEach((time, index) => {
                    animateItem(index + 1, time);
                });

                const attachmentPlaybackEnd = mainTimelineLabels.aboutIntro;
                const attachmentVideoWindows = timelinePoints.map((startTime, index) => ({
                    itemIndex: index + 1,
                    start: Math.max(mainTimelineLabels.attachmentsDetailsIntro, startTime - attachmentVideoOverlapLead),
                    end: Math.max(mainTimelineLabels.attachmentsDetailsIntro, startTime - attachmentVideoOverlapLead)
                        + attachmentVideoTravelDuration,
                }));
                let activeAttachmentVideoIndex = null;
                let activeAttachmentVideoSetKey = "";
                // Selection follows the visible title's reveal, rather than the
                // nominal label (desktop video arrival can precede that label).
                const attachmentSelectionTimes = timelinePoints.map((startTime) => {
                    const videoStart = Math.max(mainTimelineLabels.attachmentsDetailsIntro, startTime - attachmentVideoOverlapLead);
                    const revealDuration = Math.max(
                        isNotDesktop ? 0.2 : 0.24,
                        Math.min(isNotDesktop ? 0.32 : 0.36, attachmentVideoEntryDuration * 0.24)
                    );
                    return videoStart + attachmentVideoEntryDuration + attachmentVideoCenterBlendDuration - revealDuration * 0.5;
                });
                const getActiveAttachmentIndexForTime = (timelineTime) => {
                    if (
                        typeof timelineTime !== "number" ||
                        !timelinePoints.length ||
                        timelineTime < attachmentSelectionTimes[0] ||
                        timelineTime >= attachmentPlaybackEnd
                    ) {
                        return null;
                    }

                    for (let index = timelinePoints.length - 1; index >= 0; index -= 1) {
                        if (timelineTime >= attachmentSelectionTimes[index]) {
                            return index + 1;
                        }
                    }

                    return null;
                };

                const getVisibleAttachmentIndicesForTime = (timelineTime) => {
                    if (typeof timelineTime !== "number") return [];

                    return attachmentVideoWindows
                        .filter(({ start, end }) => timelineTime >= start && timelineTime < end)
                        .map(({ itemIndex }) => itemIndex);
                };

                const knobMarkers = getKnobChapterMarkers(mainTimelineLabels, getSecondaryChapterTimingProfile(), isDesktop);
                const knobPlayStart = mainTimelineLabels.knobMediaPlay;
                const knobPlayEnd = mainTimelineLabels.knobIntro + knobMarkers.backgroundExitStart;
                let knobPlaybackRequested = false;
                const syncAttachmentVideoPlayback = () => {
                    // Revert may render one last frame after ScrollTrigger has detached.
                    if (homepageRuntimeDestroyed || !mainTl.scrollTrigger) return;
                    const timelineTime = mainTl.time();
                    if (!mainTimelineRestoring && !mainTimelineRestoreState
                        && mountedViewport[0] === window.innerWidth
                        && mountedViewport[1] === window.innerHeight) {
                        mainTimelineStableState = {
                            time: timelineTime,
                            labels: mainTimelineLabels,
                            inside: window.scrollY >= mainTl.scrollTrigger.start && window.scrollY <= mainTl.scrollTrigger.end,
                        };
                    }
                    if (timelineTime >= mainTimelineLabels.knobIntro - 10) loadHomepageImages(knobSection);
                    if (timelineTime >= mainTimelineLabels.attachmentsIntro - 8) loadHomepageImages(attSection);
                    if (timelineTime >= mainTimelineLabels.aboutIntro - 8) loadHomepageImages(aboutSection);
                    if (timelineTime >= mainTimelineLabels.instagramIntro - 8) warmInstagramGalleryAssets();
                    if (timelineTime >= knobPlayStart - 4 && timelineTime < knobPlayEnd) {
                        if (knobVideo && knobVideo.dataset.mediaLoaded !== 'true') {
                            knobVideo.preload = 'auto';
                            loadDeferredMediaElement(knobVideo);
                        }
                    }
                    const shouldPlayKnob = timelineTime >= knobPlayStart && timelineTime < knobPlayEnd;
                    if (shouldPlayKnob !== knobPlaybackRequested) {
                        knobPlaybackRequested = shouldPlayKnob;
                        if (shouldPlayKnob) safePlayMedia(knobVideo);
                        else pauseMedia(knobVideo);
                    }
                    attachmentVideoWindows.forEach(({ start, end, itemIndex }) => {
                        if (timelineTime < start - 4 || timelineTime >= end) return;
                        const video = attachmentVideos[itemIndex - 1];
                        if (video && video.dataset.mediaLoaded !== 'true') {
                            video.preload = 'auto';
                            loadDeferredMediaElement(video);
                        }
                    });
                    const nextActiveIndex = getActiveAttachmentIndexForTime(timelineTime);
                    if (nextActiveIndex !== activeAttachmentVideoIndex) {
                        activeAttachmentVideoIndex = nextActiveIndex;
                        leftItemList.forEach((item, itemIndex) => {
                            item.setAttribute('aria-pressed', String(itemIndex === activeAttachmentVideoIndex - 1));
                        });
                    }

                    const visibleAttachmentIndices = getVisibleAttachmentIndicesForTime(timelineTime);
                    const nextVideoSetKey = visibleAttachmentIndices.join(",");
                    if (nextVideoSetKey !== activeAttachmentVideoSetKey) {
                        activeAttachmentVideoSetKey = nextVideoSetKey;
                        if (visibleAttachmentIndices.length) {
                            setAttachmentVideosPlayback(visibleAttachmentIndices);
                        } else {
                            pauseAllAttachmentVideos();
                        }
                    }

                    if (activeAttachmentVideoIndex === null && !visibleAttachmentIndices.length) {
                        pauseAllAttachmentVideos();
                        return;
                    }
                };

                mainTl.eventCallback("onUpdate", syncAttachmentVideoPlayback);
                syncAttachmentVideoPlayback();
                cleanupFns.push(() => {
                    pauseMedia(knobVideo);
                    pauseAllAttachmentVideos();
                    leftItemList.forEach((item) => item.setAttribute('aria-pressed', 'false'));
                    activeAttachmentVideoIndex = null;
                    activeAttachmentVideoSetKey = "";
                });

                const getAttachmentCenterFocusTime = (startTime) => {
                    const videoStartTime = Math.max(
                        mainTimelineLabels.attachmentsDetailsIntro,
                        startTime - attachmentVideoOverlapLead
                    );

                    return videoStartTime
                        + attachmentVideoEntryDuration
                        + attachmentVideoCenterBlendDuration;
                };

                const attachmentTargetTimes = timelinePoints.map((startTime) =>
                    getAttachmentCenterFocusTime(startTime)
                );

                const handleAttachmentClick = (event) => {
                    const clickedItem = event.target.closest(".att-left-item");
                    if (!clickedItem || !attLeftPanel?.contains(clickedItem)) return;

                    const index = leftItemList.indexOf(clickedItem);
                    if (index === -1) return;

                    scrollMainTimelineToTime(attachmentTargetTimes[index]);
                };

                attLeftPanel?.addEventListener('click', handleAttachmentClick);
                cleanupFns.push(() => attLeftPanel?.removeEventListener('click', handleAttachmentClick));

                mainTl.set(insOverlays, { display: runtimeProfile.overlay.hiddenDisplay }, 0);
                mainTl.set(insBackground, { zIndex: 18 }, 0);
                mainTl.set(aboutDesignWrapper, { zIndex: 21 }, 0);
                mainTl.set(aboutSustainabilityWrapper, { zIndex: 22 }, 0);
                mainTl.set(insTitleWrapper, { autoAlpha: 0 }, 0);
                mainTl.set(insGallery, { autoAlpha: 0 }, 0);

                if (isNotDesktop) {
                    buildMobileMainTimeline(mainTl, runtimeProfile);
                } else {
                    buildDesktopMainTimeline(mainTl, runtimeProfile);
                }
                mainTl.addLabel('instagramReadEnd', mainTl.labels.instagramHoverReady + runtimeProfile.readingHold);
                mainTl.to({}, { duration: runtimeProfile.readingHold }, 'instagramHoverReady');
                Object.assign(mainTimelineLabels, mainTl.labels);
                mainTl.set(insOverlays, { display: runtimeProfile.overlay.readyDisplay }, "instagramHoverReady");
                addAmbientMotionLayer(mainTl, mainTimelineLabels, runtimeProfile, isNotDesktop);
                addInsideCardSoftFlowLayer(mainTl, mainTimelineLabels, runtimeProfile, isNotDesktop);
                mainTimelineDuration = mainTl.duration();
                syncMainScrollSpace();
                const restoreState = mainTimelineRestoreState;
                mainTimelineRestoreState = null;
                if (restoreState) {
                    mainTimelineRestoring = true;
                    const sharedLabels = Object.keys(restoreState.labels)
                        .filter(label => Number.isFinite(mainTimelineLabels[label]))
                        .sort((a, b) => restoreState.labels[a] - restoreState.labels[b]);
                    const previous = sharedLabels.filter(label => restoreState.labels[label] <= restoreState.time).pop();
                    const next = sharedLabels.find(label => restoreState.labels[label] > restoreState.time);
                    if (previous) {
                        const span = next ? restoreState.labels[next] - restoreState.labels[previous] : 0;
                        const fraction = span > 0 ? (restoreState.time - restoreState.labels[previous]) / span : 0;
                        const restoredTime = mainTimelineLabels[previous] + (next ? fraction * (mainTimelineLabels[next] - mainTimelineLabels[previous]) : 0);
                        requestAnimationFrame(() => {
                            if (homepageRuntimeDestroyed || homepageDocumentRoot.dataset.kmMotion === 'reading' || !mainTl.scrollTrigger) return;
                            ScrollTrigger.refresh();
                            const trigger = mainTl.scrollTrigger;
                            window.scrollTo(0, trigger.start + (trigger.end - trigger.start) * restoredTime / mainTl.duration());
                            mainTl.time(restoredTime);
                            ScrollTrigger.update();
                            mainTimelineRestoring = false;
                            syncAttachmentVideoPlayback();
                        });
                    } else {
                        mainTimelineRestoring = false;
                    }
                }


                let footerAnimationsInitialized = false;

                function initFooterAnimations() {
                    if (footerAnimationsInitialized || !footerSection) return;
                    footerAnimationsInitialized = true;
                    ensureTitleSplit(11);
                    ensureTextSplit(8);
                    const footerConfig = getFooterAnimationProfile(isMobile);
                    const { float: floatConfig, timeline: timelineConfig } = footerConfig;

                    function getRandomNumber(min, max) {
                        return Math.random() * (max - min) + min;
                    }

                    const randomR1 = getRandomNumber(floatConfig.radiusRange[0], floatConfig.radiusRange[1]);
                    const randomR2 = getRandomNumber(floatConfig.radiusRange[0], floatConfig.radiusRange[1]);
                    const circle3Anim = gsap.to(circle3, {
                        duration: floatConfig.circle3Duration,
                        attr: {
                            cx: () => getRandomNumber(floatConfig.cxRange[0], floatConfig.cxRange[1]),
                            cy: () => getRandomNumber(floatConfig.cyRange[0], floatConfig.cyRange[1]),
                            rx: () => randomR1,
                            ry: () => randomR1
                        },
                        ease: "none",
                        repeat: -1,
                        repeatRefresh: true,
                        paused: true
                    });

                    const circle4Anim = gsap.to(circle4, {
                        duration: floatConfig.circle4Duration,
                        attr: {
                            cx: () => getRandomNumber(floatConfig.cxRange[0], floatConfig.cxRange[1]),
                            cy: () => getRandomNumber(floatConfig.cyRange[0], floatConfig.cyRange[1]),
                            rx: () => randomR2,
                            ry: () => randomR2
                        },
                        ease: "none",
                        repeat: -1,
                        repeatRefresh: true,
                        paused: true
                    });

                    const footerTl = gsap.timeline({
                        scrollTrigger: {
                            trigger: footerSection,
                            start: "top 72%",
                            end: "bottom bottom",
                            scrub: interactionProfile.scroll.scrub.footer
                        }
                    });

                    const footerFloatTrigger = ScrollTrigger.create({
                        trigger: footerSection,
                        start: "top bottom",
                        end: "bottom top",
                        onToggle: ({ isActive }) => {
                            if (isActive) {
                                circle3Anim.play();
                                circle4Anim.play();
                            } else {
                                circle3Anim.pause();
                                circle4Anim.pause();
                            }
                        }
                    });

                    footerTl
                        .to(titleSplits[11], {
                            y: "0%",
                            stagger: timelineConfig.title.stagger,
                            duration: timelineConfig.title.duration
                        })
                        .to(textSplits[8], {
                            opacity: 1,
                            y: 0,
                            duration: timelineConfig.text.duration,
                            stagger: timelineConfig.text.stagger
                        }, `<+=${timelineConfig.text.delay}`)
                        .from(footerSubscribeForm, {
                            y: timelineConfig.subscribe.y,
                            opacity: 0,
                            duration: timelineConfig.subscribe.duration
                        }, "<")
                        .to(footerBackground, {
                            opacity: 1,
                            duration: timelineConfig.background.duration,
                        }, "<")
                        .from(footerBottom, {
                            y: timelineConfig.bottom.y,
                            opacity: 0,
                            duration: timelineConfig.bottom.duration
                        }, `<+=${timelineConfig.bottom.delay}`)
                        .from([...footerColumns, ...footerColumnTitles], {
                            y: timelineConfig.columns.y,
                            opacity: 0,
                            duration: timelineConfig.columns.duration,
                            stagger: timelineConfig.columns.stagger
                        }, timelineConfig.columns.offset);

                    if (footerColumns.length > 0) {
                        const footerColumnItems = Array.from(footerColumns, (col) =>
                            Array.from(col.querySelectorAll("li, .footer-social-icons a"))
                        );
                        const maxItems = Math.max(...footerColumnItems.map((items) => items.length));

                        for (let i = 0; i < maxItems; i++) {
                            const itemsAtIndex = footerColumnItems
                                .map((items) => items[i] || null)
                                .filter((item) => item !== null);

                            if (itemsAtIndex.length) {
                                footerTl.from(itemsAtIndex, {
                                    y: timelineConfig.columnItems.y,
                                    opacity: 0,
                                    duration: timelineConfig.columnItems.duration,
                                }, i === 0 ? "<" : `<+=${timelineConfig.columnItems.stepDelay}`);
                            }
                        }
                    }

                    requestScrollRefresh();
                    requestAnimationFrame(() => {
                        footerTl.scrollTrigger?.refresh();
                        footerTl.scrollTrigger?.update();
                        ScrollTrigger.update();
                    });

                    const footerRect = footerSection.getBoundingClientRect();
                    if (footerRect.top < window.innerHeight && footerRect.bottom > 0) {
                        circle3Anim.play();
                        circle4Anim.play();
                    }

                    cleanupFns.push(() => {
                        circle3Anim.pause();
                        circle4Anim.pause();
                        circle3Anim.kill();
                        circle4Anim.kill();
                        footerFloatTrigger.kill();
                        footerTl.kill();
                    });
                }

                initFooterAnimations();

                return () => {
                    cleanupFns.forEach((cleanup) => cleanup());
                };
            });
        }

        let mainTimelineRebuildTimeout = null;
        const scheduleMainTimelineRebuild = () => {
            if (mainTimelineRebuildTimeout) return;
            mainTimelineRebuildTimeout = window.setTimeout(() => {
                mainTimelineRebuildTimeout = null;
                if (Date.now() - homepageLastWheelInputAt < 180) {
                    scheduleMainTimelineRebuild();
                    return;
                }
                mountMainTimelineExperience();
                requestAnimationFrame(() => {
                    requestScrollRefresh();
                    ScrollTrigger.update();
                });
            }, 220);
        };

        const handleInputModeChange = () => {
            if (!featureAnimationsInitialized) return;
            scheduleMainTimelineRebuild();
        };

        window.addEventListener('km:input-mode-change', handleInputModeChange);
        mainTimelineExperienceCleanup = () => {
            if (mainTimelineRebuildTimeout) {
                clearTimeout(mainTimelineRebuildTimeout);
                mainTimelineRebuildTimeout = null;
            }
            window.removeEventListener('km:input-mode-change', handleInputModeChange);
            mainTimelineMediaContext?.revert();
            mainTimelineMediaContext = null;
        };

        mountMainTimelineExperience();
        }).catch((error) => {
            featureAnimationsInitializing = false;
            console.error('Feature animation initialization failed', error);
            enterHomepageReadingMode('feature-error');
        });
    }
}).catch((error) => {
    console.error('Homepage intro setup failed', error);
    enterHomepageReadingMode('intro-error');
});

} catch (error) {
    console.error('Homepage animation setup failed', error);
    enterHomepageReadingMode('setup-error');
}
})();
